<template xmlns="http://www.w3.org/1999/html">
    <div>

        <div class="row">
            <div class="page-header">
                <div class="d-flex align-items-center">
                    <h2 class="page-header-title">
                        <router-link :to="{ name: 'risk-audit-view' }">
                            Risk Assessments </router-link>
                        <span v-if="raAnswer.ra_cover.prepared_for && raAnswer.ra_cover.reference_number">
                        &raquo; {{ raAnswer.ra_cover.reference_number + ' | ' + raAnswer.ra_cover.prepared_for }}
                            </span>
                    </h2>
                </div>
            </div>
        </div>

        <div class="row" v-if="isSubmitted">
            <div class="col-md-12">
                <div class="alert alert-success">
                    The form was submitted successfully!
                </div>
            </div>
        </div>

        <div class="row flex-row">

            <div class="col-md-12 col-lg-2">
                <div class="widget widget-12 has-shadow c-pointer" v-on:click="openTab = 1" v-bind:class="openTab === 1 ? 'bg-primary': ''">
                    <div class="widget-body">
                        <div class="media">
                            <div class="number">Assessment Overview</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-12 col-lg-2">
                <div class="widget widget-12 has-shadow c-pointer" v-on:click="openTab = 2" v-bind:class="openTab === 2 ? 'bg-primary': ''">
                    <div class="widget-body">
                        <div class="media">
                            <div class="number">Management of Fire Safety</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-12 col-lg-2">
                <div class="widget widget-12 has-shadow c-pointer" v-on:click="openTab = 3" v-bind:class="openTab === 3 ? 'bg-primary': ''">
                    <div class="widget-body">
                        <div class="media">
                            <div class="number">Fire Hazards and Dangerous Substances</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-12 col-lg-2">
                <div class="widget widget-12 has-shadow c-pointer" v-on:click="openTab = 4" v-bind:class="openTab === 4 ? 'bg-primary': ''">
                    <div class="widget-body">
                        <div class="media">
                            <div class="number">General Fire Precautions</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-12 col-lg-2">
                <div class="widget widget-12 has-shadow c-pointer" v-on:click="openTab = 5" v-bind:class="openTab === 5 ? 'bg-primary': ''">
                    <div class="widget-body">
                        <div class="media">
                            <div class="number">Photos</div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <form @submit.prevent="submit">
            <div class="form-body" id="audit-app-container">

                <input type="hidden" v-model="raAnswer.site_risk_audit_id">

                <div class="row" v-if="openTab === 1">
                    <div class="col-sm-12 widget-20">
                        <div class="widget has-shadow">
                            <div class="widget-header bordered d-flex align-items-center section-header">
                                <h2>{{getPartTitle(1)}}</h2>
                                <div>
                                    <!--<span class="a-primary c-pointer" v-on:click="openTab = 5" v-bind:class="openTab === 5 ? 'bg-primary': ''">Summary</span>-->
                                </div>
                            </div>
                            <div class="widget-body">

                                <h3><strong>Assessment Details</strong></h3>

                                <div class="em-separator separator-dashed"></div>



                                <div class="form-group row d-flex align-items-center">
                                    <label class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                        Cover Photo
                                    </label>
                                    <div class="col-lg-6 col-md-12">
                                        <div v-for="offlineImage in raAnswer.ra_cover.cover_offline_images" style="margin-bottom: 10px;">
                                            <img v-bind:src="offlineImage.data" class="img-fluid">
                                            <div class="image-actions">
                                                <button v-on:click="rotateCoverPhoto(-90)" :disabled="modifyingPhoto" class="btn btn-primary btn-xs btn-square" title="Rotate Anti-clockwise"><i class="fa fa-undo"></i></button>
                                                <button v-on:click="rotateCoverPhoto(90)" :disabled="modifyingPhoto" class="btn btn-primary btn-xs btn-square" title="Rotate Clockwise"><i class="fa fa-undo fa-flip-horizontal"></i></button>
                                            </div>
                                        </div>
                                        <div v-if="raAnswer.ra_cover.cover_image" style="margin-bottom: 10px;">
                                            <img v-bind:src="this.cmsUrl + raAnswer.ra_cover.cover_image" class="img-fluid">
                                        </div>
                                        <div v-if="isImageUploading" style="background: #eaeaea; padding: 10px; margin: 10px 0;">
                                            <h3><span class="fa fa-spin fa-circle-notch"></span>
                                                Adding image... Please wait...</h3>
                                        </div>
                                        <label class="fileContainer">
                                            <span class="fa fa-camera"></span> Click to add an image
                                            <input type="file" accept="image/*" @change="onFileChange">
                                        </label>
                                    </div>
                                </div>

                                <div class="em-separator separator-dashed"></div>

                                <div class="form-group row d-flex align-items-center">
                                    <label
                                            class="col-lg-12 form-control-label"
                                            for="raAnswer.ra_cover.reference_number">
                                        Reference Number
                                    </label>
                                    <div class="col-lg-12">
                                        <input
                                                type="text"
                                                class="form-control"
                                                maxlength="255"
                                                id="raAnswer.ra_cover.reference_number"
                                                v-model="raAnswer.ra_cover.reference_number"
                                        />
                                    </div>
                                </div>

                                <div class="em-separator separator-dashed"></div>

                                <div v-if="dbName === 'jpfire'">
                                        <div class="form-group row d-flex align-items-center">
                                                <label
                                                        class="col-lg-12 form-control-label"
                                                        for="raAnswer.ra_cover.report_type">
                                                        Report Type
                                                </label>
                                                <div class="col-lg-12">
                                                        <select
                                                                id="raAnswer.ra_cover.report_type"
                                                                class="form-control"
                                                                v-model="raAnswer.ra_cover.report_type"
                                                        >
                                                                <option value="" disabled="disabled">Please select an option</option>
                                                                <option v-bind:value="reportTypeOption.fra_report_type_name" v-for="reportTypeOption in reportTypes" v-bind:key="reportTypeOption.fra_report_type_id">{{ reportTypeOption.fra_report_type_name }}</option>
                                                        </select>
                                                </div>
                                        </div>

                                        <div class="em-separator separator-dashed"></div>
                                </div>

                                <div class="form-group row d-flex align-items-center">
                                    <label
                                            class="col-lg-12 form-control-label"
                                            for="raAnswer.ra_cover.prepared_for">
                                            <span v-if="dbName === 'jpfire'">Client</span>
                                        <span v-else>Prepared for</span>
                                    </label>
                                    <div class="col-lg-12">
                                        <input
                                                type="text"
                                                class="form-control"
                                                maxlength="255"
                                                id="raAnswer.ra_cover.prepared_for"
                                                v-model="raAnswer.ra_cover.prepared_for"
                                        />
                                    </div>
                                </div>

                                <div class="em-separator separator-dashed"></div>

                                <div class="form-group row d-flex align-items-center">
                                    <label
                                            class="col-lg-12 form-control-label"
                                            for="raAnswer.ra_cover.location">
                                            <span v-if="dbName === 'jpfire'">Address of premises inspected</span>
                                        <span v-else>Location</span>
                                    </label>
                                    <div class="col-lg-12">
                                        <textarea
                                                class="form-control"
                                                id="raAnswer.ra_cover.location"
                                                v-model="raAnswer.ra_cover.location"
                                                rows="5"
                                        ></textarea>
                                    </div>
                                </div>

                                <div class="form-group row d-flex align-items-center">
                                    <label
                                            class="col-lg-12 form-control-label"
                                            for="raAnswer.ra_cover.date_of_assessment">
                                        Date of Assessment
                                    </label>
                                    <div class="col-lg-12">
                                        <input
                                                type="text"
                                                class="form-control"
                                                maxlength="255"
                                                id="raAnswer.ra_cover.date_of_assessment"
                                                v-model="raAnswer.ra_cover.date_of_assessment"
                                        />
                                    </div>
                                </div>

                                <div class="em-separator separator-dashed"></div>

                                <div class="form-group row d-flex align-items-center">
                                    <label
                                            class="col-lg-12 form-control-label"
                                            for="raAnswer.ra_cover.assessor_name">
                                        <span v-if="dbName === 'jpfire'">Name of Assessor</span>
                                        <span v-else>Assessor / Consultant Name</span>
                                    </label>
                                    <div class="col-lg-12">
                                        <input
                                                type="text"
                                                class="form-control"
                                                maxlength="255"
                                                id="raAnswer.ra_cover.assessor_name"
                                                v-model="raAnswer.ra_cover.assessor_name"
                                        />
                                    </div>
                                </div>

                                <div class="em-separator separator-dashed"></div>

                                <div class="form-group row d-flex align-items-center">
                                    <label
                                            class="col-lg-12 form-control-label"
                                            for="raAnswer.ra_cover.signed_off_by">
                                        <span v-if="dbName === 'jpfire'">Name of Validator</span>
                                        <span v-else>Signed off by</span>
                                    </label>
                                    <div class="col-lg-12">
                                        <input
                                                type="text"
                                                class="form-control"
                                                maxlength="255"
                                                id="raAnswer.ra_cover.signed_off_by"
                                                v-model="raAnswer.ra_cover.signed_off_by"
                                        />
                                    </div>
                                </div>

                                <div class="em-separator separator-dashed"></div>

                                <div v-if="dbName === 'jpfire'">
                                        <div class="form-group row d-flex align-items-center">
                                                <label
                                                        class="col-lg-12 form-control-label"
                                                        for="raAnswer.ra_cover.sign_off_date">
                                                        Date of Validation
                                                </label>
                                                <div class="col-lg-12">
                                                        <input
                                                                type="text"
                                                                class="form-control"
                                                                maxlength="255"
                                                                id="raAnswer.ra_cover.sign_off_date"
                                                                v-model="raAnswer.ra_cover.sign_off_date"
                                                        />
                                                </div>
                                        </div>

                                        <div class="em-separator separator-dashed"></div>
                                </div>

                                <div class="form-group row d-flex align-items-center">
                                    <label
                                            class="col-lg-12 form-control-label"
                                            for="raAnswer.ra_cover.recommended_review_date">
                                        Recommended review date
                                    </label>
                                    <div class="col-lg-12">
                                        <input
                                                type="text"
                                                class="form-control"
                                                maxlength="255"
                                                id="raAnswer.ra_cover.recommended_review_date"
                                                v-model="raAnswer.ra_cover.recommended_review_date"
                                        />
                                    </div>
                                </div>

                                <div class="em-separator separator-dashed"></div>

                                <div class="form-group row align-items-center" :class="{ 'd-none': dbName === 'jpfire', 'd-flex': dbName !== 'jpfire'  }">
                                        <label class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                                Engineer Signature
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                                <div class="signature-area" v-if="raAnswer.offline_engineer_signature_image != null">
                                                <img v-bind:src="raAnswer.offline_engineer_signature_image.data" class="img-fluid">
                                                </div>
                                                <div class="mb-3" v-else-if="raAnswer.engineer_signature_image != null">
                                                Report signed
                                                </div>
                                                <div class="pt-2">
                                                <div v-if="addingEngineerSignature">
                                                        <div class="signature-area">
                                                        <VueSignaturePad width="100%" height="200px" ref="engineerSignaturePad" />
                                                        </div>
                                                        <div class="row">
                                                        <div class="col-6">
                                                                <a class="btn btn-square btn-lg btn-outline-primary w-100"
                                                                href="javascript:void(0)"
                                                                v-on:click="saveEngineerSignature">Save signature</a>
                                                        </div>
                                                        <div class="col-6">
                                                                <a class="btn btn-square btn-lg btn-outline-danger w-100"
                                                                href="javascript:void(0)"
                                                                v-on:click="clearEngineerSignature">Clear signature</a>
                                                        </div>
                                                        </div>
                                                </div>
                                                <a v-else class="btn btn-square btn-lg btn-outline-primary"
                                                        href="javascript:void(0)"
                                                        v-on:click="addEditEngineerSignature"
                                                ><span v-if="raAnswer.offline_engineer_signature_image != null || raAnswer.engineer_signature_image != null">Replace</span><span v-else>Add</span> signature</a>
                                                </div>
                                        </div>
                                </div>

                                <div class="em-separator separator-dashed" v-if="dbName !== 'jpfire'"></div>

                                <div class="form-group row align-items-center" :class="{ 'd-none': dbName === 'jpfire', 'd-flex': dbName !== 'jpfire'  }">
                                        <label class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                                Client Signature
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                                <div class="signature-area" v-if="raAnswer.offline_client_signature_image != null">
                                                <img v-bind:src="raAnswer.offline_client_signature_image.data" class="img-fluid">
                                                </div>
                                                <div v-else-if="raAnswer.client_signature_image != null">
                                                Report signed
                                                </div>
                                                <div class="pt-2">
                                                <div v-if="addingClientSignature">
                                                        <div class="signature-area">
                                                        <VueSignaturePad width="100%" height="200px" ref="clientSignaturePad" />
                                                        </div>
                                                        <div class="row">
                                                        <div class="col-6">
                                                                <a class="btn btn-square btn-lg btn-outline-primary w-100"
                                                                href="javascript:void(0)"
                                                                v-on:click="saveClientSignature">Save signature</a>
                                                        </div>
                                                        <div class="col-6">
                                                                <a class="btn btn-square btn-lg btn-outline-danger w-100"
                                                                href="javascript:void(0)"
                                                                v-on:click="clearClientSignature">Clear signature</a>
                                                        </div>
                                                        </div>
                                                </div>
                                                <a v-else class="btn btn-square btn-lg btn-outline-primary"
                                                        href="javascript:void(0)"
                                                        v-on:click="addEditClientSignature"
                                                ><span v-if="raAnswer.offline_client_signature_image != null || raAnswer.client_signature_image != null">Replace</span><span v-else>Add</span> signature</a>
                                                </div>
                                        </div>
                                </div>

                                <div class="em-separator separator-dashed" v-if="dbName !== 'jpfire'"></div>

                                <div class="form-group row align-items-center required" :class="{ 'd-none': dbName === 'jpfire', 'd-flex': dbName !== 'jpfire'  }">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('client_signed_by')]"
                                                for="client-name">Client Name</label>
                                        <div class="col-lg-6 col-md-12">
                                                <input
                                                        type="text"
                                                        name="client_signed_by"
                                                        :class="['form-control', getFieldClasses('client_signed_by')]"
                                                        v-model="raAnswer.client_signed_by"
                                                        id="client-name"
                                                        @blur="onFieldBlur('client_signed_by')"
                                                /></div>
                                        <div v-if="isErrorField('client_signed_by')" class="invalid-feedback">This field is required</div>
                                        </div>
                                        
                                        <div class="form-group row d-flex align-items-center">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end']"
                                                for="client-sign-date">
                                                Client Sign Date
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                                <datepicker
                                                        v-model="raAnswer.client_signed_date"
                                                        format="dd/MM/yy"
                                                        input-class="form-control"
                                                        name="client_signed_date"
                                                        id="client-sign-date"
                                                ></datepicker>
                                        </div>
                                </div>

                                <div class="em-separator separator-dashed" v-if="dbName !== 'jpfire'"></div>

                                <h3><strong>{{getSectionTitle(1)}}</strong></h3>

                                <div class="em-separator separator-dashed"></div>

                                <div class="form-group row d-flex align-items-center">
                                    <label
                                            class="col-lg-12 form-control-label"
                                            for="raAnswer.ra_s1_answer.report_text">Report Text</label>
                                    <div class="col-lg-12">
                                        <textarea
                                                v-model="raAnswer.ra_s1_answer.report_text"
                                                id="raAnswer.ra_s1_answer.report_text"
                                                class="form-control"
                                                rows="5"
                                        >
                                        </textarea>
                                    </div>
                                </div>

                                <div class="em-separator separator-dashed"></div>

                                <div class="form-group row d-flex align-items-center">
                                    <div class="col-lg-12">
                                        <div class="row">
                                                <div class="col-lg-1 col-chkbx hide-question-chbx">
                                                        <label class="styled-checkbox">
                                                        <input type="checkbox" v-model="raAnswer.ra_hidden_question.s1q1">
                                                        <span class="checkmark"></span>
                                                        </label>
                                                        <i class="fa fa-eye-slash"></i>
                                                </div>
                                                <label
                                                        class="col-lg-11 form-control-label"
                                                        for="raAnswer.ra_s1_answer.q1">
                                                        {{ getQuestion('s1q1') }}
                                                </label>
                                        </div>
                                    </div>
                                    
                                    <div class="col-lg-1 col-chkbx">
                                        <label class="styled-checkbox">
                                            <input type="checkbox" v-model="raAnswer.ra_s1_yn.q1_add_ap">
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                    <div class="col-lg-11">
                                        <input
                                                type="text"
                                                class="form-control"
                                                maxlength="255"
                                                id="raAnswer.ra_s1_answer.q1"
                                                v-model="raAnswer.ra_s1_answer.q1"
                                        />
                                    </div>
                                </div>
                                <additional-comment
                                        :key="'s1q1_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s1_comment.q1"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s1q1_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s1_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s1_images_to_delete"
                                        v-bind:questionId="1"
                                ></question-photos>

                                <div class="em-separator separator-dashed"></div>

                                <div class="form-group row d-flex align-items-center">
                                    <div class="col-lg-12">
                                        <div class="row">
                                                <div class="col-lg-1 col-chkbx hide-question-chbx">
                                                        <label class="styled-checkbox">
                                                        <input type="checkbox" v-model="raAnswer.ra_hidden_question.s1q2">
                                                        <span class="checkmark"></span>
                                                        </label>
                                                        <i class="fa fa-eye-slash"></i>
                                                </div>
                                                <label
                                                        class="col-lg-11 form-control-label"
                                                        for="raAnswer.ra_s1_answer.q2">
                                                        {{ getQuestion('s1q2') }}
                                                </label>
                                        </div>
                                    </div>    
                                    
                                    <div class="col-lg-1 col-chkbx">
                                        <label class="styled-checkbox">
                                            <input type="checkbox" v-model="raAnswer.ra_s1_yn.q2_add_ap">
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                    <div class="col-lg-11">
                                        <input
                                                type="text"
                                                class="form-control"
                                                maxlength="255"
                                                id="raAnswer.ra_s1_answer.q2"
                                                v-model="raAnswer.ra_s1_answer.q2"
                                        />
                                    </div>
                                </div>
                                <additional-comment
                                        :key="'s1q2_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s1_comment.q2"
                                ></additional-comment>

                                <question-photos  
                                        :key="'s1q2_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s1_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s1_images_to_delete"
                                        v-bind:questionId="2"
                                ></question-photos>

                                <div class="em-separator separator-dashed"></div>

                                <div class="form-group row d-flex align-items-center">
                                    <div class="col-lg-12">
                                        <div class="row">
                                                <div class="col-lg-1 col-chkbx hide-question-chbx">
                                                        <label class="styled-checkbox">
                                                        <input type="checkbox" v-model="raAnswer.ra_hidden_question.s1q3">
                                                        <span class="checkmark"></span>
                                                        </label>
                                                        <i class="fa fa-eye-slash"></i>
                                                </div>
                                                <label
                                                        class="col-lg-11 form-control-label"
                                                        for="raAnswer.ra_s1_answer.q3">
                                                        {{ getQuestion('s1q3') }}
                                                </label>
                                        </div>
                                    </div>    
                                    
                                    <div class="col-lg-1 col-chkbx">
                                        <label class="styled-checkbox">
                                            <input type="checkbox" v-model="raAnswer.ra_s1_yn.q3_add_ap">
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                    <div class="col-lg-11">
                                        <input
                                                type="text"
                                                class="form-control"
                                                maxlength="255"
                                                id="raAnswer.ra_s1_answer.q3"
                                                v-model="raAnswer.ra_s1_answer.q3"
                                        />
                                    </div>
                                </div>
                                <additional-comment
                                        :key="'s1q3_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s1_comment.q3"
                                ></additional-comment>

                                <question-photos  
                                        :key="'s1q3_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s1_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s1_images_to_delete"
                                        v-bind:questionId="3"
                                ></question-photos>

                                <div class="em-separator separator-dashed"></div>
                                
                                <div v-if="dbName === 'jpfire'">
                                        <div class="form-group row d-flex align-items-center">
                                                <div class="col-lg-12">
                                                        <div class="row">
                                                                <div class="col-lg-1 col-chkbx hide-question-chbx">
                                                                        <label class="styled-checkbox">
                                                                        <input type="checkbox" v-model="raAnswer.ra_hidden_question.s1q4">
                                                                        <span class="checkmark"></span>
                                                                        </label>
                                                                        <i class="fa fa-eye-slash"></i>
                                                                </div>
                                                                <label
                                                                        class="col-lg-11 form-control-label"
                                                                        for="raAnswer.ra_s1_answer.q4">
                                                                        {{ getQuestion('s1q4') }}
                                                                </label>
                                                        </div>
                                                </div>    
                                                
                                                <div class="col-lg-1 col-chkbx">
                                                    <label class="styled-checkbox">
                                                        <input type="checkbox" v-model="raAnswer.ra_s1_yn.q4_add_ap">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                                <div class="col-lg-11">
                                                        <input
                                                                type="text"
                                                                class="form-control"
                                                                maxlength="255"
                                                                id="raAnswer.ra_s1_answer.q4"
                                                                v-model="raAnswer.ra_s1_answer.q4"
                                                        />
                                                </div>
                                        </div>
                                        <additional-comment
                                                :key="'s1q4_additional_comment'+componentKey"
                                                v-model="raAnswer.ra_s1_comment.q4"
                                        ></additional-comment>

                                        <question-photos  
                                                :key="'s1q4_photos'+componentKey"
                                                v-bind:sectionImages="raAnswer.ra_s1_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s1_images_to_delete"
                                                v-bind:questionId="4"
                                        ></question-photos>

                                        <div class="em-separator separator-dashed"></div>
                                </div>

                                <h3><strong>{{getSectionTitle(2)}}</strong></h3>

                                <div class="em-separator separator-dashed"></div>

                                <div class="form-group row d-flex align-items-center">
                                    <label
                                            class="col-lg-12 form-control-label"
                                            for="raAnswer.ra_s2_answer.report_text">Report Text</label>
                                    <div class="col-lg-12">
                                        <textarea
                                                v-model="raAnswer.ra_s2_answer.report_text"
                                                id="raAnswer.ra_s2_answer.report_text"
                                                class="form-control"
                                                rows="5"
                                        >
                                        </textarea>
                                    </div>
                                </div>

                                <div class="em-separator separator-dashed"></div>

                                <div class="form-group row d-flex align-items-center">
                                    <div class="col-lg-12">
                                        <div class="row">
                                                <div class="col-lg-1 col-chkbx hide-question-chbx">
                                                        <label class="styled-checkbox">
                                                        <input type="checkbox" v-model="raAnswer.ra_hidden_question.s2q1">
                                                        <span class="checkmark"></span>
                                                        </label>
                                                        <i class="fa fa-eye-slash"></i>
                                                </div>
                                                <label
                                                        class="col-lg-11 form-control-label"
                                                        for="raAnswer.ra_s2_answer.q1">
                                                        {{ getQuestion('s2q1') }}
                                                </label>
                                        </div>
                                    </div>    
                                    
                                    <div class="col-lg-1 col-chkbx">
                                        <label class="styled-checkbox">
                                            <input type="checkbox" v-model="raAnswer.ra_s2_yn.q1_add_ap">
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                    <div class="col-lg-11">
                                        <input
                                            v-model="raAnswer.ra_s2_answer.q1"
                                            v-if="dbName !== 'jpfire'"
                                            id="raAnswer.ra_s2_answer.q1"
                                            class="form-control"
                                            type="number"
                                            min="0"
                                            step="1"
                                        >
                                        <text-dropdown-field
                                                id="raAnswer.ra_s2_answer.q1"
                                                :key="'s2q1_value'+componentKey"
                                                v-model="raAnswer.ra_s2_answer.q1"
                                                v-bind:qid="'s2q1'"
                                                v-if="dbName === 'jpfire'"
                                        ></text-dropdown-field>
                                    </div>
                                </div>
                                <additional-comment
                                        :key="'s2q1_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s2_comment.q1"
                                ></additional-comment>

                                <question-photos  
                                        :key="'s2q1_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s2_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s2_images_to_delete"
                                        v-bind:questionId="1"
                                ></question-photos>

                                <div class="em-separator separator-dashed"></div>

                                <div class="form-group row d-flex align-items-center">
                                    <div class="col-lg-12">
                                        <div class="row">
                                                <div class="col-lg-1 col-chkbx hide-question-chbx">
                                                        <label class="styled-checkbox">
                                                        <input type="checkbox" v-model="raAnswer.ra_hidden_question.s2q2">
                                                        <span class="checkmark"></span>
                                                        </label>
                                                        <i class="fa fa-eye-slash"></i>
                                                </div>
                                                <label
                                                        class="col-lg-11 form-control-label"
                                                        for="raAnswer.ra_s2_answer.q2">
                                                        {{ getQuestion('s2q2') }}
                                                </label>
                                        </div>
                                    </div>    
                                    
                                    <div class="col-lg-1 col-chkbx">
                                        <label class="styled-checkbox">
                                            <input type="checkbox" v-model="raAnswer.ra_s2_yn.q2_add_ap">
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                    <div class="col-lg-11">
                                        <input
                                                v-model="raAnswer.ra_s2_answer.q2"
                                                id="raAnswer.ra_s2_answer.q2"
                                                class="form-control"
                                                type="number"
                                                min="0"
                                                step="1"
                                                v-if="dbName !== 'jpfire'"
                                        >
                                        <text-dropdown-field
                                                id="raAnswer.ra_s2_answer.q2"
                                                :key="'s2q2_value'+componentKey"
                                                v-model="raAnswer.ra_s2_answer.q2"
                                                v-bind:qid="'s2q2'"
                                                v-if="dbName === 'jpfire'"
                                        ></text-dropdown-field>
                                    </div>
                                </div>
                                <additional-comment
                                        :key="'s2q2_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s2_comment.q2"
                                ></additional-comment>

                                <question-photos  
                                        :key="'s2q2_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s2_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s2_images_to_delete"
                                        v-bind:questionId="2"
                                ></question-photos>

                                <div class="em-separator separator-dashed"></div>

                                <div class="form-group row d-flex align-items-center">
                                    <div class="col-lg-12">
                                        <div class="row">
                                                <div class="col-lg-1 col-chkbx hide-question-chbx">
                                                        <label class="styled-checkbox">
                                                        <input type="checkbox" v-model="raAnswer.ra_hidden_question.s2q3">
                                                        <span class="checkmark"></span>
                                                        </label>
                                                        <i class="fa fa-eye-slash"></i>
                                                </div>
                                                <label
                                                        class="col-lg-11 form-control-label"
                                                        for="raAnswer.ra_s2_answer.q3">
                                                        {{ getQuestion('s2q3') }}
                                                </label>
                                        </div>
                                    </div>    
                                    
                                    <div class="col-lg-1 col-chkbx">
                                        <label class="styled-checkbox">
                                            <input type="checkbox" v-model="raAnswer.ra_s2_yn.q3_add_ap">
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                    <div class="col-lg-11">
                                        <input
                                                v-model="raAnswer.ra_s2_answer.q3"
                                                id="raAnswer.ra_s2_answer.q3"
                                                class="form-control"
                                                type="number"
                                                min="0"
                                                step="1"
                                                v-if="dbName !== 'jpfire'"
                                        >
                                        <text-dropdown-field
                                                id="raAnswer.ra_s2_answer.q3"
                                                :key="'s2q3_value'+componentKey"
                                                v-model="raAnswer.ra_s2_answer.q3"
                                                v-bind:qid="'s2q3'"
                                                v-if="dbName === 'jpfire'"
                                        ></text-dropdown-field>
                                    </div>
                                </div>
                                <additional-comment
                                        :key="'s2q3_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s2_comment.q3"
                                ></additional-comment>

                                <question-photos  
                                        :key="'s2q3_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s2_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s2_images_to_delete"
                                        v-bind:questionId="3"
                                ></question-photos>

                                <div class="em-separator separator-dashed"></div>

                                <div class="form-group row d-flex align-items-center">
                                    <div class="col-lg-12">
                                        <div class="row">
                                                <div class="col-lg-1 col-chkbx hide-question-chbx">
                                                        <label class="styled-checkbox">
                                                        <input type="checkbox" v-model="raAnswer.ra_hidden_question.s2q4">
                                                        <span class="checkmark"></span>
                                                        </label>
                                                        <i class="fa fa-eye-slash"></i>
                                                </div>
                                                <label
                                                        class="col-lg-11 form-control-label"
                                                        for="raAnswer.ra_s2_answer.q4">
                                                        {{ getQuestion('s2q4') }}
                                                </label>
                                        </div>
                                    </div>    
                                    
                                    <div class="col-lg-1 col-chkbx">
                                        <label class="styled-checkbox">
                                            <input type="checkbox" v-model="raAnswer.ra_s2_yn.q4_add_ap">
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                    <div class="col-lg-11">
                                        <text-dropdown-field
                                                :key="'s2q4_value'+componentKey"
                                                v-model="raAnswer.ra_s2_answer.q4"
                                                v-bind:qid="'s2q4'"
                                        ></text-dropdown-field>
                                    </div>
                                </div>
                                <additional-comment
                                         :key="'s2q4_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s2_comment.q4"
                                ></additional-comment>

                                <question-photos  
                                        :key="'s2q4_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s2_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s2_images_to_delete"
                                        v-bind:questionId="4"
                                ></question-photos>

                                <yes-no-na-button :key="'s2q5'+componentKey" 
                                        v-model="raAnswer.ra_s2_yn.q5"
                                        v-bind:action_plan.sync = "raAnswer.ra_s2_yn.q5_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s2q5"
                                        v-bind:id="'raAnswer.ra_s2_yn.q5'"
                                        v-bind:question="getQuestion('s2q5')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s2q5_yn'+componentKey"
                                        v-model="raAnswer.ra_s2_answer.q5"
                                        v-if="raAnswer.ra_s2_yn.q5 !== null"
                                        v-bind:qid="'s2q5'"
                                ></yes-no-na-comment>
                                <additional-comment
                                         :key="'s2q5_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s2_comment.q5"
                                ></additional-comment>

                                <question-photos  
                                        :key="'s2q5_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s2_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s2_images_to_delete"
                                        v-bind:questionId="5"
                                ></question-photos>

                                <div class="em-separator separator-dashed"></div>

                                <h3><strong>{{getSectionTitle(3)}}</strong></h3>

                                <yes-no-na-button :key="'s3q1'+componentKey" 
                                        v-model="raAnswer.ra_s3_yn.q1"
                                        v-bind:action_plan.sync = "raAnswer.ra_s3_yn.q1_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s3q1"
                                        v-bind:id="'raAnswer.ra_s3_yn.q1'"
                                        v-bind:question="getQuestion('s3q1')"
                                        v-bind:note="'Please provide date, location of fire, source of ignition and whether the fire service attended.'"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s3q1_yn'+componentKey"
                                        v-model="raAnswer.ra_s3_answer.q1"
                                        v-if="raAnswer.ra_s3_yn.q1 !== null"
                                        v-bind:qid="'s3q1'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s3q1_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s3_comment.q1"
                                ></additional-comment>

                                <question-photos  
                                        :key="'s3q1_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s3_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s3_images_to_delete"
                                        v-bind:questionId="1"
                                ></question-photos>

                                <div class="em-separator separator-dashed"></div>

                                <div v-if="dbName === 'jpfire'">
                                    <div class="form-group row d-flex align-items-center">
                                        <div class="col-lg-12">
                                            <div class="row">
                                                <div class="col-lg-1 col-chkbx hide-question-chbx">
                                                    <label class="styled-checkbox">
                                                    <input type="checkbox" v-model="raAnswer.ra_hidden_question.s3q2">
                                                    <span class="checkmark"></span>
                                                    </label>
                                                    <i class="fa fa-eye-slash"></i>
                                                </div>
                                                <label
                                                    class="col-lg-11 form-control-label"
                                                    for="raAnswer.ra_s1_answer.q4">
                                                    {{ getQuestion('s3q2') }}
                                                </label>
                                            </div>
                                        </div>    
                                        
                                        <div class="col-lg-1 col-chkbx">
                                            <label class="styled-checkbox">
                                                <input type="checkbox" v-model="raAnswer.ra_s3_yn.q2_add_ap">
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                        <div class="col-lg-11">
                                            <text-dropdown-field
                                                    :key="'s3q2_value'+componentKey"
                                                    v-model="raAnswer.ra_s3_answer.q2"
                                                    v-bind:qid="'s3q2'"
                                            ></text-dropdown-field>
                                        </div>
                                    </div>
                                    <additional-comment
                                            :key="'s3q2_additional_comment'+componentKey"
                                            v-model="raAnswer.ra_s3_comment.q2"
                                    ></additional-comment>

                                    <question-photos  
                                            :key="'s3q2_photos'+componentKey"
                                            v-bind:sectionImages="raAnswer.ra_s3_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s3_images_to_delete"
                                            v-bind:questionId="2"
                                    ></question-photos>

                                    <div class="em-separator separator-dashed"></div>
                                </div>

                                <h3><strong>{{getSectionTitle(4)}}</strong></h3>

                                <div class="em-separator separator-dashed"></div>

                                <div class="form-group row d-flex align-items-center">
                                    <label
                                            class="col-lg-12 form-control-label" for="raAnswer.ra_s4_answer.report_text">
                                        Please enter a description of the premises.
                                    </label>
                                    <div class="col-lg-12">
                                        <textarea
                                                v-model="raAnswer.ra_s4_answer.report_text"
                                                id="raAnswer.ra_s4_answer.report_text"
                                                class="form-control"
                                                rows="5"
                                        >
                                        </textarea>
                                    </div>
                                </div>

                                <yes-no-na-button :key="'s4q1'+componentKey" 
                                        v-model="raAnswer.ra_s4_yn.q1"
                                        v-bind:action_plan.sync = "raAnswer.ra_s4_yn.q1_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s4q1"
                                        v-bind:id="'raAnswer.ra_s4_yn.q1'"
                                        v-bind:question="getQuestion('s4q1')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s4q1_yn'+componentKey"
                                        v-model="raAnswer.ra_s4_answer.q1"
                                        v-if="raAnswer.ra_s4_yn.q1 !== null"
                                        v-bind:qid="'s4q1'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s4q1_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s4_comment.q1"
                                ></additional-comment>

                                <question-photos  
                                        :key="'s4q1_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s4_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s4_images_to_delete"
                                        v-bind:questionId="1"
                                ></question-photos>

                                <yes-no-na-button :key="'s4q2'+componentKey" 
                                        v-model="raAnswer.ra_s4_yn.q2"
                                        v-bind:action_plan.sync = "raAnswer.ra_s4_yn.q2_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s4q2"
                                        v-bind:id="'raAnswer.ra_s4_yn.q2'"
                                        v-bind:question="getQuestion('s4q2')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s4q2_yn'+componentKey"
                                        v-model="raAnswer.ra_s4_answer.q2"
                                        v-if="raAnswer.ra_s4_yn.q2 !== null"
                                        v-bind:qid="'s4q2'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s4q2_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s4_comment.q2"
                                ></additional-comment>

                                <question-photos  
                                        :key="'s4q2_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s4_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s4_images_to_delete"
                                        v-bind:questionId="2"
                                ></question-photos>

                                <yes-no-na-button :key="'s4q3'+componentKey" 
                                        v-model="raAnswer.ra_s4_yn.q3"
                                        v-bind:action_plan.sync = "raAnswer.ra_s4_yn.q3_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s4q3"
                                        v-bind:id="'raAnswer.ra_s4_yn.q3'"
                                        v-bind:question="getQuestion('s4q3')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s4q3_yn'+componentKey"
                                        v-model="raAnswer.ra_s4_answer.q3"
                                        v-if="raAnswer.ra_s4_yn.q3 !== null"
                                        v-bind:qid="'s4q3'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s4q3_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s4_comment.q3"
                                ></additional-comment>

                                <question-photos  
                                        :key="'s4q3_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s4_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s4_images_to_delete"
                                        v-bind:questionId="3"
                                ></question-photos>

                                <div class="em-separator separator-dashed"></div>

                                <div class="form-group row d-flex align-items-center">
                                    <div class="col-lg-12">
                                        <div class="row">
                                                <div class="col-lg-1 col-chkbx hide-question-chbx">
                                                        <label class="styled-checkbox">
                                                        <input type="checkbox" v-model="raAnswer.ra_hidden_question.s4q4">
                                                        <span class="checkmark"></span>
                                                        </label>
                                                        <i class="fa fa-eye-slash"></i>
                                                </div>
                                                <label
                                                        class="col-lg-11 form-control-label"
                                                        for="raAnswer.ra_s4_answer.q4">
                                                        {{ getQuestion('s4q4') }}
                                                </label>
                                        </div>
                                    </div>    
                                    <div class="col-lg-1 col-chkbx">
                                        <label class="styled-checkbox">
                                            <input type="checkbox" v-model="raAnswer.ra_s4_yn.q4_add_ap">
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                    <div class="col-lg-11">
                                        <text-dropdown-field
                                                    :key="'s4q4_value'+componentKey"
                                                    v-model="raAnswer.ra_s4_answer.q4"
                                                    v-bind:qid="'s4q4'"
                                        ></text-dropdown-field>
                                    </div>
                                </div>
                                <additional-comment
                                        :key="'s4q4_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s4_comment.q4"
                                ></additional-comment>

                                <question-photos   
                                        :key="'s4q4_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s4_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s4_images_to_delete"
                                        v-bind:questionId="4"
                                ></question-photos>

                                <yes-no-na-button :key="'s4q5'+componentKey" 
                                        v-model="raAnswer.ra_s4_yn.q5"
                                        v-bind:action_plan.sync = "raAnswer.ra_s4_yn.q5_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s4q5"
                                        v-bind:id="'raAnswer.ra_s4_yn.q5'"
                                        v-bind:question="getQuestion('s4q5')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s4q5_yn'+componentKey"
                                        v-model="raAnswer.ra_s4_answer.q5"
                                        v-if="raAnswer.ra_s4_yn.q5 !== null"
                                        v-bind:qid="'s4q5'"
                                ></yes-no-na-comment>
                                <additional-comment :key="'s4q5_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s4_comment.q5"
                                ></additional-comment>

                                <question-photos   
                                        :key="'s4q5_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s4_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s4_images_to_delete"
                                        v-bind:questionId="5"
                                ></question-photos>

                                <yes-no-na-button :key="'s4q6'+componentKey" 
                                        v-model="raAnswer.ra_s4_yn.q6"
                                        v-bind:action_plan.sync = "raAnswer.ra_s4_yn.q6_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s4q6"
                                        v-bind:id="'raAnswer.ra_s4_yn.q6'"
                                        v-bind:question="getQuestion('s4q6')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s4q6_yn'+componentKey"
                                        v-model="raAnswer.ra_s4_answer.q6"
                                        v-if="raAnswer.ra_s4_yn.q6 !== null"
                                        v-bind:qid="'s4q6'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s4q6_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s4_comment.q6"
                                ></additional-comment>

                                <question-photos   
                                        :key="'s4q6_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s4_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s4_images_to_delete"
                                        v-bind:questionId="6"
                                ></question-photos>

                                <div class="form-group row d-flex align-items-center">
                                    <label
                                            class="col-lg-12 form-control-label"
                                            for="raAnswer.ra_s4_answer.q6_report_text">
                                        Multi-occupied buildings Statement
                                    </label>
                                    <div class="col-lg-12">
                                       <textarea
                                               v-model="raAnswer.ra_s4_answer.q6_report_text"
                                               id="raAnswer.ra_s4_answer.q6_report_text"
                                               class="form-control"
                                               rows="5"
                                       >
                                        </textarea>
                                    </div>
                                </div>

                                <div class="em-separator separator-dashed"></div>

                                <div class="form-group row d-flex align-items-center">
                                    <div class="col-lg-12">
                                        <div class="row">
                                                <div class="col-lg-1 col-chkbx hide-question-chbx">
                                                        <label class="styled-checkbox">
                                                        <input type="checkbox" v-model="raAnswer.ra_hidden_question.s4q7">
                                                        <span class="checkmark"></span>
                                                        </label>
                                                        <i class="fa fa-eye-slash"></i>
                                                </div>
                                                <label
                                                        class="col-lg-11 form-control-label"
                                                        for="raAnswer.ra_s4_answer.q7">
                                                        {{ getQuestion('s4q7') }}
                                                </label>
                                        </div>
                                    </div>
                                    
                                    <div class="col-lg-1 col-chkbx">
                                        <label class="styled-checkbox">
                                            <input type="checkbox" v-model="raAnswer.ra_s4_yn.q7_add_ap">
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                    <div class="col-lg-11">
                                        <input
                                                v-model="raAnswer.ra_s4_answer.q7"
                                                id="raAnswer.ra_s4_answer.q7"
                                                class="form-control"
                                                type="number"
                                                min="0"
                                                step="1"
                                        >
                                    </div>
                                </div>
                                <additional-comment
                                        :key="'s4q7_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s4_comment.q7"
                                ></additional-comment>

                                <question-photos   
                                        :key="'s4q7_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s4_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s4_images_to_delete"
                                        v-bind:questionId="7"
                                ></question-photos>

                                <yes-no-na-button :key="'s4q8'+componentKey" 
                                        v-model="raAnswer.ra_s4_yn.q8"
                                        v-bind:action_plan.sync = "raAnswer.ra_s4_yn.q8_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s4q8"
                                        v-bind:id="'raAnswer.ra_s4_yn.q8'"
                                        v-bind:question="getQuestion('s4q8')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s4q8_yn'+componentKey"
                                        v-model="raAnswer.ra_s4_answer.q8"
                                        v-if="raAnswer.ra_s4_yn.q8 !== null"
                                        v-bind:qid="'s4q8'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s4q8_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s4_comment.q8"
                                ></additional-comment>

                                <question-photos   
                                        :key="'s4q8_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s4_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s4_images_to_delete"
                                        v-bind:questionId="8"
                                ></question-photos>

                                <yes-no-na-button :key="'s4q9'+componentKey" 
                                        v-model="raAnswer.ra_s4_yn.q9"
                                        v-bind:action_plan.sync = "raAnswer.ra_s4_yn.q9_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s4q9"
                                        v-bind:id="'raAnswer.ra_s4_yn.q9'"
                                        v-bind:question="getQuestion('s4q9')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s4q9_yn'+componentKey"
                                        v-model="raAnswer.ra_s4_answer.q9"
                                        v-if="raAnswer.ra_s4_yn.q9 !== null"
                                        v-bind:qid="'s4q9'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s4q9_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s4_comment.q9"
                                ></additional-comment>

                                <question-photos   
                                        :key="'s4q9_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s4_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s4_images_to_delete"
                                        v-bind:questionId="9"
                                ></question-photos>

                                <yes-no-na-button :key="'s4q10'+componentKey" 
                                        v-model="raAnswer.ra_s4_yn.q10"
                                        v-bind:action_plan.sync = "raAnswer.ra_s4_yn.q10_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s4q10"
                                        v-bind:id="'raAnswer.ra_s4_yn.q10'"
                                        v-bind:question="getQuestion('s4q10')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s4q10_yn'+componentKey"
                                        v-model="raAnswer.ra_s4_answer.q10"
                                        v-if="raAnswer.ra_s4_yn.q10 !== null"
                                        v-bind:qid="'s4q10'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s4q10_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s4_comment.q10"
                                ></additional-comment>

                                <question-photos   
                                        :key="'s4q10_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s4_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s4_images_to_delete"
                                        v-bind:questionId="10"
                                ></question-photos>

                                <yes-no-na-button :key="'s4q11'+componentKey" 
                                        v-model="raAnswer.ra_s4_yn.q11"
                                        v-bind:action_plan.sync = "raAnswer.ra_s4_yn.q11_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s4q11"
                                        v-bind:id="'raAnswer.ra_s4_yn.q11'"
                                        v-bind:question="getQuestion('s4q11')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s4q11_yn'+componentKey"
                                        v-model="raAnswer.ra_s4_answer.q11"
                                        v-if="raAnswer.ra_s4_yn.q11 !== null"
                                        v-bind:qid="'s4q11'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s4q11_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s4_comment.q11"
                                ></additional-comment>

                                <question-photos   
                                        :key="'s4q11_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s4_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s4_images_to_delete"
                                        v-bind:questionId="11"
                                ></question-photos>

                                <yes-no-na-button :key="'s4q12'+componentKey" 
                                        v-model="raAnswer.ra_s4_yn.q12"
                                        v-bind:action_plan.sync = "raAnswer.ra_s4_yn.q12_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s4q12"
                                        v-bind:id="'raAnswer.ra_s4_yn.q12'"
                                        v-bind:question="getQuestion('s4q12')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s4q12_yn'+componentKey"
                                        v-model="raAnswer.ra_s4_answer.q12"
                                        v-if="raAnswer.ra_s4_yn.q12 !== null"
                                        v-bind:qid="'s4q12'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s4q12_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s4_comment.q12"
                                ></additional-comment>

                                <question-photos   
                                        :key="'s4q12_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s4_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s4_images_to_delete"
                                        v-bind:questionId="12"
                                ></question-photos>

                                <yes-no-na-button :key="'s4q13'+componentKey" 
                                        v-model="raAnswer.ra_s4_yn.q13"
                                        v-bind:action_plan.sync = "raAnswer.ra_s4_yn.q13_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s4q13"
                                        v-bind:id="'raAnswer.ra_s4_yn.q13'"
                                        v-bind:question="getQuestion('s4q13')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s4q13_yn'+componentKey"
                                        v-model="raAnswer.ra_s4_answer.q13"
                                        v-if="raAnswer.ra_s4_yn.q13 !== null"
                                        v-bind:qid="'s4q13'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s4q13_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s4_comment.q13"
                                ></additional-comment>

                                <question-photos   
                                        :key="'s4q13_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s4_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s4_images_to_delete"
                                        v-bind:questionId="13"
                                ></question-photos>

                                <div class="em-separator separator-dashed"></div>

                                <div class="form-group row d-flex align-items-center">
                                    <div class="col-lg-12">
                                        <div class="row">
                                                <div class="col-lg-1 col-chkbx hide-question-chbx">
                                                        <label class="styled-checkbox">
                                                        <input type="checkbox" v-model="raAnswer.ra_hidden_question.s4q14">
                                                        <span class="checkmark"></span>
                                                        </label>
                                                        <i class="fa fa-eye-slash"></i>
                                                </div>
                                                <label
                                                        class="col-lg-11 form-control-label"
                                                        for="raAnswer.ra_s4_answer.number_of_staircases_in_the_property">
                                                        {{ getQuestion('s4q14') }}
                                                </label>
                                        </div>
                                    </div>    
                                    
                                    <div class="col-lg-1 col-chkbx">
                                        <label class="styled-checkbox">
                                            <input type="checkbox" v-model="raAnswer.ra_s4_yn.q14_add_ap">
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                    <div class="col-lg-11">
                                        <text-dropdown-field
                                                    :key="'s4q14_value'+componentKey"
                                                    v-model="raAnswer.ra_s4_answer.q14"
                                                    v-bind:qid="'s4q14'"
                                        ></text-dropdown-field>
                                    </div>
                                </div>
                                <additional-comment
                                        :key="'s4q14_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s4_comment.q14"
                                ></additional-comment>

                                <question-photos   
                                        :key="'s4q14_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s4_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s4_images_to_delete"
                                        v-bind:questionId="14"
                                ></question-photos>

                                <div class="em-separator separator-dashed"></div>

                                <div class="form-group row d-flex align-items-center">
                                    <div class="col-lg-12">
                                        <div class="row">
                                                <div class="col-lg-1 col-chkbx hide-question-chbx">
                                                        <label class="styled-checkbox">
                                                        <input type="checkbox" v-model="raAnswer.ra_hidden_question.s4q15">
                                                        <span class="checkmark"></span>
                                                        </label>
                                                        <i class="fa fa-eye-slash"></i>
                                                </div>
                                                <label
                                                        class="col-lg-11 form-control-label"
                                                        for="raAnswer.ra_s4_answer.number_of_external_fire_escape_staircases">
                                                        {{ getQuestion('s4q15') }}
                                                </label>
                                        </div>
                                    </div>    
                                    
                                    <div class="col-lg-1 col-chkbx">
                                        <label class="styled-checkbox">
                                            <input type="checkbox" v-model="raAnswer.ra_s4_yn.q15_add_ap">
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                    <div class="col-lg-11">
                                        <input
                                                v-model="raAnswer.ra_s4_answer.q15"
                                                id="raAnswer.ra_s4_answer.number_of_external_fire_escape_staircases"
                                                class="form-control"
                                                type="number"
                                                min="0"
                                                step="1"
                                                v-if="dbName !== 'jpfire'"
                                        >
                                        <text-dropdown-field
                                                id="raAnswer.ra_s4_answer.q15"
                                                :key="'s4q15_value'+componentKey"
                                                v-model="raAnswer.ra_s4_answer.q15"
                                                v-bind:qid="'s4q15'"
                                                v-if="dbName === 'jpfire'"
                                        ></text-dropdown-field>
                                    </div>
                                </div>
                                <additional-comment
                                        :key="'s4q15_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s4_comment.q15"
                                ></additional-comment>

                                <question-photos   
                                        :key="'s4q15_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s4_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s4_images_to_delete"
                                        v-bind:questionId="15"
                                ></question-photos>

                                <div class="em-separator separator-dashed"></div>

                                <div class="form-group row d-flex align-items-center">
                                    <div class="col-lg-12">
                                        <div class="row">
                                                <div class="col-lg-1 col-chkbx hide-question-chbx">
                                                        <label class="styled-checkbox">
                                                        <input type="checkbox" v-model="raAnswer.ra_hidden_question.s4q16">
                                                        <span class="checkmark"></span>
                                                        </label>
                                                        <i class="fa fa-eye-slash"></i>
                                                </div>
                                                <label
                                                        class="col-lg-11 form-control-label"
                                                        for="raAnswer.ra_s4_answer.number_of_emergency_exits">
                                                        {{ getQuestion('s4q16') }}
                                                </label>
                                        </div>
                                    </div>    
                                    
                                    <div class="col-lg-1 col-chkbx">
                                        <label class="styled-checkbox">
                                            <input type="checkbox" v-model="raAnswer.ra_s4_yn.q16_add_ap">
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                    <div class="col-lg-11">
                                        <input
                                                v-model="raAnswer.ra_s4_answer.q16"
                                                id="raAnswer.ra_s4_answer.number_of_emergency_exits"
                                                class="form-control"
                                                type="number"
                                                min="0"
                                                step="1"
                                                v-if="dbName !== 'jpfire'"
                                        >
                                        <text-dropdown-field
                                                id="raAnswer.ra_s4_answer.q16"
                                                :key="'s4q16_value'+componentKey"
                                                v-model="raAnswer.ra_s4_answer.q16"
                                                v-bind:qid="'s4q16'"
                                                v-if="dbName === 'jpfire'"
                                        ></text-dropdown-field>
                                    </div>
                                </div>
                                <additional-comment
                                        :key="'s4q16_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s4_comment.q16"
                                ></additional-comment>

                                <question-photos   
                                        :key="'s4q16_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s4_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s4_images_to_delete"
                                        v-bind:questionId="16"
                                ></question-photos>

                                <div class="em-separator separator-dashed"></div>

                                <div class="form-group row d-flex align-items-center">
                                    <div class="col-lg-12">
                                        <div class="row">
                                                <div class="col-lg-1 col-chkbx hide-question-chbx">
                                                        <label class="styled-checkbox">
                                                        <input type="checkbox" v-model="raAnswer.ra_hidden_question.s4q17">
                                                        <span class="checkmark"></span>
                                                        </label>
                                                        <i class="fa fa-eye-slash"></i>
                                                </div>
                                                <label
                                                        class="col-lg-11 form-control-label"
                                                        for="raAnswer.ra_s4_answer.total_number_of_lifts">
                                                        {{ getQuestion('s4q17') }}
                                                </label>
                                        </div>
                                    </div>    
                                    
                                    <div class="col-lg-1 col-chkbx">
                                        <label class="styled-checkbox">
                                            <input type="checkbox" v-model="raAnswer.ra_s4_yn.q17_add_ap">
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                    <div class="col-lg-11">
                                        <input
                                                v-model="raAnswer.ra_s4_answer.q17"
                                                id="raAnswer.ra_s4_answer.total_number_of_lifts"
                                                class="form-control"
                                                type="number"
                                                min="0"
                                                step="1"
                                                v-if="dbName !== 'jpfire'"
                                        >
                                        <text-dropdown-field
                                                id="raAnswer.ra_s4_answer.q17"
                                                :key="'s4q17_value'+componentKey"
                                                v-model="raAnswer.ra_s4_answer.q17"
                                                v-bind:qid="'s4q17'"
                                                v-if="dbName === 'jpfire'"
                                        ></text-dropdown-field>
                                    </div>
                                </div>
                                <additional-comment
                                        :key="'s4q17_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s4_comment.q17"
                                ></additional-comment>

                                <question-photos   
                                        :key="'s4q17_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s4_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s4_images_to_delete"
                                        v-bind:questionId="17"
                                ></question-photos>

                                <div class="em-separator separator-dashed"></div>

                                <div class="form-group row d-flex align-items-center">
                                    <div class="col-lg-12">
                                        <div class="row">
                                                <div class="col-lg-1 col-chkbx hide-question-chbx">
                                                        <label class="styled-checkbox">
                                                        <input type="checkbox" v-model="raAnswer.ra_hidden_question.s4q18">
                                                        <span class="checkmark"></span>
                                                        </label>
                                                        <i class="fa fa-eye-slash"></i>
                                                </div>
                                                <label
                                                        class="col-lg-11 form-control-label"
                                                        for="raAnswer.ra_s4_answer.total_number_of_fireman_lifts">
                                                        {{ getQuestion('s4q18') }}
                                                </label>
                                        </div>
                                    </div>    
                                    
                                    <div class="col-lg-1 col-chkbx">
                                        <label class="styled-checkbox">
                                            <input type="checkbox" v-model="raAnswer.ra_s4_yn.q18_add_ap">
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                    <div class="col-lg-11">
                                        <input
                                                v-model="raAnswer.ra_s4_answer.q18"
                                                id="raAnswer.ra_s4_answer.total_number_of_fireman_lifts"
                                                class="form-control"
                                                type="number"
                                                min="0"
                                                step="1"
                                                v-if="dbName !== 'jpfire'"
                                        >
                                        <text-dropdown-field
                                                id="raAnswer.ra_s4_answer.q18"
                                                :key="'s4q18_value'+componentKey"
                                                v-model="raAnswer.ra_s4_answer.q18"
                                                v-bind:qid="'s4q18'"
                                                v-if="dbName === 'jpfire'"
                                        ></text-dropdown-field>
                                    </div>
                                </div>
                                <additional-comment
                                        :key="'s4q18_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s4_comment.q18"
                                ></additional-comment>

                                <question-photos   
                                        :key="'s4q18_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s4_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s4_images_to_delete"
                                        v-bind:questionId="18"
                                ></question-photos>

                                <yes-no-na-button :key="'s4q19'+componentKey" 
                                        v-model="raAnswer.ra_s4_yn.q19"
                                        v-bind:action_plan.sync = "raAnswer.ra_s4_yn.q19_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s4q19"
                                        v-bind:id="'raAnswer.ra_s4_yn.q19'"
                                        v-bind:question="getQuestion('s4q19')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s4q19_yn'+componentKey"
                                        v-model="raAnswer.ra_s4_answer.q19"
                                        v-if="raAnswer.ra_s4_yn.q19 !== null"
                                        v-bind:qid="'s4q19'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s4q19_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s4_comment.q19"
                                ></additional-comment>

                                <question-photos   
                                        :key="'s4q19_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s4_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s4_images_to_delete"
                                        v-bind:questionId="19"
                                ></question-photos>

                                <yes-no-na-button :key="'s4q20'+componentKey" 
                                        v-model="raAnswer.ra_s4_yn.q20"
                                        v-bind:action_plan.sync = "raAnswer.ra_s4_yn.q20_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s4q20"
                                        v-bind:id="'raAnswer.ra_s4_yn.q20'"
                                        v-bind:question="getQuestion('s4q20')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s4q20_yn'+componentKey"
                                        v-model="raAnswer.ra_s4_answer.q20"
                                        v-if="raAnswer.ra_s4_yn.q20 !== null"
                                        v-bind:qid="'s4q20'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s4q20_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s4_comment.q20"
                                ></additional-comment>

                                <question-photos   
                                        :key="'s4q20_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s4_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s4_images_to_delete"
                                        v-bind:questionId="20"
                                ></question-photos>

                                <yes-no-na-button :key="'s4q21'+componentKey" 
                                        v-model="raAnswer.ra_s4_yn.q21"
                                        v-bind:action_plan.sync = "raAnswer.ra_s4_yn.q21_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s4q21"
                                        v-bind:id="'raAnswer.ra_s4_yn.q21'"
                                        v-bind:question="getQuestion('s4q21')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s4q21_yn'+componentKey"
                                        v-model="raAnswer.ra_s4_answer.q21"
                                        v-if="raAnswer.ra_s4_yn.q21 !== null"
                                        v-bind:qid="'s4q21'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s4q21_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s4_comment.q21"
                                ></additional-comment>

                                <question-photos  
                                        :key="'s4q21_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s4_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s4_images_to_delete"
                                        v-bind:questionId="21"
                                ></question-photos>

                                <yes-no-na-button :key="'s4q22'+componentKey" 
                                        v-model="raAnswer.ra_s4_yn.q22"
                                        v-bind:action_plan.sync = "raAnswer.ra_s4_yn.q22_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s4q22"
                                        v-bind:id="'raAnswer.ra_s4_yn.q22'"
                                        v-bind:question="getQuestion('s4q22')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s4q22_yn'+componentKey"
                                        v-model="raAnswer.ra_s4_answer.q22"
                                        v-if="raAnswer.ra_s4_yn.q22 !== null"
                                        v-bind:qid="'s4q22'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s4q22_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s4_comment.q22"
                                ></additional-comment>

                                <question-photos   
                                        :key="'s4q22_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s4_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s4_images_to_delete"
                                        v-bind:questionId="22"
                                ></question-photos>

                                <yes-no-na-button :key="'s4q23'+componentKey" 
                                        v-model="raAnswer.ra_s4_yn.q23"
                                        v-bind:action_plan.sync = "raAnswer.ra_s4_yn.q23_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s4q23"
                                        v-bind:id="'raAnswer.ra_s4_yn.q23'"
                                        v-bind:question="getQuestion('s4q23')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s4q23_yn'+componentKey"
                                        v-model="raAnswer.ra_s4_answer.q23"
                                        v-if="raAnswer.ra_s4_yn.q23 !== null"
                                        v-bind:qid="'s4q23'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s4q23_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s4_comment.q23"
                                ></additional-comment>

                                <question-photos   
                                        :key="'s4q23_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s4_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s4_images_to_delete"
                                        v-bind:questionId="23"
                                ></question-photos>

                                <yes-no-na-button :key="'s4q24'+componentKey" 
                                        v-model="raAnswer.ra_s4_yn.q24"
                                        v-bind:action_plan.sync = "raAnswer.ra_s4_yn.q24_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s4q24"
                                        v-bind:id="'raAnswer.ra_s4_yn.q24'"
                                        v-bind:question="getQuestion('s4q24')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s4q24_yn'+componentKey"
                                        v-model="raAnswer.ra_s4_answer.q24"
                                        v-if="raAnswer.ra_s4_yn.q24 !== null"
                                        v-bind:qid="'s4q24'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s4q24_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s4_comment.q24"
                                ></additional-comment>

                                <question-photos  
                                        :key="'s4q24_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s4_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s4_images_to_delete"
                                        v-bind:questionId="24"
                                ></question-photos>

                                <yes-no-na-button :key="'s4q25'+componentKey" 
                                        v-model="raAnswer.ra_s4_yn.q25"
                                        v-bind:action_plan.sync = "raAnswer.ra_s4_yn.q25_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s4q25"
                                        v-bind:id="'raAnswer.ra_s4_yn.q25'"
                                        v-bind:question="getQuestion('s4q25')"
                                        v-bind:note="'NB: The main source of oxygen for a fire is the air around us. Identify materials stored on the premises such as chemicals that could provide a fire with extra oxygen. These chemicals should be identified on the container by the manufacturer.'"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s4q25_yn'+componentKey"
                                        v-model="raAnswer.ra_s4_answer.q25"
                                        v-if="raAnswer.ra_s4_yn.q25 !== null"
                                        v-bind:qid="'s4q25'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s4q25_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s4_comment.q25"
                                ></additional-comment>

                                <question-photos   
                                        :key="'s4q25_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s4_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s4_images_to_delete"
                                        v-bind:questionId="25"
                                ></question-photos>

                                <yes-no-na-button :key="'s4q26'+componentKey" 
                                        v-model="raAnswer.ra_s4_yn.q26"
                                        v-bind:action_plan.sync = "raAnswer.ra_s4_yn.q26_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s4q26"
                                        v-bind:id="'raAnswer.ra_s4_yn.q26'"
                                        v-bind:question="getQuestion('s4q26')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s4q26_yn'+componentKey"
                                        v-model="raAnswer.ra_s4_answer.q26"
                                        v-if="raAnswer.ra_s4_yn.q26 !== null"
                                        v-bind:qid="'s4q26'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s4q26_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s4_comment.q26"
                                ></additional-comment>

                                <question-photos   
                                        :key="'s4q26_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s4_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s4_images_to_delete"
                                        v-bind:questionId="26"
                                ></question-photos>

                                <yes-no-na-button :key="'s4q27'+componentKey" 
                                        v-model="raAnswer.ra_s1_yn.q27"
                                        v-bind:action_plan.sync = "raAnswer.ra_s4_yn.q27_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s4q27"
                                        v-bind:id="'raAnswer.ra_s1_yn.27'"
                                        v-bind:question="getQuestion('s4q27')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s4q27_yn'+componentKey"
                                        v-model="raAnswer.ra_s4_answer.q27"
                                        v-if="raAnswer.ra_s1_yn.q27 !== null"
                                        v-bind:qid="'s4q27'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s4q27_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s4_comment.q27"
                                ></additional-comment>

                                <question-photos  
                                        :key="'s4q27_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s4_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s4_images_to_delete"
                                        v-bind:questionId="27"
                                ></question-photos>

                                <div class="em-separator separator-dashed"></div>

                                <h3><strong>{{getSectionTitle(5)}}</strong></h3>

                                <div class="em-separator separator-dashed"></div>

                                <div class="form-group row d-flex align-items-center">
                                    <label
                                            class="col-lg-12 form-control-label"
                                            for="raAnswer.ra_s5_answer.report_text">Report Text</label>
                                    <div class="col-lg-12">
                                        <textarea
                                                v-model="raAnswer.ra_s5_answer.report_text"
                                                id="raAnswer.ra_s5_answer.report_text"
                                                class="form-control"
                                                rows="5"
                                        >
                                        </textarea>
                                    </div>
                                </div>

                                <yes-no-na-button :key="'s5q1'+componentKey" 
                                        v-model="raAnswer.ra_s5_yn.q1"
                                        v-bind:action_plan.sync = "raAnswer.ra_s5_yn.q1_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s5q1"
                                        v-bind:id="'raAnswer.ra_s5_yn.q1'"
                                        v-bind:question="getQuestion('s5q1')"
                                        v-bind:note="'Details of sub buildings'"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s5q1_yn'+componentKey"
                                        v-model="raAnswer.ra_s5_answer.q1"
                                        v-if="raAnswer.ra_s5_yn.q1 !== null"
                                        v-bind:qid="'s5q1'"
                                ></yes-no-na-comment>

                                <question-photos   
                                        :key="'s5q1_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s5_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s5_images_to_delete"
                                        v-bind:questionId="1"
                                ></question-photos>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row" v-if="openTab === 2">
                    <div class="col-sm-12 widget-20">
                        <div class="widget has-shadow">
                            <div class="widget-header bordered d-flex align-items-center section-header">
                                <h2>{{getPartTitle(2)}}</h2>
                                <div>
                                    <!--<span class="a-primary c-pointer" v-on:click="openTab = 5" v-bind:class="openTab === 5 ? 'bg-primary': ''">Summary</span>-->
                                </div>
                            </div>
                            <div class="widget-body">

                                <h3><strong>{{getSectionTitle(6)}}</strong></h3>

                                <div class="em-separator separator-dashed"></div>

                                <div class="form-group row d-flex align-items-center">
                                    <label
                                            class="col-lg-12 form-control-label"
                                            for="raAnswer.ra_s6_answer.report_text">Report Text</label>
                                    <div class="col-lg-12">
                                        <textarea
                                                v-model="raAnswer.ra_s6_answer.report_text"
                                                id="raAnswer.ra_s6_answer.report_text"
                                                class="form-control"
                                                rows="5"
                                        >
                                        </textarea>
                                    </div>
                                </div>

                                <yes-no-na-button :key="'s6q1'+componentKey" 
                                        v-model="raAnswer.ra_s6_yn.q1"
                                        v-bind:action_plan.sync = "raAnswer.ra_s6_yn.q1_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s6q1"
                                        v-bind:id="'raAnswer.ra_s6_yn.q1'"
                                        v-bind:question="getQuestion('s6q1')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s6q1_yn'+componentKey"
                                        v-model="raAnswer.ra_s6_answer.q1"
                                        v-if="raAnswer.ra_s6_yn.q1 !== null"
                                        v-bind:qid="'s6q1'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s6q1_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s6_comment.q1"
                                ></additional-comment>

                                <question-photos    
                                        :key="'s6q1_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s6_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s6_images_to_delete"
                                        v-bind:questionId="1"
                                ></question-photos>

                                <yes-no-na-button :key="'s6q2'+componentKey" 
                                        v-model="raAnswer.ra_s6_yn.q2"
                                        v-bind:action_plan.sync = "raAnswer.ra_s6_yn.q2_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s6q2"
                                        v-bind:id="'raAnswer.ra_s6_yn.q2'"
                                        v-bind:question="getQuestion('s6q2')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s6q2_yn'+componentKey"
                                        v-model="raAnswer.ra_s6_answer.q2"
                                        v-if="raAnswer.ra_s6_yn.q2 !== null"
                                        v-bind:qid="'s6q2'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s6q2_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s6_comment.q2"
                                ></additional-comment>

                                <question-photos     
                                        :key="'s6q2_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s6_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s6_images_to_delete"
                                        v-bind:questionId="2"
                                ></question-photos>

                                <yes-no-na-button :key="'s6q3'+componentKey" 
                                        v-model="raAnswer.ra_s6_yn.q3"
                                        v-bind:action_plan.sync = "raAnswer.ra_s6_yn.q3_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s6q3"
                                        v-bind:id="'raAnswer.ra_s6_yn.q3'"
                                        v-bind:question="getQuestion('s6q3')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s6q3_yn'+componentKey"
                                        v-model="raAnswer.ra_s6_answer.q3"
                                        v-if="raAnswer.ra_s6_yn.q3 !== null"
                                        v-bind:qid="'s6q3'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s6q3_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s6_comment.q3"
                                ></additional-comment>

                                <question-photos     
                                        :key="'s6q3_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s6_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s6_images_to_delete"
                                        v-bind:questionId="3"
                                ></question-photos>

                                <yes-no-na-button :key="'s6q4'+componentKey" 
                                        v-model="raAnswer.ra_s6_yn.q4"
                                        v-bind:action_plan.sync = "raAnswer.ra_s6_yn.q4_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s6q4"
                                        v-bind:id="'raAnswer.ra_s6_yn.q4'"
                                        v-bind:question="getQuestion('s6q4')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s6q4_yn'+componentKey"
                                        v-model="raAnswer.ra_s6_answer.q4"
                                        v-if="raAnswer.ra_s6_yn.q4 !== null"
                                        v-bind:qid="'s6q4'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s6q4_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s6_comment.q4"
                                ></additional-comment>

                                <question-photos     
                                        :key="'s6q4_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s6_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s6_images_to_delete"
                                        v-bind:questionId="4"
                                ></question-photos>

                                <div class="em-separator separator-dashed"></div>

                                <h3><strong>{{getSectionTitle(7)}}</strong></h3>

                                <div class="em-separator separator-dashed"></div>

                                <div class="form-group row d-flex align-items-center">
                                    <label
                                            class="col-lg-12 form-control-label"
                                            for="raAnswer.ra_s7_answer.report_text">Report Text</label>
                                    <div class="col-lg-12">
                                        <textarea
                                                v-model="raAnswer.ra_s7_answer.report_text"
                                                id="raAnswer.ra_s7_answer.report_text"
                                                class="form-control"
                                                rows="5"
                                        >
                                        </textarea>
                                    </div>
                                </div>

                                <yes-no-na-button :key="'s7q1'+componentKey" 
                                        v-model="raAnswer.ra_s7_yn.q1"
                                        v-bind:action_plan.sync = "raAnswer.ra_s7_yn.q1_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s7q1"
                                        v-bind:id="'raAnswer.ra_s7_yn.q1'"
                                        v-bind:question="getQuestion('s7q1')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s7q1_yn'+componentKey"
                                        v-model="raAnswer.ra_s7_answer.q1"
                                        v-if="raAnswer.ra_s7_yn.q1 !== null"
                                        v-bind:qid="'s7q1'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s7q1_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s7_comment.q1"
                                ></additional-comment>

                                <question-photos     
                                        :key="'s7q1_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s7_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s7_images_to_delete"
                                        v-bind:questionId="1"
                                ></question-photos>

                                <yes-no-na-button :key="'s7q2'+componentKey" 
                                        v-model="raAnswer.ra_s7_yn.q2"
                                        v-bind:action_plan.sync = "raAnswer.ra_s7_yn.q2_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s7q2"
                                        v-bind:id="'raAnswer.ra_s7_yn.q2'"
                                        v-bind:question="getQuestion('s7q2')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s7q2_yn'+componentKey"
                                        v-model="raAnswer.ra_s7_answer.q2"
                                        v-if="raAnswer.ra_s7_yn.q2 !== null"
                                        v-bind:qid="'s7q2'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s7q2_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s7_comment.q2"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s7q2_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s7_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s7_images_to_delete"
                                        v-bind:questionId="2"
                                ></question-photos>

                                <yes-no-na-button :key="'s7q3'+componentKey" 
                                        v-model="raAnswer.ra_s7_yn.q3"
                                        v-bind:action_plan.sync = "raAnswer.ra_s7_yn.q3_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s7q3"
                                        v-bind:id="'raAnswer.ra_s7_yn.q3'"
                                        v-bind:question="getQuestion('s7q3')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s7q3_yn'+componentKey"
                                        v-model="raAnswer.ra_s7_answer.q3"
                                        v-if="raAnswer.ra_s7_yn.q3 !== null"
                                        v-bind:qid="'s7q3'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s7q3_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s7_comment.q3"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s7q3_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s7_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s7_images_to_delete"
                                        v-bind:questionId="3"
                                ></question-photos>

                                <yes-no-na-button :key="'s7q4'+componentKey" 
                                        v-model="raAnswer.ra_s7_yn.q4"
                                        v-bind:action_plan.sync = "raAnswer.ra_s7_yn.q4_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s7q4"
                                        v-bind:id="'raAnswer.ra_s7_yn.q4'"
                                        v-bind:question="getQuestion('s7q4')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s7q4_yn'+componentKey"
                                        v-model="raAnswer.ra_s7_answer.q4"
                                        v-if="raAnswer.ra_s7_yn.q4 !== null"
                                        v-bind:qid="'s7q4'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s7q4_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s7_comment.q4"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s7q4_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s7_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s7_images_to_delete"
                                        v-bind:questionId="4"
                                ></question-photos>

                                <yes-no-na-button :key="'s7q5'+componentKey" 
                                        v-model="raAnswer.ra_s7_yn.q5"
                                        v-bind:action_plan.sync = "raAnswer.ra_s7_yn.q5_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s7q5"
                                        v-bind:id="'raAnswer.ra_s7_yn.q5'"
                                        v-bind:question="getQuestion('s7q5')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s7q5_yn'+componentKey"
                                        v-model="raAnswer.ra_s7_answer.q5"
                                        v-if="raAnswer.ra_s7_yn.q5 !== null"
                                        v-bind:qid="'s7q5'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s7q5_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s7_comment.q5"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s7q5_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s7_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s7_images_to_delete"
                                        v-bind:questionId="5"
                                ></question-photos>

                                <yes-no-na-button :key="'s7q6'+componentKey" 
                                        v-model="raAnswer.ra_s7_yn.q6"
                                        v-bind:action_plan.sync = "raAnswer.ra_s7_yn.q6_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s7q6"
                                        v-bind:id="'raAnswer.ra_s7_yn.q6'"
                                        v-bind:question="getQuestion('s7q6')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s7q6_yn'+componentKey"
                                        v-model="raAnswer.ra_s7_answer.q6"
                                        v-if="raAnswer.ra_s7_yn.q6 !== null"
                                        v-bind:qid="'s7q6'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s7q6_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s7_comment.q6"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s7q6_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s7_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s7_images_to_delete"
                                        v-bind:questionId="6"
                                ></question-photos>

                                <yes-no-na-button :key="'s7q7'+componentKey" 
                                        v-model="raAnswer.ra_s7_yn.q7"
                                        v-bind:action_plan.sync = "raAnswer.ra_s7_yn.q7_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s7q7"
                                        v-bind:id="'raAnswer.ra_s7_yn.q7'"
                                        v-bind:question="getQuestion('s7q7')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s7q7_yn'+componentKey"
                                        v-model="raAnswer.ra_s7_answer.q7"
                                        v-if="raAnswer.ra_s7_yn.q7 !== null"
                                        v-bind:qid="'s7q7'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s7q7_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s7_comment.q7"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s7q7_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s7_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s7_images_to_delete"
                                        v-bind:questionId="7"
                                ></question-photos>

                                <yes-no-na-button :key="'s7q8'+componentKey" 
                                        v-model="raAnswer.ra_s7_yn.q8"
                                        v-bind:action_plan.sync = "raAnswer.ra_s7_yn.q8_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s7q8"
                                        v-bind:id="'raAnswer.ra_s7_yn.q8'"
                                        v-bind:question="getQuestion('s7q8')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s7q8_yn'+componentKey"
                                        v-model="raAnswer.ra_s7_answer.q8"
                                        v-if="raAnswer.ra_s7_yn.q8 !== null"
                                        v-bind:qid="'s7q8'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s7q8_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s7_comment.q8"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s7q8_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s7_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s7_images_to_delete"
                                        v-bind:questionId="8"
                                ></question-photos>

                                <yes-no-na-button :key="'s7q9'+componentKey" 
                                        v-model="raAnswer.ra_s7_yn.q9"
                                        v-bind:action_plan.sync = "raAnswer.ra_s7_yn.q9_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s7q9"
                                        v-bind:id="'raAnswer.ra_s7_yn.q9'"
                                        v-bind:question="getQuestion('s7q9')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s7q9_yn'+componentKey"
                                        v-model="raAnswer.ra_s7_answer.q9"
                                        v-if="raAnswer.ra_s7_yn.q9 !== null"
                                        v-bind:qid="'s7q9'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s7q9_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s7_comment.q9"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s7q9_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s7_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s7_images_to_delete"
                                        v-bind:questionId="9"
                                ></question-photos>

                                <div class="em-separator separator-dashed"></div>

                                <h3><strong>{{getSectionTitle(8)}}</strong></h3>

                                <div class="em-separator separator-dashed"></div>

                                <div class="form-group row d-flex align-items-center">
                                    <label
                                            class="col-lg-12 form-control-label"
                                            for="raAnswer.ra_s8_answer.report_text">Report Text</label>
                                    <div class="col-lg-12">
                                        <textarea
                                                v-model="raAnswer.ra_s8_answer.report_text"
                                                id="raAnswer.ra_s8_answer.report_text"
                                                class="form-control"
                                                rows="5"
                                        >
                                        </textarea>
                                    </div>
                                </div>

                                <yes-no-na-button :key="'s8q1'+componentKey" 
                                        v-model="raAnswer.ra_s8_yn.q1"
                                        v-bind:action_plan.sync = "raAnswer.ra_s8_yn.q1_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s8q1"
                                        v-bind:id="'raAnswer.ra_s8_yn.q1'"
                                        v-bind:question="getQuestion('s8q1')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s8q1_yn'+componentKey"
                                        v-model="raAnswer.ra_s8_answer.q1"
                                        v-if="raAnswer.ra_s8_yn.q1 !== null"
                                        v-bind:qid="'s8q1'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s8q1_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s8_comment.q1"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s8q1_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s8_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s8_images_to_delete"
                                        v-bind:questionId="1"
                                ></question-photos>

                                <yes-no-na-button :key="'s8q2'+componentKey" 
                                        v-model="raAnswer.ra_s8_yn.q2"
                                        v-bind:action_plan.sync = "raAnswer.ra_s8_yn.q2_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s8q2"
                                        v-bind:id="'raAnswer.ra_s8_yn.q2'"
                                        v-bind:question="getQuestion('s8q2')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s8q2_yn'+componentKey"
                                        v-model="raAnswer.ra_s8_answer.q2"
                                        v-if="raAnswer.ra_s8_yn.q2 !== null"
                                        v-bind:qid="'s8q2'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s8q2_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s8_comment.q2"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s8q2_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s8_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s8_images_to_delete"
                                        v-bind:questionId="2"
                                ></question-photos>

                                <yes-no-na-button :key="'s8q3'+componentKey" 
                                        v-model="raAnswer.ra_s8_yn.q3"
                                        v-bind:action_plan.sync = "raAnswer.ra_s8_yn.q3_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s8q3"
                                        v-bind:id="'raAnswer.ra_s8_yn.q3'"
                                        v-bind:question="getQuestion('s8q3')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s8q3_yn'+componentKey"
                                        v-model="raAnswer.ra_s8_answer.q3"
                                        v-if="raAnswer.ra_s8_yn.q3 !== null"
                                        v-bind:qid="'s8q3'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s8q3_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s8_comment.q3"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s8q3_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s8_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s8_images_to_delete"
                                        v-bind:questionId="3"
                                ></question-photos>

                                <yes-no-na-button :key="'s8q4'+componentKey" 
                                        v-model="raAnswer.ra_s8_yn.q4"
                                        v-bind:action_plan.sync = "raAnswer.ra_s8_yn.q4_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s8q4"
                                        v-bind:id="'raAnswer.ra_s8_yn.q4'"
                                        v-bind:question="getQuestion('s8q4')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s8q4_yn'+componentKey"
                                        v-model="raAnswer.ra_s8_answer.q4"
                                        v-if="raAnswer.ra_s8_yn.q4 !== null"
                                        v-bind:qid="'s8q4'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s8q4_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s8_comment.q4"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s8q4_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s8_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s8_images_to_delete"
                                        v-bind:questionId="4"
                                ></question-photos>

                                <yes-no-na-button :key="'s8q5'+componentKey" 
                                        v-model="raAnswer.ra_s8_yn.q5"
                                        v-bind:action_plan.sync = "raAnswer.ra_s8_yn.q5_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s8q5"
                                        v-bind:id="'raAnswer.ra_s8_yn.q5'"
                                        v-bind:question="getQuestion('s8q5')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s8q5_yn'+componentKey"
                                        v-model="raAnswer.ra_s8_answer.q5"
                                        v-if="raAnswer.ra_s8_yn.q5 !== null"
                                        v-bind:qid="'s8q5'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s8q5_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s8_comment.q5"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s8q5_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s8_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s8_images_to_delete"
                                        v-bind:questionId="5"
                                ></question-photos>

                                <yes-no-na-button :key="'s8q6'+componentKey" 
                                        v-model="raAnswer.ra_s8_yn.q6"
                                        v-bind:action_plan.sync = "raAnswer.ra_s8_yn.q6_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s8q6"
                                        v-bind:id="'raAnswer.ra_s8_yn.q6'"
                                        v-bind:question="getQuestion('s8q6')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s8q6_yn'+componentKey"
                                        v-model="raAnswer.ra_s8_answer.q6"
                                        v-if="raAnswer.ra_s8_yn.q6 !== null"
                                        v-bind:qid="'s8q6'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s8q6_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s8_comment.q6"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s8q6_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s8_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s8_images_to_delete"
                                        v-bind:questionId="6"
                                ></question-photos>

                                <yes-no-na-button :key="'s8q7'+componentKey" 
                                        v-model="raAnswer.ra_s8_yn.q7"
                                        v-bind:action_plan.sync = "raAnswer.ra_s8_yn.q7_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s8q7"
                                        v-bind:id="'raAnswer.ra_s8_yn.q7'"
                                        v-bind:question="getQuestion('s8q7')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s8q7_yn'+componentKey"
                                        v-model="raAnswer.ra_s8_answer.q7"
                                        v-if="raAnswer.ra_s8_yn.q7 !== null"
                                        v-bind:qid="'s8q7'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s8q7_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s8_comment.q7"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s8q7_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s8_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s8_images_to_delete"
                                        v-bind:questionId="7"
                                ></question-photos>

                                <div class="em-separator separator-dashed"></div>

                                <h3><strong>{{getSectionTitle(9)}}</strong></h3>

                                <div class="em-separator separator-dashed"></div>

                                <div class="form-group row d-flex align-items-center">
                                    <label
                                            class="col-lg-12 form-control-label"
                                            for="raAnswer.ra_s9_answer.report_text">Report Text</label>
                                    <div class="col-lg-12">
                                        <textarea
                                                v-model="raAnswer.ra_s9_answer.report_text"
                                                id="raAnswer.ra_s9_answer.report_text"
                                                class="form-control"
                                                rows="5"
                                        >
                                        </textarea>
                                    </div>
                                </div>

                                <yes-no-na-button :key="'s9q1'+componentKey" 
                                        v-model="raAnswer.ra_s9_yn.q1"
                                        v-bind:action_plan.sync = "raAnswer.ra_s9_yn.q1_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s9q1"
                                        v-bind:id="'raAnswer.ra_s9_yn.q1'"
                                        v-bind:question="getQuestion('s9q1')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s9q1_yn'+componentKey"
                                        v-model="raAnswer.ra_s9_answer.q1"
                                        v-if="raAnswer.ra_s9_yn.q1 !== null"
                                        v-bind:qid="'s9q1'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s9q1_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s9_comment.q1"
                                ></additional-comment>

                                <question-photos
                                        :key="'s9q1_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s9_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s9_images_to_delete"
                                        v-bind:questionId="1"
                                ></question-photos>

                                <yes-no-na-button :key="'s9q2'+componentKey" 
                                        v-model="raAnswer.ra_s9_yn.q2"
                                        v-bind:action_plan.sync = "raAnswer.ra_s9_yn.q2_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s9q2"
                                        v-bind:id="'raAnswer.ra_s9_yn.q2'"
                                        v-bind:question="getQuestion('s9q2')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s9q2_yn'+componentKey"
                                        v-model="raAnswer.ra_s9_answer.q2"
                                        v-if="raAnswer.ra_s9_yn.q2 !== null"
                                        v-bind:qid="'s9q2'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s9q2_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s9_comment.q2"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s9q2_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s9_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s9_images_to_delete"
                                        v-bind:questionId="2"
                                ></question-photos>

                                <yes-no-na-button :key="'s9q3'+componentKey" 
                                        v-model="raAnswer.ra_s9_yn.q3"
                                        v-bind:action_plan.sync = "raAnswer.ra_s9_yn.q3_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s9q3"
                                        v-bind:id="'raAnswer.ra_s9_yn.q3'"
                                        v-bind:question="getQuestion('s9q3')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s9q3_yn'+componentKey"
                                        v-model="raAnswer.ra_s9_answer.q3"
                                        v-if="raAnswer.ra_s9_yn.q3 !== null"
                                        v-bind:qid="'s9q3'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s9q3_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s9_comment.q3"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s9q3_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s9_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s9_images_to_delete"
                                        v-bind:questionId="3"
                                ></question-photos>

                            </div>
                        </div>
                    </div>
                </div>

                <div class="row" v-if="openTab === 3">
                    <div class="col-sm-12 widget-20">
                        <div class="widget has-shadow">
                            <div class="widget-header bordered d-flex align-items-center section-header">
                                <h2>{{getPartTitle(3)}}</h2>
                                <div>
                                    <!--<span class="a-primary c-pointer" v-on:click="openTab = 5" v-bind:class="openTab === 5 ? 'bg-primary': ''">Summary</span>-->
                                </div>
                            </div>
                            <div class="widget-body">

                                <h3><strong>{{getSectionTitle(10)}}</strong></h3>

                                <div class="em-separator separator-dashed"></div>

                                <div class="form-group row d-flex align-items-center">
                                    <label
                                            class="col-lg-12 form-control-label"
                                            for="raAnswer.ra_s10_answer.report_text">Report Text</label>
                                    <div class="col-lg-12">
                                        <textarea
                                                v-model="raAnswer.ra_s10_answer.report_text"
                                                id="raAnswer.ra_s10_answer.p3s10_report_text"
                                                class="form-control"
                                                rows="5"
                                        >
                                        </textarea>
                                    </div>
                                </div>

                                <div class="em-separator separator-dashed"></div>

                                <h4><strong>Electrical</strong></h4>

                                <yes-no-na-button :key="'s10q1'+componentKey" 
                                        v-model="raAnswer.ra_s10_yn.q1"
                                        v-bind:action_plan.sync = "raAnswer.ra_s10_yn.q1_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s10q1"
                                        v-bind:id="'raAnswer.ra_s10_yn.q1'"
                                        v-bind:question="getQuestion('s10q1')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s10q1_yn'+componentKey"
                                        v-model="raAnswer.ra_s10_answer.q1"
                                        v-if="raAnswer.ra_s10_yn.q1 !== null"
                                        v-bind:qid="'s10q1'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s10q1_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s10_comment.q1"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s10q1_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s10_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s10_images_to_delete"
                                        v-bind:questionId="1"
                                ></question-photos>

                                <yes-no-na-button :key="'s10q2'+componentKey" 
                                        v-model="raAnswer.ra_s10_yn.q2"
                                        v-bind:action_plan.sync = "raAnswer.ra_s10_yn.q2_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s10q2"
                                        v-bind:id="'raAnswer.ra_s10_yn.q2'"
                                        v-bind:question="getQuestion('s10q2')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s10q2_yn'+componentKey"
                                        v-model="raAnswer.ra_s10_answer.q2"
                                        v-if="raAnswer.ra_s10_yn.q2 !== null"
                                        v-bind:qid="'s10q2'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s10q2_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s10_comment.q2"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s10q2_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s10_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s10_images_to_delete"
                                        v-bind:questionId="2"
                                ></question-photos>

                                <yes-no-na-button :key="'s10q3'+componentKey" 
                                        v-model="raAnswer.ra_s10_yn.q3"
                                        v-bind:action_plan.sync = "raAnswer.ra_s10_yn.q3_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s10q3"
                                        v-bind:id="'raAnswer.ra_s10_yn.q3'"
                                        v-bind:question="getQuestion('s10q3')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s10q3_yn'+componentKey"
                                        v-model="raAnswer.ra_s10_answer.q3"
                                        v-if="raAnswer.ra_s10_yn.q3 !== null"
                                        v-bind:qid="'s10q3'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s10q3_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s10_comment.q3"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s10q3_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s10_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s10_images_to_delete"
                                        v-bind:questionId="3"
                                ></question-photos>

                                <yes-no-na-button :key="'s10q4'+componentKey" 
                                        v-model="raAnswer.ra_s10_yn.q4"
                                        v-bind:action_plan.sync = "raAnswer.ra_s10_yn.q4_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s10q4"
                                        v-bind:id="'raAnswer.ra_s10_yn.q4'"
                                        v-bind:question="getQuestion('s10q4')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s10q4_yn'+componentKey"
                                        v-model="raAnswer.ra_s10_answer.q4"
                                        v-if="raAnswer.ra_s10_yn.q4 !== null"
                                        v-bind:qid="'s10q4'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s10q4_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s10_comment.q4"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s10q4_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s10_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s10_images_to_delete"
                                        v-bind:questionId="4"
                                ></question-photos>

                                <yes-no-na-button :key="'s10q5'+componentKey" 
                                        v-model="raAnswer.ra_s10_yn.q5"
                                        v-bind:action_plan.sync = "raAnswer.ra_s10_yn.q5_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s10q5"
                                        v-bind:id="'raAnswer.ra_s10_yn.q5'"
                                        v-bind:question="getQuestion('s10q5')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s10q5_yn'+componentKey"
                                        v-model="raAnswer.ra_s10_answer.q5"
                                        v-if="raAnswer.ra_s10_yn.q5 !== null"
                                        v-bind:qid="'s10q5'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s10q5_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s10_comment.q5"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s10q5_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s10_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s10_images_to_delete"
                                        v-bind:questionId="5"
                                ></question-photos>

                                <yes-no-na-button :key="'s10q6'+componentKey" 
                                        v-model="raAnswer.ra_s10_yn.q6"
                                        v-bind:action_plan.sync = "raAnswer.ra_s10_yn.q6_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s10q6"
                                        v-bind:id="'raAnswer.ra_s10_yn.q6'"
                                        v-bind:question="getQuestion('s10q6')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s10q6_yn'+componentKey"
                                        v-model="raAnswer.ra_s10_answer.q6"
                                        v-if="raAnswer.ra_s10_yn.q6 !== null"
                                        v-bind:qid="'s10q6'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s10q6_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s10_comment.q6"
                                ></additional-comment>

                                <question-photos
                                        :key="'s10q6_photos'+componentKey"  
                                        v-bind:sectionImages="raAnswer.ra_s10_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s10_images_to_delete"
                                        v-bind:questionId="6"
                                ></question-photos>

                                <yes-no-na-button :key="'s10q7'+componentKey" 
                                        v-model="raAnswer.ra_s10_yn.q7"
                                        v-bind:action_plan.sync = "raAnswer.ra_s10_yn.q7_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s10q7"
                                        v-bind:id="'raAnswer.ra_s10_yn.q7'"
                                        v-bind:question="getQuestion('s10q7')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s10q7_yn'+componentKey"
                                        v-model="raAnswer.ra_s10_answer.q7"
                                        v-if="raAnswer.ra_s10_yn.q7 !== null"
                                        v-bind:qid="'s10q7'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s10q7_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s10_comment.q7"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s10q7_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s10_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s10_images_to_delete"
                                        v-bind:questionId="7"
                                ></question-photos>

                                <div class="em-separator separator-dashed"></div>

                                <h4><strong>Kitchen Equipment, Cooking and Welfare Facilities.</strong></h4>

                                <div class="em-separator separator-dashed"></div>

                                <div class="form-group row d-flex align-items-center">
                                    <label
                                            class="col-lg-12 form-control-label"
                                            for="raAnswer.ra_s10_answer.s10_second_report_text">Report Text</label>
                                    <div class="col-lg-12">
                                        <textarea
                                                v-model="raAnswer.ra_s10_answer.s10_second_report_text"
                                                id="raAnswer.ra_s10_answer.s10_second_report_text"
                                                class="form-control"
                                                rows="5"
                                        >
                                        </textarea>
                                    </div>
                                </div>

                                <yes-no-na-button :key="'s10q8'+componentKey" 
                                        v-model="raAnswer.ra_s10_yn.q8"
                                        v-bind:action_plan.sync = "raAnswer.ra_s10_yn.q8_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s10q8"
                                        v-bind:id="'raAnswer.ra_s10_yn.q8'"
                                        v-bind:question="getQuestion('s10q8')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s10q8_yn'+componentKey"
                                        v-model="raAnswer.ra_s10_answer.q8"
                                        v-if="raAnswer.ra_s10_yn.q8 !== null"
                                        v-bind:qid="'s10q8'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s10q8_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s10_comment.q8"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s10q8_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s10_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s10_images_to_delete"
                                        v-bind:questionId="8"
                                ></question-photos>

                                <yes-no-na-button :key="'s10q9'+componentKey" 
                                        v-model="raAnswer.ra_s10_yn.q9"
                                        v-bind:action_plan.sync = "raAnswer.ra_s10_yn.q9_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s10q9"
                                        v-bind:id="'raAnswer.ra_s10_yn.q9'"
                                        v-bind:question="getQuestion('s10q9')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s10q9_yn'+componentKey"
                                        v-model="raAnswer.ra_s10_answer.q9"
                                        v-if="raAnswer.ra_s10_yn.q9 !== null"
                                        v-bind:qid="'s10q9'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s10q9_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s10_comment.q9"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s10q9_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s10_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s10_images_to_delete"
                                        v-bind:questionId="9"
                                ></question-photos>

                                <yes-no-na-button :key="'s10q10'+componentKey" 
                                        v-model="raAnswer.ra_s10_yn.q10"
                                        v-bind:action_plan.sync = "raAnswer.ra_s10_yn.q10_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s10q10"
                                        v-bind:id="'raAnswer.ra_s10_yn.q10'"
                                        v-bind:question="getQuestion('s10q10')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s10q10_yn'+componentKey"
                                        v-model="raAnswer.ra_s10_answer.q10"
                                        v-if="raAnswer.ra_s10_yn.q10 !== null"
                                        v-bind:qid="'s10q10'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s10q10_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s10_comment.q10"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s10q10_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s10_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s10_images_to_delete"
                                        v-bind:questionId="10"
                                ></question-photos>

                                <div class="em-separator separator-dashed"></div>

                                <h4><strong>Hot Work Processes</strong></h4>

                                <yes-no-na-button :key="'s10q11'+componentKey" 
                                        v-model="raAnswer.ra_s10_yn.q11"
                                        v-bind:action_plan.sync = "raAnswer.ra_s10_yn.q11_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s10q11"
                                        v-bind:id="'raAnswer.ra_s10_yn.q11'"
                                        v-bind:question="getQuestion('s10q11')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s10q11_yn'+componentKey"
                                        v-model="raAnswer.ra_s10_answer.q11"
                                        v-if="raAnswer.ra_s10_yn.q11 !== null"
                                        v-bind:qid="'s10q11'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s10q11_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s10_comment.q11"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s10q11_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s10_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s10_images_to_delete"
                                        v-bind:questionId="11"
                                ></question-photos>

                                <yes-no-na-button :key="'s10q12'+componentKey" 
                                        v-model="raAnswer.ra_s10_yn.q12"
                                        v-bind:action_plan.sync = "raAnswer.ra_s10_yn.q12_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s10q12"
                                        v-bind:id="'raAnswer.ra_s10_yn.q12'"
                                        v-bind:question="getQuestion('s10q12')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s10q12_yn'+componentKey"
                                        v-model="raAnswer.ra_s10_answer.q12"
                                        v-if="raAnswer.ra_s10_yn.q12 !== null"
                                        v-bind:qid="'s10q12'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s10q12_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s10_comment.q12"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s10q12_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s10_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s10_images_to_delete"
                                        v-bind:questionId="12"
                                ></question-photos>

                                <yes-no-na-button :key="'s10q13'+componentKey" 
                                        v-model="raAnswer.ra_s10_yn.q13"
                                        v-bind:action_plan.sync = "raAnswer.ra_s10_yn.q13_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s10q13"
                                        v-bind:id="'raAnswer.ra_s10_yn.q13'"
                                        v-bind:question="getQuestion('s10q13')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s10q13_yn'+componentKey"
                                        v-model="raAnswer.ra_s10_answer.q13"
                                        v-if="raAnswer.ra_s10_yn.q13 !== null"
                                        v-bind:qid="'s10q13'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s10q13_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s10_comment.q13"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s10q13_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s10_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s10_images_to_delete"
                                        v-bind:questionId="13"
                                ></question-photos>

                                <yes-no-na-button :key="'s10q14'+componentKey" 
                                        v-model="raAnswer.ra_s10_yn.q14"
                                        v-bind:action_plan.sync = "raAnswer.ra_s10_yn.q14_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s10q14"
                                        v-bind:id="'raAnswer.ra_s10_yn.q14'"
                                        v-bind:question="getQuestion('s10q14')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s10q14_yn'+componentKey"
                                        v-model="raAnswer.ra_s10_answer.q14"
                                        v-if="raAnswer.ra_s10_yn.q14 !== null"
                                        v-bind:qid="'s10q14'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s10q14_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s10_comment.q14"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s10q14_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s10_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s10_images_to_delete"
                                        v-bind:questionId="14"
                                ></question-photos>

                                <div class="em-separator separator-dashed"></div>

                                <h4><strong>Mechanical Machinery</strong></h4>

                                <yes-no-na-button :key="'s10q15'+componentKey" 
                                        v-model="raAnswer.ra_s10_yn.q15"
                                        v-bind:action_plan.sync = "raAnswer.ra_s10_yn.q15_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s10q15"
                                        v-bind:id="'raAnswer.ra_s10_yn.q15'"
                                        v-bind:question="getQuestion('s10q15')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s10q15_yn'+componentKey"
                                        v-model="raAnswer.ra_s10_answer.q15"
                                        v-if="raAnswer.ra_s10_yn.q15 !== null"
                                        v-bind:qid="'s10q15'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s10q15_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s10_comment.q15"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s10q15_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s10_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s10_images_to_delete"
                                        v-bind:questionId="15"
                                ></question-photos>

                                <yes-no-na-button :key="'s10q16'+componentKey" 
                                        v-model="raAnswer.ra_s10_yn.q16"
                                        v-bind:action_plan.sync = "raAnswer.ra_s10_yn.q16_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s10q16"
                                        v-bind:id="'raAnswer.ra_s10_yn.q16'"
                                        v-bind:question="getQuestion('s10q16')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s10q16_yn'+componentKey"
                                        v-model="raAnswer.ra_s10_answer.q16"
                                        v-if="raAnswer.ra_s10_yn.q16 !== null"
                                        v-bind:qid="'s10q16'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s10q16_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s10_comment.q16"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s10q16_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s10_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s10_images_to_delete"
                                        v-bind:questionId="16"
                                ></question-photos>

                                <div class="em-separator separator-dashed"></div>

                                <h4><strong>Housekeeping</strong></h4>

                                <yes-no-na-button :key="'s10q17'+componentKey" 
                                        v-model="raAnswer.ra_s10_yn.q17"
                                        v-bind:action_plan.sync = "raAnswer.ra_s10_yn.q17_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s10q17"
                                        v-bind:id="'raAnswer.ra_s10_yn.q17'"
                                        v-bind:question="getQuestion('s10q17')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s10q17_yn'+componentKey"
                                        v-model="raAnswer.ra_s10_answer.q17"
                                        v-if="raAnswer.ra_s10_yn.q17 !== null"
                                        v-bind:qid="'s10q17'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s10q17_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s10_comment.q17"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s10q17_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s10_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s10_images_to_delete"
                                        v-bind:questionId="17"
                                ></question-photos>

                                <div class="em-separator separator-dashed"></div>

                                <h4><strong>Waste Management</strong></h4>

                                <yes-no-na-button :key="'s10q18'+componentKey" 
                                        v-model="raAnswer.ra_s10_yn.q18"
                                        v-bind:action_plan.sync = "raAnswer.ra_s10_yn.q18_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s10q18"
                                        v-bind:id="'raAnswer.ra_s10_yn.q18'"
                                        v-bind:question="getQuestion('s10q18')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s10q18_yn'+componentKey"
                                        v-model="raAnswer.ra_s10_answer.q18"
                                        v-if="raAnswer.ra_s10_yn.q18 !== null"
                                        v-bind:qid="'s10q18'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s10q18_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s10_comment.q18"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s10q18_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s10_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s10_images_to_delete"
                                        v-bind:questionId="18"
                                ></question-photos>

                                <div class="em-separator separator-dashed"></div>

                                <h4><strong>Arson</strong></h4>

                                <yes-no-na-button :key="'s10q19'+componentKey" 
                                        v-model="raAnswer.ra_s10_yn.q19"
                                        v-bind:action_plan.sync = "raAnswer.ra_s10_yn.q19_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s10q19"
                                        v-bind:id="'raAnswer.ra_s10_yn.q19'"
                                        v-bind:question="getQuestion('s10q19')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s10q19_yn'+componentKey"
                                        v-model="raAnswer.ra_s10_answer.q19"
                                        v-if="raAnswer.ra_s10_yn.q19 !== null"
                                        v-bind:qid="'s10q19'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s10q19_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s10_comment.q19"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s10q19_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s10_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s10_images_to_delete"
                                        v-bind:questionId="19"
                                ></question-photos>

                                <div class="em-separator separator-dashed"></div>

                                <h4><strong>Smoking Policy</strong></h4>

                                <yes-no-na-button :key="'s10q20'+componentKey" 
                                        v-model="raAnswer.ra_s10_yn.q20"
                                        v-bind:action_plan.sync = "raAnswer.ra_s10_yn.q20_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s10q20"
                                        v-bind:id="'raAnswer.ra_s10_yn.q20'"
                                        v-bind:question="getQuestion('s10q20')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s10q20_yn'+componentKey"
                                        v-model="raAnswer.ra_s10_answer.q20"
                                        v-if="raAnswer.ra_s10_yn.q20 !== null"
                                        v-bind:qid="'s10q20'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s10q20_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s10_comment.q20"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s10q20_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s10_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s10_images_to_delete"
                                        v-bind:questionId="20"
                                ></question-photos>

                                <yes-no-na-button :key="'s10q21'+componentKey" 
                                        v-model="raAnswer.ra_s10_yn.q21"
                                        v-bind:action_plan.sync = "raAnswer.ra_s10_yn.q21_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s10q21"
                                        v-bind:id="'raAnswer.ra_s10_yn.q21'"
                                        v-bind:question="getQuestion('s10q21')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s10q21_yn'+componentKey"
                                        v-model="raAnswer.ra_s10_answer.q21"
                                        v-if="raAnswer.ra_s10_yn.q21 !== null"
                                        v-bind:qid="'s10q21'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s10q21_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s10_comment.q21"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s10q21_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s10_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s10_images_to_delete"
                                        v-bind:questionId="21"
                                ></question-photos>

                                <div class="em-separator separator-dashed"></div>

                                <h4>
                                    <strong v-if="dbName !== 'jpfire'">Furniture & Furnishings</strong>
                                    <strong v-else>Fire Loading</strong>
                                </h4>

                                <yes-no-na-button :key="'s10q22'+componentKey" 
                                        v-model="raAnswer.ra_s10_yn.q22"
                                        v-bind:action_plan.sync = "raAnswer.ra_s10_yn.q22_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s10q22"
                                        v-bind:id="'raAnswer.ra_s10_yn.q22'"
                                        v-bind:question="getQuestion('s10q22')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s10q22_yn'+componentKey"
                                        v-model="raAnswer.ra_s10_answer.q22"
                                        v-if="raAnswer.ra_s10_yn.q22 !== null"
                                        v-bind:qid="'s10q22'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s10q22_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s10_comment.q22"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s10q22_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s10_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s10_images_to_delete"
                                        v-bind:questionId="22"
                                ></question-photos>

                                <yes-no-na-button :key="'s10q23'+componentKey" 
                                        v-model="raAnswer.ra_s10_yn.q23"
                                        v-bind:action_plan.sync = "raAnswer.ra_s10_yn.q23_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s10q23"
                                        v-bind:id="'raAnswer.ra_s10_yn.q23'"
                                        v-bind:question="getQuestion('s10q23')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s10q23_yn'+componentKey"
                                        v-model="raAnswer.ra_s10_answer.q23"
                                        v-if="raAnswer.ra_s10_yn.q23 !== null"
                                        v-bind:qid="'s10q23'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s10q23_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s10_comment.q23"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s10q23_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s10_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s10_images_to_delete"
                                        v-bind:questionId="23"
                                ></question-photos>

                                <yes-no-na-button :key="'s10q24'+componentKey" 
                                        v-model="raAnswer.ra_s10_yn.q24"
                                        v-bind:action_plan.sync = "raAnswer.ra_s10_yn.q24_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s10q24"
                                        v-bind:id="'raAnswer.ra_s10_yn.q24'"
                                        v-bind:question="getQuestion('s10q24')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s10q24_yn'+componentKey"
                                        v-model="raAnswer.ra_s10_answer.q24"
                                        v-if="raAnswer.ra_s10_yn.q24 !== null"
                                        v-bind:qid="'s10q24'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s10q24_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s10_comment.q24"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s10q24_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s10_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s10_images_to_delete"
                                        v-bind:questionId="24"
                                ></question-photos>

                                <div class="em-separator separator-dashed"></div>

                                <h3><strong>{{getSectionTitle(11)}}</strong></h3>

                                <div class="em-separator separator-dashed"></div>

                                <div class="form-group row d-flex align-items-center">
                                    <label
                                            class="col-lg-12 form-control-label"
                                            for="raAnswer.ra_s11_answer.report_text">Report Text</label>
                                    <div class="col-lg-12">
                                        <textarea
                                                v-model="raAnswer.ra_s11_answer.report_text"
                                                id="raAnswer.ra_s11_answer.report_text"
                                                class="form-control"
                                                rows="5"
                                        >
                                        </textarea>
                                    </div>
                                </div>

                                <div class="em-separator separator-dashed"></div>

                                <h4><strong>Highly Flammable Liquids</strong></h4>

                                <yes-no-na-button :key="'s11q1'+componentKey" 
                                        v-model="raAnswer.ra_s11_yn.q1"
                                        v-bind:action_plan.sync = "raAnswer.ra_s11_yn.q1_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s11q1"
                                        v-bind:id="'raAnswer.ra_s11_yn.q1'"
                                        v-bind:question="getQuestion('s11q1')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s11q1_yn'+componentKey"
                                        v-model="raAnswer.ra_s11_answer.q1"
                                        v-if="raAnswer.ra_s11_yn.q1 !== null"
                                        v-bind:qid="'s11q1'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s11q1_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s11_comment.q1"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s11q1_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s11_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s11_images_to_delete"
                                        v-bind:questionId="1"
                                ></question-photos>

                                <yes-no-na-button :key="'s11q2'+componentKey" 
                                        v-model="raAnswer.ra_s11_yn.q2"
                                        v-bind:action_plan.sync = "raAnswer.ra_s11_yn.q2_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s11q2"
                                        v-bind:id="'raAnswer.ra_s11_yn.q2'"
                                        v-bind:question="getQuestion('s11q2')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s11q2_yn'+componentKey"
                                        v-model="raAnswer.ra_s11_answer.q2"
                                        v-if="raAnswer.ra_s11_yn.q2 !== null"
                                        v-bind:qid="'s11q2'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s11q2_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s11_comment.q2"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s11q2_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s11_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s11_images_to_delete"
                                        v-bind:questionId="2"
                                ></question-photos>

                                <yes-no-na-button :key="'s11q3'+componentKey" 
                                        v-model="raAnswer.ra_s11_yn.q3"
                                        v-bind:action_plan.sync = "raAnswer.ra_s11_yn.q3_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s11q3"
                                        v-bind:id="'raAnswer.ra_s11_yn.q3'"
                                        v-bind:question="getQuestion('s11q3')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s11q3_yn'+componentKey"
                                        v-model="raAnswer.ra_s11_answer.q3"
                                        v-if="raAnswer.ra_s11_yn.q3 !== null"
                                        v-bind:qid="'s11q3'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s11q3_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s11_comment.q3"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s11q3_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s11_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s11_images_to_delete"
                                        v-bind:questionId="3"
                                ></question-photos>

                                <yes-no-na-button :key="'s11q4'+componentKey" 
                                        v-model="raAnswer.ra_s11_yn.q4"
                                        v-bind:action_plan.sync = "raAnswer.ra_s11_yn.q4_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s11q4"
                                        v-bind:id="'raAnswer.ra_s11_yn.q4'"
                                        v-bind:question="getQuestion('s11q4')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s11q4_yn'+componentKey"
                                        v-model="raAnswer.ra_s11_answer.q4"
                                        v-if="raAnswer.ra_s11_yn.q4 !== null"
                                        v-bind:qid="'s11q4'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s11q4_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s11_comment.q4"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s11q4_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s11_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s11_images_to_delete"
                                        v-bind:questionId="4"
                                ></question-photos>

                                <div class="em-separator separator-dashed"></div>

                                <h4><strong>Gas Installation and Appliances</strong></h4>

                                <yes-no-na-button :key="'s11q5'+componentKey" 
                                        v-model="raAnswer.ra_s11_yn.q5"
                                        v-bind:action_plan.sync = "raAnswer.ra_s11_yn.q5_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s11q5"
                                        v-bind:id="'raAnswer.ra_s11_yn.q5'"
                                        v-bind:question="getQuestion('s11q5')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s11q5_yn'+componentKey"
                                        v-model="raAnswer.ra_s11_answer.q5"
                                        v-if="raAnswer.ra_s11_yn.q5 !== null"
                                        v-bind:qid="'s11q5'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s11q5_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s11_comment.q5"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s11q5_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s11_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s11_images_to_delete"
                                        v-bind:questionId="5"
                                ></question-photos>

                                <yes-no-na-button :key="'s11q6'+componentKey" 
                                        v-model="raAnswer.ra_s11_yn.q6"
                                        v-bind:action_plan.sync = "raAnswer.ra_s11_yn.q6_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s11q6"
                                        v-bind:id="'raAnswer.ra_s11_yn.q6'"
                                        v-bind:question="getQuestion('s11q6')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s11q6_yn'+componentKey"
                                        v-model="raAnswer.ra_s11_answer.q6"
                                        v-if="raAnswer.ra_s11_yn.q6 !== null"
                                        v-bind:qid="'s11q6'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s11q6_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s11_comment.q6"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s11q6_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s11_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s11_images_to_delete"
                                        v-bind:questionId="6"
                                ></question-photos>

                                <yes-no-na-button :key="'s11q7'+componentKey" 
                                        v-model="raAnswer.ra_s11_yn.q7"
                                        v-bind:action_plan.sync = "raAnswer.ra_s11_yn.q7_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s11q7"
                                        v-bind:id="'raAnswer.ra_s11_yn.q7'"
                                        v-bind:question="getQuestion('s11q7')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s11q7_yn'+componentKey"
                                        v-model="raAnswer.ra_s11_answer.q7"
                                        v-if="raAnswer.ra_s11_yn.q7 !== null"
                                        v-bind:qid="'s11q7'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s11q7_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s11_comment.q7"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s11q7_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s11_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s11_images_to_delete"
                                        v-bind:questionId="7"
                                ></question-photos>

                                <div class="em-separator separator-dashed"></div>

                                <h4><strong>Highly Flammable Gases</strong></h4>

                                <yes-no-na-button :key="'s11q8'+componentKey" 
                                        v-model="raAnswer.ra_s11_yn.q8"
                                        v-bind:action_plan.sync = "raAnswer.ra_s11_yn.q8_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s11q8"
                                        v-bind:id="'raAnswer.ra_s11_yn.q8'"
                                        v-bind:question="getQuestion('s11q8')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s11q8_yn'+componentKey"
                                        v-model="raAnswer.ra_s11_answer.q8"
                                        v-if="raAnswer.ra_s11_yn.q8 !== null"
                                        v-bind:qid="'s11q8'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s11q8_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s11_comment.q8"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s11q8_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s11_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s11_images_to_delete"
                                        v-bind:questionId="8"
                                ></question-photos>

                                <yes-no-na-button :key="'s11q9'+componentKey" 
                                        v-model="raAnswer.ra_s11_yn.q9"
                                        v-bind:action_plan.sync = "raAnswer.ra_s11_yn.q9_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s11q9"
                                        v-bind:id="'raAnswer.ra_s11_yn.q9'"
                                        v-bind:question="getQuestion('s11q9')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s11q9_yn'+componentKey"
                                        v-model="raAnswer.ra_s11_answer.q9"
                                        v-if="raAnswer.ra_s11_yn.q9 !== null"
                                        v-bind:qid="'s11q9'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s11q9_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s11_comment.q9"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s11q9_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s11_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s11_images_to_delete"
                                        v-bind:questionId="9"
                                ></question-photos>

                                <yes-no-na-button :key="'s11q10'+componentKey" 
                                        v-model="raAnswer.ra_s11_yn.q10"
                                        v-bind:action_plan.sync = "raAnswer.ra_s11_yn.q10_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s11q10"
                                        v-bind:id="'raAnswer.ra_s11_yn.q10'"
                                        v-bind:question="getQuestion('s11q10')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s11q10_yn'+componentKey"
                                        v-model="raAnswer.ra_s11_answer.q10"
                                        v-if="raAnswer.ra_s11_yn.q10 !== null"
                                        v-bind:qid="'s11q10'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s11q10_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s11_comment.q10"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s11q10_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s11_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s11_images_to_delete"
                                        v-bind:questionId="10"
                                ></question-photos>

                                <div class="em-separator separator-dashed"></div>

                                <h4><strong>Combustible Dusts and appropriate control measures.</strong></h4>

                                <yes-no-na-button :key="'s11q11'+componentKey" 
                                        v-model="raAnswer.ra_s11_yn.q11"
                                        v-bind:action_plan.sync = "raAnswer.ra_s11_yn.q11_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s11q11"
                                        v-bind:id="'raAnswer.ra_s11_yn.q11'"
                                        v-bind:question="getQuestion('s11q11')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s11q11_yn'+componentKey"
                                        v-model="raAnswer.ra_s11_answer.q11"
                                        v-if="raAnswer.ra_s11_yn.q11 !== null"
                                        v-bind:qid="'s11q11'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s11q11_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s11_comment.q11"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s11q11_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s11_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s11_images_to_delete"
                                        v-bind:questionId="11"
                                ></question-photos>

                                <yes-no-na-button :key="'s11q12'+componentKey" 
                                        v-model="raAnswer.ra_s11_yn.q12"
                                        v-bind:action_plan.sync = "raAnswer.ra_s11_yn.q12_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s11q12"
                                        v-bind:id="'raAnswer.ra_s11_yn.q12'"
                                        v-bind:question="getQuestion('s11q12')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s11q12_yn'+componentKey"
                                        v-model="raAnswer.ra_s11_answer.q12"
                                        v-if="raAnswer.ra_s11_yn.q12 !== null"
                                        v-bind:qid="'s11q12'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s11q12_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s11_comment.q12"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s11q12_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s11_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s11_images_to_delete"
                                        v-bind:questionId="12"
                                ></question-photos>

                                <div class="em-separator separator-dashed"></div>

                                <div class="form-group row d-flex align-items-center">
                                    <div class="col-lg-12">
                                        <div class="row">
                                                <div class="col-lg-1 col-chkbx hide-question-chbx">
                                                        <label class="styled-checkbox">
                                                        <input type="checkbox" v-model="raAnswer.ra_hidden_question.s11q13">
                                                        <span class="checkmark"></span>
                                                        </label>
                                                        <i class="fa fa-eye-slash"></i>
                                                </div>
                                                <label
                                                        class="col-lg-11 form-control-label"
                                                        for="raAnswer.ra_s11_answer.q13">
                                                        {{ getQuestion('s11q13') }}
                                                </label>
                                        </div>
                                    </div>   
                                    
                                    <div class="col-lg-1 col-chkbx">
                                        <label class="styled-checkbox">
                                            <input type="checkbox" v-model="raAnswer.ra_s11_yn.q13_add_ap">
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                    <div class="col-lg-11">
                                        <textarea
                                                v-model="raAnswer.ra_s11_answer.q13"
                                                v-if="dbName !== 'jpfire'"
                                                id="raAnswer.ra_s11_answer.q13"
                                                class="form-control"
                                                rows="5"
                                        >
                                        </textarea>
                                        <text-dropdown-field
                                                id="raAnswer.ra_s11_answer.q13"
                                                :key="'s11q13_value'+componentKey"
                                                v-model="raAnswer.ra_s11_answer.q13"
                                                v-bind:qid="'s11q13'"
                                                v-if="dbName === 'jpfire'"
                                        ></text-dropdown-field>
                                    </div>
                                </div>

                                <question-photos 
                                        :key="'s11q13_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s11_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s11_images_to_delete"
                                        v-bind:questionId="13"
                                ></question-photos>

                            </div>
                        </div>
                    </div>
                </div>

                <div class="row" v-if="openTab === 4">
                    <div class="col-sm-12 widget-20">
                        <div class="widget has-shadow">
                            <div class="widget-header bordered d-flex align-items-center section-header">
                                <h2>{{getPartTitle(4)}}</h2>
                                <div>
                                    <!--<span class="a-primary c-pointer" v-on:click="openTab = 5" v-bind:class="openTab === 5 ? 'bg-primary': ''">Summary</span>-->
                                </div>
                            </div>
                            <div class="widget-body">

                                <h4><strong>{{getSectionTitle(12)}}</strong></h4>

                                <div class="em-separator separator-dashed"></div>

                                <div class="form-group row d-flex align-items-center">
                                    <label
                                            class="col-lg-12 form-control-label"
                                            for="raAnswer.ra_s12_answer.report_text">Report Text</label>
                                    <div class="col-lg-12">
                                        <textarea
                                                v-model="raAnswer.ra_s12_answer.report_text"
                                                id="raAnswer.ra_s12_answer.report_text"
                                                class="form-control"
                                                rows="5"
                                        >
                                        </textarea>
                                    </div>
                                </div>

                                <div class="em-separator separator-dashed"></div>
                                <h4><strong>Fire Extinguisher provisions for this site</strong></h4>


                                <yes-no-na-button :key="'s12q1'+componentKey" 
                                        v-model="raAnswer.ra_s12_yn.q1"
                                        v-bind:action_plan.sync = "raAnswer.ra_s12_yn.q1_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s12q1"
                                        v-bind:id="'raAnswer.ra_s12_yn.q1'"
                                        v-bind:question="getQuestion('s12q1')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s12q1_yn'+componentKey"
                                        v-model="raAnswer.ra_s12_answer.q1"
                                        v-if="raAnswer.ra_s12_yn.q1 !== null"
                                        v-bind:qid="'s12q1'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s12q1_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s12_comment.q1"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s12q1_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s12_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s12_images_to_delete"
                                        v-bind:questionId="1"
                                ></question-photos>

                                <yes-no-na-button :key="'s12q2'+componentKey" 
                                        v-model="raAnswer.ra_s12_yn.q2"
                                        v-bind:action_plan.sync = "raAnswer.ra_s12_yn.q2_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s12q2"
                                        v-bind:id="'raAnswer.ra_s12_yn.q2'"
                                        v-bind:question="getQuestion('s12q2')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s12q2_yn'+componentKey"
                                        v-model="raAnswer.ra_s12_answer.q2"
                                        v-if="raAnswer.ra_s12_yn.q2 !== null"
                                        v-bind:qid="'s12q2'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s12q2_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s12_comment.q2"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s12q2_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s12_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s12_images_to_delete"
                                        v-bind:questionId="2"
                                ></question-photos>

                                <yes-no-na-button :key="'s12q3'+componentKey" 
                                        v-model="raAnswer.ra_s12_yn.q3"
                                        v-bind:action_plan.sync = "raAnswer.ra_s12_yn.q3_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s12q3"
                                        v-bind:id="'raAnswer.ra_s12_yn.q3'"
                                        v-bind:question="getQuestion('s12q3')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s12q3_yn'+componentKey"
                                        v-model="raAnswer.ra_s12_answer.q3"
                                        v-if="raAnswer.ra_s12_yn.q3 !== null"
                                        v-bind:qid="'s12q3'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s12q3_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s12_comment.q3"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s12q3_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s12_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s12_images_to_delete"
                                        v-bind:questionId="3"
                                ></question-photos>

                                <yes-no-na-button :key="'s12q4'+componentKey" 
                                        v-model="raAnswer.ra_s12_yn.q4"
                                        v-bind:action_plan.sync = "raAnswer.ra_s12_yn.q4_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s12q4"
                                        v-bind:id="'raAnswer.ra_s12_yn.q4'"
                                        v-bind:question="getQuestion('s12q4')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s12q4_yn'+componentKey"
                                        v-model="raAnswer.ra_s12_answer.q4"
                                        v-if="raAnswer.ra_s12_yn.q4 !== null"
                                        v-bind:qid="'s12q4'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s12q4_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s12_comment.q4"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s12q4_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s12_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s12_images_to_delete"
                                        v-bind:questionId="4"
                                ></question-photos>

                                <yes-no-na-button :key="'s12q5'+componentKey" 
                                        v-model="raAnswer.ra_s12_yn.q5"
                                        v-bind:action_plan.sync = "raAnswer.ra_s12_yn.q5_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s12q5"
                                        v-bind:id="'raAnswer.ra_s12_yn.q5'"
                                        v-bind:question="getQuestion('s12q5')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s12q5_yn'+componentKey"
                                        v-model="raAnswer.ra_s12_answer.q5"
                                        v-if="raAnswer.ra_s12_yn.q5 !== null"
                                        v-bind:qid="'s12q5'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s12q5_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s12_comment.q5"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s12q5_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s12_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s12_images_to_delete"
                                        v-bind:questionId="5"
                                ></question-photos>

                                <div class="em-separator separator-dashed"></div>

                                <h4><strong>Fire Suppression</strong></h4>

                                <yes-no-na-button :key="'s12q6'+componentKey" 
                                        v-model="raAnswer.ra_s12_yn.q6"
                                        v-bind:action_plan.sync = "raAnswer.ra_s12_yn.q6_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s12q6"
                                        v-bind:id="'raAnswer.ra_s12_yn.q6'"
                                        v-bind:question="getQuestion('s12q6')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s12q6_yn'+componentKey"
                                        v-model="raAnswer.ra_s12_answer.q6"
                                        v-if="raAnswer.ra_s12_yn.q6 !== null"
                                        v-bind:qid="'s12q6'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s12q6_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s12_comment.q6"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s12q6_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s12_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s12_images_to_delete"
                                        v-bind:questionId="6"
                                ></question-photos>

                                <div class="em-separator separator-dashed"></div>

                                <h4><strong>Sprinkler Systems, Water Misting and Firefighting Medium</strong></h4>

                                <yes-no-na-button :key="'s12q7'+componentKey" 
                                        v-model="raAnswer.ra_s12_yn.q7"
                                        v-bind:action_plan.sync = "raAnswer.ra_s12_yn.q7_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s12q7"
                                        v-bind:id="'raAnswer.ra_s12_yn.q7'"
                                        v-bind:question="getQuestion('s12q7')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s12q7_yn'+componentKey"
                                        v-model="raAnswer.ra_s12_answer.q7"
                                        v-if="raAnswer.ra_s12_yn.q7 !== null"
                                        v-bind:qid="'s12q7'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s12q7_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s12_comment.q7"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s12q7_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s12_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s12_images_to_delete"
                                        v-bind:questionId="7"
                                ></question-photos>

                                <yes-no-na-button :key="'s12q8'+componentKey" 
                                        v-model="raAnswer.ra_s12_yn.q8"
                                        v-bind:action_plan.sync = "raAnswer.ra_s12_yn.q8_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s12q8"
                                        v-bind:id="'raAnswer.ra_s12_yn.q8'"
                                        v-bind:question="getQuestion('s12q8')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s12q8_yn'+componentKey"
                                        v-model="raAnswer.ra_s12_answer.q8"
                                        v-if="raAnswer.ra_s12_yn.q8 !== null"
                                        v-bind:qid="'s12q8'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s12q8_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s12_comment.q8"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s12q8_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s12_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s12_images_to_delete"
                                        v-bind:questionId="8"
                                ></question-photos>

                                <yes-no-na-button :key="'s12q9'+componentKey" 
                                        v-model="raAnswer.ra_s12_yn.q9"
                                        v-bind:action_plan.sync = "raAnswer.ra_s12_yn.q9_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s12q9"
                                        v-bind:id="'raAnswer.ra_s12_yn.q9'"
                                        v-bind:question="getQuestion('s12q9')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        v-model="raAnswer.ra_s12_answer.q9"
                                        v-if="raAnswer.ra_s12_yn.q9 !== null"
                                        v-bind:qid="'s12q9'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s12q9_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s12_comment.q9"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s12q9_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s12_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s12_images_to_delete"
                                        v-bind:questionId="9"
                                ></question-photos>

                                <div class="em-separator separator-dashed"></div>

                                <div class="form-group row d-flex align-items-center">
                                    <div class="col-lg-12">
                                        <div class="row">
                                                <div class="col-lg-1 col-chkbx hide-question-chbx">
                                                        <label class="styled-checkbox">
                                                        <input type="checkbox" v-model="raAnswer.ra_hidden_question.s12q10">
                                                        <span class="checkmark"></span>
                                                        </label>
                                                        <i class="fa fa-eye-slash"></i>
                                                </div>
                                                <label
                                                        class="col-lg-11 form-control-label"
                                                        for="raAnswer.ra_s12_answer.q10">
                                                        {{ getQuestion('s12q10') }}
                                                </label>
                                        </div>
                                    </div>    

                                    <div class="col-lg-1 col-chkbx">
                                        <label class="styled-checkbox">
                                            <input type="checkbox" v-model="raAnswer.ra_s12_yn.q10_add_ap">
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                    <div class="col-lg-11">
                                        <textarea
                                                v-model="raAnswer.ra_s12_answer.q10"
                                                id="raAnswer.ra_s12_answer.q10"
                                                class="form-control"
                                                rows="5"
                                                v-if="dbName !== 'jpfire'"
                                        >
                                        </textarea>
                                        <text-dropdown-field
                                                id="raAnswer.ra_s12_answer.q10"
                                                :key="'s12q10_value'+componentKey"
                                                v-model="raAnswer.ra_s12_answer.q10"
                                                v-bind:qid="'s12q10'"
                                                v-if="dbName === 'jpfire'"
                                        ></text-dropdown-field>
                                    </div>
                                </div>

                                <question-photos 
                                        :key="'s12q10_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s12_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s12_images_to_delete"
                                        v-bind:questionId="10"
                                ></question-photos>

                                <h4><strong>{{getSectionTitle(13)}}</strong></h4>

                                <div class="em-separator separator-dashed"></div>

                                <div class="form-group row d-flex align-items-center">
                                    <label
                                            class="col-lg-12 form-control-label"
                                            for="raAnswer.ra_s13_answer.report_text">Report Text</label>
                                    <div class="col-lg-12">
                                        <textarea
                                                v-model="raAnswer.ra_s13_answer.report_text"
                                                id="raAnswer.ra_s13_answer.report_text"
                                                class="form-control"
                                                rows="5"
                                        >
                                        </textarea>
                                    </div>
                                </div>

                                <div class="em-separator separator-dashed"></div>

                                <h4><strong>Detection and Warning Systems</strong></h4>

                                <yes-no-na-button :key="'s13q1'+componentKey" 
                                        v-model="raAnswer.ra_s13_yn.q1"
                                        v-bind:action_plan.sync = "raAnswer.ra_s13_yn.q1_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s13q1"
                                        v-bind:id="'raAnswer.ra_s13_yn.q1'"
                                        v-bind:question="getQuestion('s13q1')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s13q1_yn'+componentKey"
                                        v-model="raAnswer.ra_s13_answer.q1"
                                        v-if="raAnswer.ra_s13_yn.q1 !== null"
                                        v-bind:qid="'s13q1'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s13q1_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s13_comment.q1"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s13q1_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s13_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s13_images_to_delete"
                                        v-bind:questionId="1"
                                ></question-photos>

                                <yes-no-na-button :key="'s13q2'+componentKey" 
                                        v-model="raAnswer.ra_s13_yn.q2"
                                        v-bind:action_plan.sync = "raAnswer.ra_s13_yn.q2_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s13q2"
                                        v-bind:id="'raAnswer.ra_s13_yn.q2'"
                                        v-bind:question="getQuestion('s13q2')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s13q2_yn'+componentKey"
                                        v-model="raAnswer.ra_s13_answer.q2"
                                        v-if="raAnswer.ra_s13_yn.q2 !== null"
                                        v-bind:qid="'s13q2'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s13q2_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s13_comment.q2"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s13q2_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s13_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s13_images_to_delete"
                                        v-bind:questionId="2"
                                ></question-photos>

                                <yes-no-na-button :key="'s13q3'+componentKey" 
                                        v-model="raAnswer.ra_s13_yn.q3"
                                        v-bind:action_plan.sync = "raAnswer.ra_s13_yn.q3_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s13q3"
                                        v-bind:id="'raAnswer.ra_s13_yn.q3'"
                                        v-bind:question="getQuestion('s13q3')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s13q3_yn'+componentKey"
                                        v-model="raAnswer.ra_s13_answer.q3"
                                        v-if="raAnswer.ra_s13_yn.q3 !== null"
                                        v-bind:qid="'s13q3'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s13q3_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s13_comment.q3"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s13q3_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s13_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s13_images_to_delete"
                                        v-bind:questionId="3"
                                ></question-photos>

                                <yes-no-na-button :key="'s13q4'+componentKey" 
                                        v-model="raAnswer.ra_s13_yn.q4"
                                        v-bind:action_plan.sync = "raAnswer.ra_s13_yn.q4_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s13q4"
                                        v-bind:id="'raAnswer.ra_s13_yn.q4'"
                                        v-bind:question="getQuestion('s13q4')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s13q4_yn'+componentKey"
                                        v-model="raAnswer.ra_s13_answer.q4"
                                        v-if="raAnswer.ra_s13_yn.q4 !== null"
                                        v-bind:qid="'s13q4'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s13q4_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s13_comment.q4"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s13q4_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s13_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s13_images_to_delete"
                                        v-bind:questionId="4"
                                ></question-photos>

                                <yes-no-na-button :key="'s13q5'+componentKey" 
                                        v-model="raAnswer.ra_s13_yn.q5"
                                        v-bind:action_plan.sync = "raAnswer.ra_s13_yn.q5_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s13q5"
                                        v-bind:id="'raAnswer.ra_s13_yn.q5'"
                                        v-bind:question="getQuestion('s13q5')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s13q5_yn'+componentKey"
                                        v-model="raAnswer.ra_s13_answer.q5"
                                        v-if="raAnswer.ra_s13_yn.q5 !== null"
                                        v-bind:qid="'s13q5'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s13q5_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s13_comment.q5"
                                ></additional-comment>

                                <question-photos
                                        :key="'s13q5_photos'+componentKey" 
                                        v-bind:sectionImages="raAnswer.ra_s13_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s13_images_to_delete"
                                        v-bind:questionId="5"
                                ></question-photos>

                                <yes-no-na-button :key="'s13q6'+componentKey" 
                                        v-model="raAnswer.ra_s13_yn.q6"
                                        v-bind:action_plan.sync = "raAnswer.ra_s13_yn.q6_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s13q6"
                                        v-bind:id="'raAnswer.ra_s13_yn.q6'"
                                        v-bind:question="getQuestion('s13q6')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s13q6_yn'+componentKey"
                                        v-model="raAnswer.ra_s13_answer.q6"
                                        v-if="raAnswer.ra_s13_yn.q6 !== null"
                                        v-bind:qid="'s13q6'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s13q6_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s13_comment.q6"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s13q6_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s13_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s13_images_to_delete"
                                        v-bind:questionId="6"
                                ></question-photos>

                                <yes-no-na-button :key="'s13q7'+componentKey" 
                                        v-model="raAnswer.ra_s13_yn.q7"
                                        v-bind:action_plan.sync = "raAnswer.ra_s13_yn.q7_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s13q7"
                                        v-bind:id="'raAnswer.ra_s13_yn.q7'"
                                        v-bind:question="getQuestion('s13q7')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s13q7_yn'+componentKey"
                                        v-model="raAnswer.ra_s13_answer.q7"
                                        v-if="raAnswer.ra_s13_yn.q7 !== null"
                                        v-bind:qid="'s13q7'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s13q7_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s13_comment.q7"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s13q7_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s13_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s13_images_to_delete"
                                        v-bind:questionId="7"
                                ></question-photos>

                                <yes-no-na-button :key="'s13q8'+componentKey" 
                                        v-model="raAnswer.ra_s13_yn.q8"
                                        v-bind:action_plan.sync = "raAnswer.ra_s13_yn.q8_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s13q8"
                                        v-bind:id="'raAnswer.ra_s13_yn.q8'"
                                        v-bind:question="getQuestion('s13q8')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s13q8_yn'+componentKey"
                                        v-model="raAnswer.ra_s13_answer.q8"
                                        v-if="raAnswer.ra_s13_yn.q8 !== null"
                                        v-bind:qid="'s13q8'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s13q8_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s13_comment.q8"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s13q8_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s13_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s13_images_to_delete"
                                        v-bind:questionId="8"
                                ></question-photos>

                                <yes-no-na-button :key="'s13q9'+componentKey" 
                                        v-model="raAnswer.ra_s13_yn.q9"
                                        v-bind:action_plan.sync = "raAnswer.ra_s13_yn.q9_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s13q9"
                                        v-bind:id="'raAnswer.ra_s13_yn.q9'"
                                        v-bind:question="getQuestion('s13q9')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s13q9_yn'+componentKey"
                                        v-model="raAnswer.ra_s13_answer.q9"
                                        v-if="raAnswer.ra_s13_yn.q9 !== null"
                                        v-bind:qid="'s13q9'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s13q9_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s13_comment.q9"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s13q9_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s13_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s13_images_to_delete"
                                        v-bind:questionId="9"
                                ></question-photos>

                                <div class="em-separator separator-dashed"></div>

                                <div class="form-group row d-flex align-items-center">
                                    <div class="col-lg-12">
                                        <div class="row">
                                                <div class="col-lg-1 col-chkbx hide-question-chbx">
                                                        <label class="styled-checkbox">
                                                        <input type="checkbox" v-model="raAnswer.ra_hidden_question.s13q10">
                                                        <span class="checkmark"></span>
                                                        </label>
                                                        <i class="fa fa-eye-slash"></i>
                                                </div>
                                                <label
                                                        class="col-lg-11 form-control-label"
                                                        for="raAnswer.ra_s13_answer.q10">
                                                        {{ getQuestion('s13q10') }}
                                                </label>
                                        </div>
                                    </div>     

                                    <div class="col-lg-1 col-chkbx">
                                        <label class="styled-checkbox">
                                            <input type="checkbox" v-model="raAnswer.ra_s13_yn.q10_add_ap">
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                    <div class="col-lg-11">
                                        <textarea
                                                v-model="raAnswer.ra_s13_answer.q10"
                                                id="raAnswer.ra_s13_answer.q10"
                                                class="form-control"
                                                rows="5"
                                                v-if="dbName !== 'jpfire'"
                                        >
                                        </textarea>
                                        <text-dropdown-field
                                                id="raAnswer.ra_s13_answer.q10"
                                                :key="'s13q10_value'+componentKey"
                                                v-model="raAnswer.ra_s13_answer.q10"
                                                v-bind:qid="'s13q10'"
                                                v-if="dbName === 'jpfire'"
                                        ></text-dropdown-field>
                                    </div>
                                </div>

                                <question-photos 
                                        :key="'s13q10_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s13_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s13_images_to_delete"
                                        v-bind:questionId="10"
                                ></question-photos>

                                <div class="em-separator separator-dashed"></div>

                                <h4><strong>{{getSectionTitle(14)}}</strong></h4>

                                <div class="em-separator separator-dashed"></div>

                                <div class="form-group row d-flex align-items-center">
                                    <label
                                            class="col-lg-12 form-control-label"
                                            for="raAnswer.ra_s14_answer.report_text">Report Text</label>
                                    <div class="col-lg-12">
                                        <textarea
                                                v-model="raAnswer.ra_s14_answer.report_text"
                                                id="raAnswer.ra_s14_answer.report_text"
                                                class="form-control"
                                                rows="5"
                                        >
                                        </textarea>
                                    </div>
                                </div>

                                <div class="em-separator separator-dashed"></div>

                                <h4><strong>Exits and Travel Distances</strong></h4>

                                <yes-no-na-button :key="'s14q1'+componentKey" 
                                        v-model="raAnswer.ra_s14_yn.q1"
                                        v-bind:action_plan.sync = "raAnswer.ra_s14_yn.q1_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s14q1"
                                        v-bind:id="'raAnswer.ra_s14_yn.q1'"
                                        v-bind:question="getQuestion('s14q1')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s14q1_yn'+componentKey"
                                        v-model="raAnswer.ra_s14_answer.q1"
                                        v-if="raAnswer.ra_s14_yn.q1 !== null"
                                        v-bind:qid="'s14q1'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s14q1_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s14_comment.q1"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s14q1_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s14_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s14_images_to_delete"
                                        v-bind:questionId="1"
                                ></question-photos>

                                <yes-no-na-button :key="'s14q2'+componentKey" 
                                        v-model="raAnswer.ra_s14_yn.q2"
                                        v-bind:action_plan.sync = "raAnswer.ra_s14_yn.q2_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s14q2"
                                        v-bind:id="'raAnswer.ra_s14_yn.q2'"
                                        v-bind:question="getQuestion('s14q2')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s14q2_yn'+componentKey"
                                        v-model="raAnswer.ra_s14_answer.q2"
                                        v-if="raAnswer.ra_s14_yn.q2 !== null"
                                        v-bind:qid="'s14q2'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s14q2_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s14_comment.q2"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s14q2_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s14_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s14_images_to_delete"
                                        v-bind:questionId="2"
                                ></question-photos>

                                <yes-no-na-button :key="'s14q3'+componentKey" 
                                        v-model="raAnswer.ra_s14_yn.q3"
                                        v-bind:action_plan.sync = "raAnswer.ra_s14_yn.q3_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s14q3"
                                        v-bind:id="'raAnswer.ra_s14_yn.q3'"
                                        v-bind:question="getQuestion('s14q3')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s14q3_yn'+componentKey"
                                        v-model="raAnswer.ra_s14_answer.q3"
                                        v-if="raAnswer.ra_s14_yn.q3 !== null"
                                        v-bind:qid="'s14q3'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s14q3_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s14_comment.q3"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s14q3_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s14_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s14_images_to_delete"
                                        v-bind:questionId="3"
                                ></question-photos>

                                <yes-no-na-button :key="'s14q4'+componentKey" 
                                        v-model="raAnswer.ra_s14_yn.q4"
                                        v-bind:action_plan.sync = "raAnswer.ra_s14_yn.q4_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s14q4"
                                        v-bind:id="'raAnswer.ra_s14_yn.q4'"
                                        v-bind:question="getQuestion('s14q4')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s14q4_yn'+componentKey"
                                        v-model="raAnswer.ra_s14_answer.q4"
                                        v-if="raAnswer.ra_s14_yn.q4 !== null"
                                        v-bind:qid="'s14q4'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s14q4_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s14_comment.q4"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s14q4_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s14_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s14_images_to_delete"
                                        v-bind:questionId="4"
                                ></question-photos>

                                <yes-no-na-button :key="'s14q5'+componentKey" 
                                        v-model="raAnswer.ra_s14_yn.q5"
                                        v-bind:action_plan.sync = "raAnswer.ra_s14_yn.q5_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s14q5"
                                        v-bind:id="'raAnswer.ra_s14_yn.q5'"
                                        v-bind:question="getQuestion('s14q5')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s14q5_yn'+componentKey"
                                        v-model="raAnswer.ra_s14_answer.q5"
                                        v-if="raAnswer.ra_s14_yn.q5 !== null"
                                        v-bind:qid="'s14q5'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s14q5_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s14_comment.q5"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s14q5_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s14_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s14_images_to_delete"
                                        v-bind:questionId="5"
                                ></question-photos>

                                <yes-no-na-button :key="'s14q6'+componentKey" 
                                        v-model="raAnswer.ra_s14_yn.q6"
                                        v-bind:action_plan.sync = "raAnswer.ra_s14_yn.q6_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s14q6"
                                        v-bind:id="'raAnswer.ra_s14_yn.q6'"
                                        v-bind:question="getQuestion('s14q6')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s14q6_yn'+componentKey"
                                        v-model="raAnswer.ra_s14_answer.q6"
                                        v-if="raAnswer.ra_s14_yn.q6 !== null"
                                        v-bind:qid="'s14q6'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s14q6_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s14_comment.q6"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s14q6_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s14_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s14_images_to_delete"
                                        v-bind:questionId="6"
                                ></question-photos>

                                <yes-no-na-button :key="'s14q7'+componentKey" 
                                        v-model="raAnswer.ra_s14_yn.q7"
                                        v-bind:action_plan.sync = "raAnswer.ra_s14_yn.q7_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s14q7"
                                        v-bind:id="'raAnswer.ra_s14_yn.q7'"
                                        v-bind:question="getQuestion('s14q7')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s14q7_yn'+componentKey"
                                        v-model="raAnswer.ra_s14_answer.q7"
                                        v-if="raAnswer.ra_s14_yn.q7 !== null"
                                        v-bind:qid="'s14q7'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s14q7_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s14_comment.q7"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s14q7_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s14_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s14_images_to_delete"
                                        v-bind:questionId="7"
                                ></question-photos>

                                <yes-no-na-button :key="'s14q8'+componentKey" 
                                        v-model="raAnswer.ra_s14_yn.q8"
                                        v-bind:action_plan.sync = "raAnswer.ra_s14_yn.q8_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s14q8"
                                        v-bind:id="'raAnswer.ra_s14_yn.q8'"
                                        v-bind:question="getQuestion('s14q8')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s14q8_yn'+componentKey"
                                        v-model="raAnswer.ra_s14_answer.q8"
                                        v-if="raAnswer.ra_s14_yn.q8 !== null"
                                        v-bind:qid="'s14q8'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s14q8_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s14_comment.q8"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s14q8_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s14_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s14_images_to_delete"
                                        v-bind:questionId="8"
                                ></question-photos>

                                <yes-no-na-button :key="'s14q9'+componentKey" 
                                        v-model="raAnswer.ra_s14_yn.q9"
                                        v-bind:action_plan.sync = "raAnswer.ra_s14_yn.q9_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s14q9"
                                        v-bind:id="'raAnswer.ra_s14_yn.q9'"
                                        v-bind:question="getQuestion('s14q9')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s14q9_yn'+componentKey"
                                        v-model="raAnswer.ra_s14_answer.q9"
                                        v-if="raAnswer.ra_s14_yn.q9 !== null"
                                        v-bind:qid="'s14q9'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s14q9_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s14_comment.q9"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s14q9_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s14_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s14_images_to_delete"
                                        v-bind:questionId="9"
                                ></question-photos>

                                <yes-no-na-button :key="'s14q10'+componentKey" 
                                        v-model="raAnswer.ra_s14_yn.q10"
                                        v-bind:action_plan.sync = "raAnswer.ra_s14_yn.q10_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s14q10"
                                        v-bind:id="'raAnswer.ra_s14_yn.q10'"
                                        v-bind:question="getQuestion('s14q10')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s14q9_yn'+componentKey"
                                        v-model="raAnswer.ra_s14_answer.q10"
                                        v-if="raAnswer.ra_s14_yn.q10 !== null"
                                        v-bind:qid="'s14q10'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s14q10_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s14_comment.q10"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s14q10_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s14_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s14_images_to_delete"
                                        v-bind:questionId="10"
                                ></question-photos>

                                <yes-no-na-button :key="'s14q11'+componentKey" 
                                        v-model="raAnswer.ra_s14_yn.q11"
                                        v-bind:action_plan.sync = "raAnswer.ra_s14_yn.q11_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s14q11"
                                        v-bind:id="'raAnswer.ra_s14_yn.q11'"
                                        v-bind:question="getQuestion('s14q11')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s14q11_yn'+componentKey"
                                        v-model="raAnswer.ra_s14_answer.q11"
                                        v-if="raAnswer.ra_s14_yn.q11 !== null"
                                        v-bind:qid="'s14q11'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s14q11_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s14_comment.q11"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s14q11_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s14_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s14_images_to_delete"
                                        v-bind:questionId="11"
                                ></question-photos>

                                <yes-no-na-button :key="'s14q12'+componentKey" 
                                        v-model="raAnswer.ra_s14_yn.q12"
                                        v-bind:action_plan.sync = "raAnswer.ra_s14_yn.q12_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s14q12"
                                        v-bind:id="'raAnswer.ra_s14_yn.q12'"
                                        v-bind:question="getQuestion('s14q12')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s14q12_yn'+componentKey"
                                        v-model="raAnswer.ra_s14_answer.q12"
                                        v-if="raAnswer.ra_s14_yn.q12 !== null"
                                        v-bind:qid="'s14q12'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s14q12_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s14_comment.q12"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s14q12_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s14_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s14_images_to_delete"
                                        v-bind:questionId="12"
                                ></question-photos>

                                <yes-no-na-button :key="'s14q13'+componentKey" 
                                        v-model="raAnswer.ra_s14_yn.q13"
                                        v-bind:action_plan.sync = "raAnswer.ra_s14_yn.q13_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s14q13"
                                        v-bind:id="'raAnswer.ra_s14_yn.q13'"
                                        v-bind:question="getQuestion('s14q13')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s14q13_yn'+componentKey"
                                        v-model="raAnswer.ra_s14_answer.q13"
                                        v-if="raAnswer.ra_s14_yn.q13 !== null"
                                        v-bind:qid="'s14q13'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s14q13_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s14_comment.q13"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s14q13_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s14_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s14_images_to_delete"
                                        v-bind:questionId="13"
                                ></question-photos>

                                <yes-no-na-button :key="'s14q14'+componentKey" 
                                        v-model="raAnswer.ra_s14_yn.q14"
                                        v-bind:action_plan.sync = "raAnswer.ra_s14_yn.q14_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s14q14"
                                        v-bind:id="'raAnswer.ra_s14_yn.q14'"
                                        v-bind:question="getQuestion('s14q14')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s14q14_yn'+componentKey"
                                        v-model="raAnswer.ra_s14_answer.q14"
                                        v-if="raAnswer.ra_s14_yn.q14 !== null"
                                        v-bind:qid="'s14q14'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s14q14_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s14_comment.q14"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s14q14_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s14_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s14_images_to_delete"
                                        v-bind:questionId="14"
                                ></question-photos>

                                <div class="em-separator separator-dashed"></div>

                                <h4><strong>{{getSectionTitle(15)}}</strong></h4>

                                <yes-no-na-button :key="'s15q1'+componentKey" 
                                        v-model="raAnswer.ra_s15_yn.q1"
                                        v-bind:action_plan.sync = "raAnswer.ra_s15_yn.q1_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s15q1"
                                        v-bind:id="'raAnswer.ra_s15_yn.q1'"
                                        v-bind:question="getQuestion('s15q1')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s15q1_yn'+componentKey"
                                        v-model="raAnswer.ra_s15_answer.q1"
                                        v-if="raAnswer.ra_s15_yn.q1 !== null"
                                        v-bind:qid="'s15q1'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s15q1_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s15_comment.q1"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s15q1_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s15_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s15_images_to_delete"
                                        v-bind:questionId="1"
                                ></question-photos>

                                <yes-no-na-button :key="'s15q2'+componentKey" 
                                        v-model="raAnswer.ra_s15_yn.q2"
                                        v-bind:action_plan.sync = "raAnswer.ra_s15_yn.q2_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s15q2"
                                        v-bind:id="'raAnswer.ra_s15_yn.q2'"
                                        v-bind:question="getQuestion('s15q2')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s15q2_yn'+componentKey"
                                        v-model="raAnswer.ra_s15_answer.q2"
                                        v-if="raAnswer.ra_s15_yn.q2 !== null"
                                        v-bind:qid="'s15q2'"
                                        v-bind:value="raAnswer.ra_s15_answer.q2"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s15q2_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s15_comment.q2"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s15q2_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s15_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s15_images_to_delete"
                                        v-bind:questionId="2"
                                ></question-photos>

                                <yes-no-na-button :key="'s15q3'+componentKey" 
                                        v-model="raAnswer.ra_s15_yn.q3"
                                        v-bind:action_plan.sync = "raAnswer.ra_s15_yn.q3_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s15q3"
                                        v-bind:id="'raAnswer.ra_s15_yn.q3'"
                                        v-bind:question="getQuestion('s15q3')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s15q3_yn'+componentKey"
                                        v-model="raAnswer.ra_s15_answer.q3"
                                        v-if="raAnswer.ra_s15_yn.q3 !== null"
                                        v-bind:qid="'s15q3'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s15q3_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s15_comment.q3"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s15q3_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s15_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s15_images_to_delete"
                                        v-bind:questionId="3"
                                ></question-photos>

                                <yes-no-na-button :key="'s15q4'+componentKey" 
                                        v-model="raAnswer.ra_s15_yn.q4"
                                        v-bind:action_plan.sync = "raAnswer.ra_s15_yn.q4_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s15q4"
                                        v-bind:id="'raAnswer.ra_s15_yn.q4'"
                                        v-bind:question="getQuestion('s15q4')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s15q4_yn'+componentKey"
                                        v-model="raAnswer.ra_s15_answer.q4"
                                        v-if="raAnswer.ra_s15_yn.q4 !== null"
                                        v-bind:qid="'s15q4'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s15q4_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s15_comment.q4"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s15q4_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s15_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s15_images_to_delete"
                                        v-bind:questionId="4"
                                ></question-photos>

                                <yes-no-na-button :key="'s15q5'+componentKey" 
                                        v-model="raAnswer.ra_s15_yn.q5"
                                        v-bind:action_plan.sync = "raAnswer.ra_s15_yn.q5_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s15q5"
                                        v-bind:id="'raAnswer.ra_s15_yn.q5'"
                                        v-bind:question="getQuestion('s15q5')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s15q5_yn'+componentKey"
                                        v-model="raAnswer.ra_s15_answer.q5"
                                        v-if="raAnswer.ra_s15_yn.q5 !== null"
                                        v-bind:qid="'s15q5'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s15q5_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s15_comment.q5"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s15q5_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s15_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s15_images_to_delete"
                                        v-bind:questionId="5"
                                ></question-photos>

                                <div class="em-separator separator-dashed"></div>

                                <h4><strong>{{getSectionTitle(16)}}</strong></h4>

                                <yes-no-na-button :key="'s16q1'+componentKey" 
                                        v-model="raAnswer.ra_s16_yn.q1"
                                        v-bind:action_plan.sync = "raAnswer.ra_s16_yn.q1_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s16q1"
                                        v-bind:id="'raAnswer.ra_s16_yn.q1'"
                                        v-bind:question="getQuestion('s16q1')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s16q1_yn'+componentKey"
                                        v-model="raAnswer.ra_s16_answer.q1"
                                        v-if="raAnswer.ra_s16_yn.q1 !== null"
                                        v-bind:qid="'s16q1'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s16q1_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s16_comment.q1"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s16q1_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s16_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s16_images_to_delete"
                                        v-bind:questionId="1"
                                ></question-photos>

                                <yes-no-na-button :key="'s16q2'+componentKey" 
                                        v-model="raAnswer.ra_s16_yn.q2"
                                        v-bind:action_plan.sync = "raAnswer.ra_s16_yn.q2_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s16q2"
                                        v-bind:id="'raAnswer.ra_s16_yn.q2'"
                                        v-bind:question="getQuestion('s16q2')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s16q2_yn'+componentKey"
                                        v-model="raAnswer.ra_s16_answer.q2"
                                        v-if="raAnswer.ra_s16_yn.q2 !== null"
                                        v-bind:qid="'s16q2'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s16q2_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s16_comment.q2"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s16q2_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s16_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s16_images_to_delete"
                                        v-bind:questionId="2"
                                ></question-photos>

                                <yes-no-na-button :key="'s16q3'+componentKey" 
                                        v-model="raAnswer.ra_s16_yn.q3"
                                        v-bind:action_plan.sync = "raAnswer.ra_s16_yn.q3_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s16q3"
                                        v-bind:id="'raAnswer.ra_s16_yn.q3'"
                                        v-bind:question="getQuestion('s16q3')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s16q3_yn'+componentKey"
                                        v-model="raAnswer.ra_s16_answer.q3"
                                        v-if="raAnswer.ra_s16_yn.q3 !== null"
                                        v-bind:qid="'s16q3'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s16q3_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s16_comment.q3"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s16q3_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s16_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s16_images_to_delete"
                                        v-bind:questionId="3"
                                ></question-photos>

                                <yes-no-na-button :key="'s16q4'+componentKey" 
                                        v-model="raAnswer.ra_s16_yn.q4"
                                        v-bind:action_plan.sync = "raAnswer.ra_s16_yn.q4_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s16q4"
                                        v-bind:id="'raAnswer.ra_s16_yn.q4'"
                                        v-bind:question="getQuestion('s16q4')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s16q4_yn'+componentKey"
                                        v-model="raAnswer.ra_s16_answer.q4"
                                        v-if="raAnswer.ra_s16_yn.q4 !== null"
                                        v-bind:qid="'s16q4'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s16q4_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s16_comment.q4"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s16q4_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s16_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s16_images_to_delete"
                                        v-bind:questionId="4"
                                ></question-photos>

                                <div class="em-separator separator-dashed"></div>

                                <h4><strong>{{getSectionTitle(17)}}</strong></h4>

                                <yes-no-na-button :key="'s17q1'+componentKey" 
                                        v-model="raAnswer.ra_s17_yn.q1"
                                        v-bind:action_plan.sync = "raAnswer.ra_s17_yn.q1_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s17q1"
                                        v-bind:id="'raAnswer.ra_s17_yn.q1'"
                                        v-bind:question="getQuestion('s17q1')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s17q1_yn'+componentKey"
                                        v-model="raAnswer.ra_s17_answer.q1"
                                        v-if="raAnswer.ra_s17_yn.q1 !== null"
                                        v-bind:qid="'s17q1'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s17q1_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s17_comment.q1"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s17q1_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s17_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s17_images_to_delete"
                                        v-bind:questionId="1"
                                ></question-photos>

                                <yes-no-na-button :key="'s17q2'+componentKey" 
                                        v-model="raAnswer.ra_s17_yn.q2"
                                        v-bind:action_plan.sync = "raAnswer.ra_s17_yn.q2_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s17q2"
                                        v-bind:id="'raAnswer.ra_s17_yn.q2'"
                                        v-bind:question="getQuestion('s17q2')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s17q2_yn'+componentKey"
                                        v-model="raAnswer.ra_s17_answer.q2"
                                        v-if="raAnswer.ra_s17_yn.q2 !== null"
                                        v-bind:qid="'s17q2'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s17q2_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s17_comment.q2"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s17q2_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s17_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s17_images_to_delete"
                                        v-bind:questionId="2"
                                ></question-photos>

                                <yes-no-na-button :key="'s17q3'+componentKey" 
                                        v-model="raAnswer.ra_s17_yn.q3"
                                        v-bind:action_plan.sync = "raAnswer.ra_s17_yn.q3_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s17q3"
                                        v-bind:id="'raAnswer.ra_s17_yn.q3'"
                                        v-bind:question="getQuestion('s17q3')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s17q3_yn'+componentKey"
                                        v-model="raAnswer.ra_s17_answer.q3"
                                        v-if="raAnswer.ra_s17_yn.q3 !== null"
                                        v-bind:qid="'s17q3'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s17q3_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s17_comment.q3"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s17q3_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s17_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s17_images_to_delete"
                                        v-bind:questionId="3"
                                ></question-photos>

                                <yes-no-na-button :key="'s17q4'+componentKey" 
                                        v-model="raAnswer.ra_s17_yn.q4"
                                        v-bind:action_plan.sync = "raAnswer.ra_s17_yn.q4_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s17q4"
                                        v-bind:id="'raAnswer.ra_s17_yn.q4'"
                                        v-bind:question="getQuestion('s17q4')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s17q4_yn'+componentKey"
                                        v-model="raAnswer.ra_s17_answer.q4"
                                        v-if="raAnswer.ra_s17_yn.q4 !== null"
                                        v-bind:qid="'s17q4'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s17q4_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s17_comment.q4"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s17q4_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s17_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s17_images_to_delete"
                                        v-bind:questionId="4"
                                ></question-photos>

                                <yes-no-na-button :key="'s17q5'+componentKey" 
                                        v-model="raAnswer.ra_s17_yn.q5"
                                        v-bind:action_plan.sync = "raAnswer.ra_s17_yn.q5_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s17q5"
                                        v-bind:id="'raAnswer.ra_s17_yn.q5'"
                                        v-bind:question="getQuestion('s17q5')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s17q5_yn'+componentKey"
                                        v-model="raAnswer.ra_s17_answer.q5"
                                        v-if="raAnswer.ra_s17_yn.q5 !== null"
                                        v-bind:qid="'s17q5'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s17q5_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s17_comment.q5"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s17q5_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s17_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s17_images_to_delete"
                                        v-bind:questionId="5"
                                ></question-photos>

                                <yes-no-na-button :key="'s17q6'+componentKey" 
                                        v-model="raAnswer.ra_s17_yn.q6"
                                        v-bind:action_plan.sync = "raAnswer.ra_s17_yn.q6_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s17q6"
                                        v-bind:id="'raAnswer.ra_s17_yn.q6'"
                                        v-bind:question="getQuestion('s17q6')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s17q6_yn'+componentKey"
                                        v-model="raAnswer.ra_s17_answer.q6"
                                        v-if="raAnswer.ra_s17_yn.q6 !== null"
                                        v-bind:qid="'s17q6'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s17q6_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s17_comment.q6"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s17q6_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s17_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s17_images_to_delete"
                                        v-bind:questionId="6"
                                ></question-photos>

                                <yes-no-na-button :key="'s17q7'+componentKey" 
                                        v-model="raAnswer.ra_s17_yn.q7"
                                        v-bind:action_plan.sync = "raAnswer.ra_s17_yn.q7_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s17q7"
                                        v-bind:id="'raAnswer.ra_s17_yn.q7'"
                                        v-bind:question="getQuestion('s17q7')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s17q7_yn'+componentKey"
                                        v-model="raAnswer.ra_s17_answer.q7"
                                        v-if="raAnswer.ra_s17_yn.q7 !== null"
                                        v-bind:qid="'s17q7'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s17q7_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s17_comment.q7"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s17q7_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s17_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s17_images_to_delete"
                                        v-bind:questionId="7"
                                ></question-photos>

                                <yes-no-na-button :key="'s17q8'+componentKey" 
                                        v-model="raAnswer.ra_s17_yn.q8"
                                        v-bind:action_plan.sync = "raAnswer.ra_s17_yn.q8_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s17q8"
                                        v-bind:id="'raAnswer.ra_s17_yn.q8'"
                                        v-bind:question="getQuestion('s17q8')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s17q8_yn'+componentKey"
                                        v-model="raAnswer.ra_s17_answer.q8"
                                        v-if="raAnswer.ra_s17_yn.q8 !== null"
                                        v-bind:qid="'s17q8'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s17q8_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s17_comment.q8"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s17q8_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s17_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s17_images_to_delete"
                                        v-bind:questionId="8"
                                ></question-photos>

                                <yes-no-na-button :key="'s17q9'+componentKey" 
                                        v-model="raAnswer.ra_s17_yn.q9"
                                        v-bind:action_plan.sync = "raAnswer.ra_s17_yn.q9_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s17q9"
                                        v-bind:id="'raAnswer.ra_s17_yn.q9'"
                                        v-bind:question="getQuestion('s17q9')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s17q9_yn'+componentKey"
                                        v-model="raAnswer.ra_s17_answer.q9"
                                        v-if="raAnswer.ra_s17_yn.q9 !== null"
                                        v-bind:qid="'s17q9'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s17q9_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s17_comment.q9"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s17q9_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s17_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s17_images_to_delete"
                                        v-bind:questionId="9"
                                ></question-photos>

                                <yes-no-na-button :key="'s17q10'+componentKey" 
                                        v-model="raAnswer.ra_s17_yn.q10"
                                        v-bind:action_plan.sync = "raAnswer.ra_s17_yn.q10_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s17q10"
                                        v-bind:id="'raAnswer.ra_s17_yn.q10'"
                                        v-bind:question="getQuestion('s17q10')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s17q19_yn'+componentKey"
                                        v-model="raAnswer.ra_s17_answer.q10"
                                        v-if="raAnswer.ra_s17_yn.q10 !== null"
                                        v-bind:qid="'s17q10'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s17q10_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s17_comment.q10"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s17q10_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s17_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s17_images_to_delete"
                                        v-bind:questionId="10"
                                ></question-photos>

                                <yes-no-na-button :key="'s17q11'+componentKey" 
                                        v-model="raAnswer.ra_s17_yn.q11"
                                        v-bind:action_plan.sync = "raAnswer.ra_s17_yn.q11_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s17q11"
                                        v-bind:id="'raAnswer.ra_s17_yn.q11'"
                                        v-bind:question="getQuestion('s17q11')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s17q11_yn'+componentKey"
                                        v-model="raAnswer.ra_s17_answer.q11"
                                        v-if="raAnswer.ra_s17_yn.q11 !== null"
                                        v-bind:qid="'s17q11'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s17q11_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s17_comment.q11"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s17q11_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s17_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s17_images_to_delete"
                                        v-bind:questionId="11"
                                ></question-photos>

                                <div class="em-separator separator-dashed"></div>

                                <h4><strong>{{getSectionTitle(18)}}</strong></h4>

                                <yes-no-na-button :key="'s18q1'+componentKey" 
                                        v-model="raAnswer.ra_s18_yn.q1"
                                        v-bind:action_plan.sync = "raAnswer.ra_s18_yn.q1_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s18q1"
                                        v-bind:id="'raAnswer.ra_s18_yn.q1'"
                                        v-bind:question="getQuestion('s18q1')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s18q1_yn'+componentKey"
                                        v-model="raAnswer.ra_s18_answer.q1"
                                        v-if="raAnswer.ra_s18_yn.q1 !== null"
                                        v-bind:qid="'s18q1'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s18q1_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s18_comment.q1"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s18q1_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s18_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s18_images_to_delete"
                                        v-bind:questionId="1"
                                ></question-photos>

                                <yes-no-na-button :key="'s18q2'+componentKey" 
                                        v-model="raAnswer.ra_s18_yn.q2"
                                        v-bind:action_plan.sync = "raAnswer.ra_s18_yn.q2_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s18q2"
                                        v-bind:id="'raAnswer.ra_s18_yn.q2'"
                                        v-bind:question="getQuestion('s18q2')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s18q2_yn'+componentKey"
                                        v-model="raAnswer.ra_s18_answer.q2"
                                        v-if="raAnswer.ra_s18_yn.q2 !== null"
                                        v-bind:qid="'s18q2'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s18q2_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s18_comment.q2"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s18q2_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s18_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s18_images_to_delete"
                                        v-bind:questionId="2"
                                ></question-photos>

                                <yes-no-na-button :key="'s18q3'+componentKey" 
                                        v-model="raAnswer.ra_s18_yn.q3"
                                        v-bind:action_plan.sync = "raAnswer.ra_s18_yn.q3_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s18q3"
                                        v-bind:id="'raAnswer.ra_s18_yn.q3'"
                                        v-bind:question="getQuestion('s18q3')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s18q3_yn'+componentKey"
                                        v-model="raAnswer.ra_s18_answer.q3"
                                        v-if="raAnswer.ra_s18_yn.q3 !== null"
                                        v-bind:qid="'s18q3'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s18q3_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s18_comment.q3"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s18q3_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s18_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s18_images_to_delete"
                                        v-bind:questionId="3"
                                ></question-photos>

                                <yes-no-na-button :key="'s18q4'+componentKey" 
                                        v-model="raAnswer.ra_s18_yn.q4"
                                        v-bind:action_plan.sync = "raAnswer.ra_s18_yn.q4_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s18q4"
                                        v-bind:id="'raAnswer.ra_s18_yn.q4'"
                                        v-bind:question="getQuestion('s18q4')"
                                        v-bind:note="'Examples include passing of pipes between rooms, cable holes or other systems penetrating the original design.'"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s18q4_yn'+componentKey"
                                        v-model="raAnswer.ra_s18_answer.q4"
                                        v-if="raAnswer.ra_s18_yn.q4 !== null"
                                        v-bind:qid="'s18q4'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s18q4_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s18_comment.q4"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s18q4_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s18_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s18_images_to_delete"
                                        v-bind:questionId="4"
                                ></question-photos>

                                <yes-no-na-button :key="'s18q5'+componentKey" 
                                        v-model="raAnswer.ra_s18_yn.q5"
                                        v-bind:action_plan.sync = "raAnswer.ra_s18_yn.q5_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s18q5"
                                        v-bind:id="'raAnswer.ra_s18_yn.q5'"
                                        v-bind:question="getQuestion('s18q5')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s18q5_yn'+componentKey"
                                        v-model="raAnswer.ra_s18_answer.q5"
                                        v-if="raAnswer.ra_s18_yn.q5 !== null"
                                        v-bind:qid="'s18q5'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s18q5_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s18_comment.q5"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s18q5_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s18_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s18_images_to_delete"
                                        v-bind:questionId="5"
                                ></question-photos>

                                <yes-no-na-button :key="'s18q6'+componentKey" 
                                        v-model="raAnswer.ra_s18_yn.q6"
                                        v-bind:action_plan.sync = "raAnswer.ra_s18_yn.q6_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s18q6"
                                        v-bind:id="'raAnswer.ra_s18_yn.q6'"
                                        v-bind:question="getQuestion('s18q6')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s18q6_yn'+componentKey"
                                        v-model="raAnswer.ra_s18_answer.q6"
                                        v-if="raAnswer.ra_s18_yn.q6!== null"
                                        v-bind:qid="'s18q6'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s18q6_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s18_comment.q6"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s18q6_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s18_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s18_images_to_delete"
                                        v-bind:questionId="6"
                                ></question-photos>

                                <div class="em-separator separator-dashed"></div>

                                <h4><strong>{{getSectionTitle(19)}}</strong></h4>

                                <yes-no-na-button :key="'s19q1'+componentKey" 
                                        v-model="raAnswer.ra_s19_yn.q1"
                                        v-bind:action_plan.sync = "raAnswer.ra_s19_yn.q1_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s19q1"
                                        v-bind:id="'raAnswer.ra_s19_yn.q1'"
                                        v-bind:question="getQuestion('s19q1')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s19q1_yn'+componentKey"
                                        v-model="raAnswer.ra_s19_answer.q1"
                                        v-if="raAnswer.ra_s19_yn.q1!== null"
                                        v-bind:qid="'s19q1'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s19q1_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s19_comment.q1"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s19q1_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s19_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s19_images_to_delete"
                                        v-bind:questionId="1"
                                ></question-photos>

                                <yes-no-na-button :key="'s19q2'+componentKey" 
                                        v-model="raAnswer.ra_s19_yn.q2"
                                        v-bind:action_plan.sync = "raAnswer.ra_s19_yn.q2_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s19q2"
                                        v-bind:id="'raAnswer.ra_s19_yn.q2'"
                                        v-bind:question="getQuestion('s19q2')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s19q2_yn'+componentKey"
                                        v-model="raAnswer.ra_s19_answer.q2"
                                        v-if="raAnswer.ra_s19_yn.q2!== null"
                                        v-bind:qid="'s19q2'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s19q2_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s19_comment.q2"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s19q2_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s19_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s19_images_to_delete"
                                        v-bind:questionId="2"
                                ></question-photos>

                                <yes-no-na-button :key="'s19q3'+componentKey" 
                                        v-model="raAnswer.ra_s19_yn.q3"
                                        v-bind:action_plan.sync = "raAnswer.ra_s19_yn.q3_add_ap"
                                        v-bind:hide_qn.sync = "raAnswer.ra_hidden_question.s19q3"
                                        v-bind:id="'raAnswer.ra_s19_yn.q3'"
                                        v-bind:question="getQuestion('s19q3')"
                                >
                                </yes-no-na-button>
                                <yes-no-na-comment
                                        :key="'s19q3_yn'+componentKey"
                                        v-model="raAnswer.ra_s19_answer.q3"
                                        v-if="raAnswer.ra_s19_yn.q3!== null"
                                        v-bind:qid="'s19q3'"
                                ></yes-no-na-comment>
                                <additional-comment
                                        :key="'s19q3_additional_comment'+componentKey"
                                        v-model="raAnswer.ra_s19_comment.q3"
                                ></additional-comment>

                                <question-photos 
                                        :key="'s19q3_photos'+componentKey"
                                        v-bind:sectionImages="raAnswer.ra_s19_images"
                                        v-bind:imagesToDelete="raAnswer.ra_s19_images_to_delete"
                                        v-bind:questionId="3"
                                ></question-photos>

                            </div>
                        </div>
                    </div>
                </div>

                <div class="row" v-if="openTab === 5">
                    <div class="col-sm-12 widget-20">
                        <div class="widget has-shadow">
                            <div class="widget-header bordered d-flex align-items-center section-header">
                                <h2>Photos</h2>
                            </div>
                            <div class="widget-body">
                                <div class="row">
                                    <div class="col-md-12">

                                        <div v-if="raAnswer.ra_photos !== undefined && raAnswer.ra_photos.length > 0" class="border mb-5 pt-3 pl-3 pr-3 pb-3">
                                            <div class="row">
                                                <div class="col-sm-3 pb-3 entity-row-6" v-for="raPhoto in raAnswer.ra_photos" style="margin-bottom: 10px;">
                                                    <img v-bind:src="raPhoto.photo_url" class="img-fluid">
                                                </div>
                                            </div>

                                            <div style="clear: both;"></div>
                                        </div>

                                        <div v-if="raAnswer.offline_images.length > 0" class="border mb-5 pt-3 pl-3 pr-3 pb-3">
                                            <div class="alert alert-warning">Images in this section have not yet been synced with the server.</div>
                                                
                                                <div class="row">
                                                    <div class="col-sm-3 pb-3 entity-row-6" v-for="(offlineImage, index) in raAnswer.offline_images" style="margin-bottom: 10px;">
                                                        <img v-bind:src="offlineImage.data" class="img-fluid">
                                                        <div class="image-actions">
                                                            <button v-on:click="rotatePhoto(index,-90)" :disabled="modifyingPhoto" class="btn btn-primary btn-xs btn-square" title="Rotate Anti-clockwise"><i class="fa fa-undo"></i></button>
                                                            <button v-on:click="rotatePhoto(index,90)" :disabled="modifyingPhoto" class="btn btn-primary btn-xs btn-square" title="Rotate Clockwise"><i class="fa fa-undo fa-flip-horizontal"></i></button>
                                                        </div>
                                                        <button v-on:click="removePhoto(index)" :disabled="modifyingPhoto" class="btn btn-outline-danger btn-square mt-3 w-100">Remove Photo</button>
                                                    </div>
                                                </div>
                                                
                                                

                                            <div style="clear: both;"></div>
                                        </div>

                                        <div v-if="isImageUploading" style="background: #eaeaea; padding: 10px; margin: 10px 0;">
                                            <h3><span class="fa fa-spin fa-circle-notch"></span>
                                                Adding image... Please wait...</h3>
                                        </div>
                                        <label class="fileContainer additionalFileButton">
                                            <span class="fa fa-camera"></span> Click to add an image
                                            <input type="file" accept="image/*" @change="onPhotoChange" multiple>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row flex-row">

                    <div class="col-md-12 col-lg-2">
                        <div class="widget widget-12 has-shadow c-pointer" v-on:click="openTab = 1" v-bind:class="openTab === 1 ? 'bg-primary': ''">
                            <div class="widget-body">
                                <div class="media">
                                    <div class="number">Assessment Overview</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12 col-lg-2">
                        <div class="widget widget-12 has-shadow c-pointer" v-on:click="openTab = 2" v-bind:class="openTab === 2 ? 'bg-primary': ''">
                            <div class="widget-body">
                                <div class="media">
                                    <div class="number">Management of Fire Safety</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12 col-lg-2">
                        <div class="widget widget-12 has-shadow c-pointer" v-on:click="openTab = 3" v-bind:class="openTab === 3 ? 'bg-primary': ''">
                            <div class="widget-body">
                                <div class="media">
                                    <div class="number">Fire Hazards and Dangerous Substances</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12 col-lg-2">
                        <div class="widget widget-12 has-shadow c-pointer" v-on:click="openTab = 4" v-bind:class="openTab === 4 ? 'bg-primary': ''">
                            <div class="widget-body">
                                <div class="media">
                                    <div class="number">General Fire Precautions</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12 col-lg-2">
                        <div class="widget widget-12 has-shadow c-pointer" v-on:click="openTab = 5" v-bind:class="openTab === 5 ? 'bg-primary': ''">
                            <div class="widget-body">
                                <div class="media">
                                    <div class="number">Photos</div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="row">
                    <div class="col-sm-12">

                        <div class="form-group">
                            <button type="submit" class="btn btn-primary btn-square btn-lg w-100" :disabled="submitting">
                                <span v-if="submitting">Submitting... <i class="fa fa-circle-notch fa-spin"></i></span>
                                <span v-else>Save</span>
                            </button>
                        </div>

                    </div>
                </div>



            </div>
        </form>





    </div>
</template>

<script>
    import { required } from 'vuelidate/lib/validators'
    import YesNoNa from '@/components/YesNoNa.vue'
    import YesNoNaButton from '@/components/YesNoNaButton.vue'
    import YesNoNaComment from '@/components/YesNoNaComment.vue'
    import TextDropdownField from '@/components/TextDropdownField.vue'
    import AdditionalComment from '@/components/AdditionalComment.vue'
    import ImageRotate from '@/components/mixins/ImageRotate.js'
    import Multiselect from 'vue-multiselect'

    import moment from 'moment';
    import Datepicker from 'vuejs-datepicker';
    import QuestionPhotos from '../components/QuestionPhotos.vue';
    import PageLeaveConfirm from '@/components/mixins/PageLeaveConfirm.js';

    var Compress = require('compress.js');
    var EXIF = require('exif-js');

    export default {
        components: {
            Datepicker,
            YesNoNa,
            YesNoNaButton,
            YesNoNaComment,
            TextDropdownField,
            AdditionalComment,
            Multiselect,
            QuestionPhotos,
        },
        mixins: [ImageRotate,PageLeaveConfirm],
        data() {
            return {
                componentKey: 0,
                openTab: 1,
                isSubmitted: false,
                errorHeader: false,
                addingEngineerSignature: false,
                addingClientSignature: false,
                isEdit: false,

                s6safetyPolicyReportText: 'NB: A Fire Safety Policy provides an organisation with direction and clear guidelines on all fire safety issues, demonstrating a commitment to the safety and welfare of staff and ensuring compliance with Fire Safety and Health and Safety Regulations. A Fire Safety Policy must be devised, written and made available to staff and Inspecting Officers from enforcing authorities. The Policy should set objectives that can be monitored to ensure compliance with regulations and be reviewed on a regular basis.',


                raAnswer: {
                    ra_hidden_question: {
                        s1q1: false,
                        s1q2: false,
                        s1q3: false,
                        s1q4: false,
                        s2q1: false,
                        s2q2: false,
                        s2q3: false,
                        s2q4: false,
                        s2q5: false,
                        s3q1: false,
                        s3q2: false,
                        s4q1: false,
                        s4q2: false,
                        s4q3: false,
                        s4q4: false,
                        s4q5: false,
                        s4q6: false,
                        s4q7: false,
                        s4q8: false,
                        s4q9: false,
                        s4q10: false,
                        s4q11: false,
                        s4q12: false,
                        s4q13: false,
                        s4q14: false,
                        s4q15: false,
                        s4q16: false,
                        s4q17: false,
                        s4q18: false,
                        s4q19: false,
                        s4q20: false,
                        s4q21: false,
                        s4q22: false,
                        s4q23: false,
                        s4q24: false,
                        s4q25: false,
                        s4q26: false,
                        s4q27: false,
                        s5q1: false,
                        s6q1: false,
                        s6q2: false,
                        s6q3: false,
                        s6q4: false,
                        s7q1: false,
                        s7q2: false,
                        s7q3: false,
                        s7q4: false,
                        s7q5: false,
                        s7q6: false,
                        s7q7: false,
                        s7q8: false,
                        s7q9: false,
                        s8q1: false,
                        s8q2: false,
                        s8q3: false,
                        s8q4: false,
                        s8q5: false,
                        s8q6: false,
                        s8q7: false,
                        s9q1: false,
                        s9q2: false,
                        s9q3: false,
                        s10q1: false,
                        s10q2: false,
                        s10q3: false,
                        s10q4: false,
                        s10q5: false,
                        s10q6: false,
                        s10q7: false,
                        s10q8: false,
                        s10q9: false,
                        s10q10: false,
                        s10q11: false,
                        s10q12: false,
                        s10q13: false,
                        s10q14: false,
                        s10q15: false,
                        s10q16: false,
                        s10q17: false,
                        s10q18: false,
                        s10q19: false,
                        s10q20: false,
                        s10q21: false,
                        s10q22: false,
                        s10q23: false,
                        s10q24: false,
                        s11q1: false,
                        s11q2: false,
                        s11q3: false,
                        s11q4: false,
                        s11q5: false,
                        s11q6: false,
                        s11q7: false,
                        s11q8: false,
                        s11q9: false,
                        s11q10: false,
                        s11q11: false,
                        s11q12: false,
                        s11q13: false,
                        s12q1: false,
                        s12q2: false,
                        s12q3: false,
                        s12q4: false,
                        s12q5: false,
                        s12q6: false,
                        s12q7: false,
                        s12q8: false,
                        s12q9: false,
                        s12q10: false,
                        s13q1: false,
                        s13q2: false,
                        s13q3: false,
                        s13q4: false,
                        s13q5: false,
                        s13q6: false,
                        s13q7: false,
                        s13q8: false,
                        s13q9: false,
                        s13q10: false,
                        s14q1: false,
                        s14q2: false,
                        s14q3: false,
                        s14q4: false,
                        s14q5: false,
                        s14q6: false,
                        s14q7: false,
                        s14q8: false,
                        s14q9: false,
                        s14q10: false,
                        s14q11: false,
                        s14q12: false,
                        s14q13: false,
                        s14q14: false,
                        s15q1: false,
                        s15q2: false,
                        s15q3: false,
                        s15q4: false,
                        s15q5: false,
                        s16q1: false,
                        s16q2: false,
                        s16q3: false,
                        s16q4: false,
                        s17q1: false,
                        s17q2: false,
                        s17q3: false,
                        s17q4: false,
                        s17q5: false,
                        s17q6: false,
                        s17q7: false,
                        s17q8: false,
                        s17q9: false,
                        s17q10: false,
                        s17q11: false,
                        s18q1: false,
                        s18q2: false,
                        s18q3: false,
                        s18q4: false,
                        s18q5: false,
                        s18q6: false,
                        s19q1: false,
                        s19q2: false,
                        s19q3: false
                    },
                    ra_s1_images: [],
                    ra_s2_images: [],
                    ra_s3_images: [],
                    ra_s4_images: [],
                    ra_s5_images: [],
                    ra_s6_images: [],
                    ra_s7_images: [],
                    ra_s8_images: [],
                    ra_s9_images: [],
                    ra_s10_images: [],
                    ra_s11_images: [],
                    ra_s12_images: [],
                    ra_s13_images: [],
                    ra_s14_images: [],
                    ra_s15_images: [],
                    ra_s16_images: [],
                    ra_s17_images: [],
                    ra_s18_images: [],
                    ra_s19_images: [],
                    offline_images: [],
                    ra_s1_images_to_delete: [],
                    ra_s2_images_to_delete: [],
                    ra_s3_images_to_delete: [],
                    ra_s4_images_to_delete: [],
                    ra_s5_images_to_delete: [],
                    ra_s6_images_to_delete: [],
                    ra_s7_images_to_delete: [],
                    ra_s8_images_to_delete: [],
                    ra_s9_images_to_delete: [],
                    ra_s10_images_to_delete: [],
                    ra_s11_images_to_delete: [],
                    ra_s12_images_to_delete: [],
                    ra_s13_images_to_delete: [],
                    ra_s14_images_to_delete: [],
                    ra_s15_images_to_delete: [],
                    ra_s16_images_to_delete: [],
                    ra_s17_images_to_delete: [],
                    ra_s18_images_to_delete: [],
                    ra_s19_images_to_delete: [],
                    ra_s19_yn: {
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q5: null,
                        q6: null,
                        q7: null,
                        q8: null,
                        q9: null,
                        q10: null,
                        q11: null,
                        q12: null,
                        q1_add_ap: false,
                        q2_add_ap: false,
                        q3_add_ap: false,
                        q4_add_ap: false,
                        q5_add_ap: false,
                        q6_add_ap: false,
                        q7_add_ap: false,
                        q8_add_ap: false,
                        q9_add_ap: false,
                        q10_add_ap: false,
                        q11_add_ap: false,
                        q12_add_ap: false
                    },
                    ra_s18_yn: {
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q5: null,
                        q6: null,
                        q7: null,
                        q8: null,
                        q9: null,
                        q10: null,
                        q11: null,
                        q12: null,
                        q1_add_ap: false,
                        q2_add_ap: false,
                        q3_add_ap: false,
                        q4_add_ap: false,
                        q5_add_ap: false,
                        q6_add_ap: false,
                        q7_add_ap: false,
                        q8_add_ap: false,
                        q9_add_ap: false,
                        q10_add_ap: false,
                        q11_add_ap: false,
                        q12_add_ap: false
                    },
                    ra_s17_yn: {
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q5: null,
                        q6: null,
                        q7: null,
                        q8: null,
                        q9: null,
                        q10: null,
                        q11: null,
                        q12: null,
                        q1_add_ap: false,
                        q2_add_ap: false,
                        q3_add_ap: false,
                        q4_add_ap: false,
                        q5_add_ap: false,
                        q6_add_ap: false,
                        q7_add_ap: false,
                        q8_add_ap: false,
                        q9_add_ap: false,
                        q10_add_ap: false,
                        q11_add_ap: false,
                        q12_add_ap: false
                    },
                    ra_s16_yn: {
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q5: null,
                        q6: null,
                        q7: null,
                        q8: null,
                        q9: null,
                        q10: null,
                        q11: null,
                        q12: null,
                        q1_add_ap: false,
                        q2_add_ap: false,
                        q3_add_ap: false,
                        q4_add_ap: false,
                        q5_add_ap: false,
                        q6_add_ap: false,
                        q7_add_ap: false,
                        q8_add_ap: false,
                        q9_add_ap: false,
                        q10_add_ap: false,
                        q11_add_ap: false,
                        q12_add_ap: false
                    },
                    ra_s15_yn: {
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q5: null,
                        q1_add_ap: false,
                        q2_add_ap: false,
                        q3_add_ap: false,
                        q4_add_ap: false,
                        q5_add_ap: false
                    },
                    ra_s14_yn: {
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q5: null,
                        q6: null,
                        q7: null,
                        q8: null,
                        q9: null,
                        q10: null,
                        q11: null,
                        q12: null,
                        q1_add_ap: false,
                        q2_add_ap: false,
                        q3_add_ap: false,
                        q4_add_ap: false,
                        q5_add_ap: false,
                        q6_add_ap: false,
                        q7_add_ap: false,
                        q8_add_ap: false,
                        q9_add_ap: false,
                        q10_add_ap: false,
                        q11_add_ap: false,
                        q12_add_ap: false
                    },
                    ra_s13_yn: {
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q5: null,
                        q6: null,
                        q7: null,
                        q8: null,
                        q9: null,
                        q10: null,
                        q1_add_ap: false,
                        q2_add_ap: false,
                        q3_add_ap: false,
                        q4_add_ap: false,
                        q5_add_ap: false,
                        q6_add_ap: false,
                        q7_add_ap: false,
                        q8_add_ap: false,
                        q9_add_ap: false,
                        q10_add_ap: false
                    },
                    ra_s12_yn: {
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q5: null,
                        q6: null,
                        q7: null,
                        q8: null,
                        q9: null,
                        q10: null,
                        q11: null,
                        q1_add_ap: false,
                        q2_add_ap: false,
                        q3_add_ap: false,
                        q4_add_ap: false,
                        q5_add_ap: false,
                        q6_add_ap: false,
                        q7_add_ap: false,
                        q8_add_ap: false,
                        q9_add_ap: false,
                        q10_add_ap: false,
                        q11_add_ap: false
                    },
                    ra_s11_yn: {
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q5: null,
                        q6: null,
                        q7: null,
                        q8: null,
                        q9: null,
                        q10: null,
                        q11: null,
                        q12: null,
                        q13: null,
                        q1_add_ap: false,
                        q2_add_ap: false,
                        q3_add_ap: false,
                        q4_add_ap: false,
                        q5_add_ap: false,
                        q6_add_ap: false,
                        q7_add_ap: false,
                        q8_add_ap: false,
                        q9_add_ap: false,
                        q10_add_ap: false,
                        q11_add_ap: false,
                        q12_add_ap: false,
                        q13_add_ap: false
                    },
                    ra_s10_yn: {
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q5: null,
                        q6: null,
                        q7: null,
                        q8: null,
                        q9: null,
                        q10: null,
                        q11: null,
                        q12: null,
                        q13: null,
                        q14: null,
                        q15: null,
                        q16: null,
                        q17: null,
                        q18: null,
                        q19: null,
                        q20: null,
                        q21: null,
                        q22: null,
                        q23: null,
                        q24: null,
                        q1_add_ap: false,
                        q2_add_ap: false,
                        q3_add_ap: false,
                        q4_add_ap: false,
                        q5_add_ap: false,
                        q6_add_ap: false,
                        q7_add_ap: false,
                        q8_add_ap: false,
                        q9_add_ap: false,
                        q10_add_ap: false,
                        q11_add_ap: false,
                        q12_add_ap: false,
                        q13_add_ap: false,
                        q14_add_ap: false,
                        q15_add_ap: false,
                        q16_add_ap: false,
                        q17_add_ap: false,
                        q18_add_ap: false,
                        q19_add_ap: false,
                        q20_add_ap: false,
                        q21_add_ap: false,
                        q22_add_ap: false,
                        q23_add_ap: false,
                        q24_add_ap: false
                    },
                    ra_s9_yn: {
                        q1: null,
                        q2: null,
                        q3: null,
                        q1_add_ap: false,
                        q2_add_ap: false,
                        q3_add_ap: false
                    },
                    ra_s8_yn: {
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q5: null,
                        q6: null,
                        q7: null,
                        q8: null,
                        q1_add_ap: false,
                        q2_add_ap: false,
                        q3_add_ap: false,
                        q4_add_ap: false,
                        q5_add_ap: false,
                        q6_add_ap: false,
                        q7_add_ap: false,
                        q8_add_ap: false
                    },
                    ra_s7_yn: {
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q5: null,
                        q6: null,
                        q7: null,
                        q8: null,
                        q9: null,
                        q1_add_ap: false,
                        q2_add_ap: false,
                        q3_add_ap: false,
                        q4_add_ap: false,
                        q5_add_ap: false,
                        q6_add_ap: false,
                        q7_add_ap: false,
                        q8_add_ap: false,
                        q9_add_ap: false
                    },
                    ra_s6_yn: {
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q1_add_ap: false,
                        q2_add_ap: false,
                        q3_add_ap: false,
                        q4_add_ap: false
                    },
                    ra_s5_yn: {
                        q1: null,
                        q1_add_ap: false
                    },
                    ra_s4_yn: {
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q5: null,
                        q6: null,
                        q7: null,
                        q8: null,
                        q9: null,
                        q10: null,
                        q11: null,
                        q12: null,
                        q13: null,
                        q14: null,
                        q15: null,
                        q16: null,
                        q17: null,
                        q18: null,
                        q19: null,
                        q20: null,
                        q21: null,
                        q22: null,
                        q23: null,
                        q24: null,
                        q25: null,
                        q26: null,
                        q27: null,
                        q1_add_ap: false,
                        q2_add_ap: false,
                        q3_add_ap: false,
                        q4_add_ap: false,
                        q5_add_ap: false,
                        q6_add_ap: false,
                        q7_add_ap: false,
                        q8_add_ap: false,
                        q9_add_ap: false,
                        q10_add_ap: false,
                        q11_add_ap: false,
                        q12_add_ap: false,
                        q13_add_ap: false,
                        q14_add_ap: false,
                        q15_add_ap: false,
                        q16_add_ap: false,
                        q17_add_ap: false,
                        q18_add_ap: false,
                        q19_add_ap: false,
                        q20_add_ap: false,
                        q21_add_ap: false,
                        q22_add_ap: false,
                        q23_add_ap: false,
                        q24_add_ap: false,
                        q25_add_ap: false,
                        q26_add_ap: false,
                        q27_add_ap: false
                    },
                    ra_s3_yn: {
                        q1: null,
                        q2: null,
                        q1_add_ap: false,
                        q2_add_ap: false
                    },
                    ra_s2_yn: {
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q5: null,
                        q1_add_ap: false,
                        q2_add_ap: false,
                        q3_add_ap: false,
                        q4_add_ap: false,
                        q5_add_ap: false
                    },
                    ra_s1_yn: {
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q1_add_ap: false,
                        q2_add_ap: false,
                        q3_add_ap: false,
                        q4_add_ap: false
                    },
                    ra_s19_comment: {
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q5: null,
                        q6: null,
                        q7: null,
                        q8: null,
                        q9: null,
                        q10: null,
                        q11: null,
                        q12: null
                    },
                    ra_s18_comment: {
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q5: null,
                        q6: null,
                        q7: null,
                        q8: null,
                        q9: null,
                        q10: null,
                        q11: null,
                        q12: null
                    },
                    ra_s17_comment: {
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q5: null,
                        q6: null,
                        q7: null,
                        q8: null,
                        q9: null,
                        q10: null,
                        q11: null,
                        q12: null
                    },
                    ra_s16_comment: {
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q5: null,
                        q6: null,
                        q7: null,
                        q8: null,
                        q9: null,
                        q10: null,
                        q11: null,
                        q12: null
                    },
                    ra_s15_comment: {
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q5: null
                    },
                    ra_s14_comment: {
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q5: null,
                        q6: null,
                        q7: null,
                        q8: null,
                        q9: null,
                        q10: null,
                        q11: null,
                        q12: null
                    },
                    ra_s13_comment: {
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q5: null,
                        q6: null,
                        q7: null,
                        q8: null,
                        q9: null,
                        q10: null
                    },
                    ra_s12_comment: {
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q5: null,
                        q6: null,
                        q7: null,
                        q8: null,
                        q9: null,
                        q10: null,
                        q11: null
                    },
                    ra_s11_comment: {
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q5: null,
                        q6: null,
                        q7: null,
                        q8: null,
                        q9: null,
                        q10: null,
                        q11: null,
                        q12: null,
                        q13: null
                    },
                    ra_s10_comment: {
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q5: null,
                        q6: null,
                        q7: null,
                        q8: null,
                        q9: null,
                        q10: null,
                        q11: null,
                        q12: null,
                        q13: null,
                        q14: null,
                        q15: null,
                        q16: null,
                        q17: null,
                        q18: null,
                        q19: null,
                        q20: null,
                        q21: null,
                        q22: null,
                        q23: null,
                        q24: null
                    },
                    ra_s9_comment: {
                        q1: null,
                        q2: null,
                        q3: null
                    },
                    ra_s8_comment: {
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q5: null,
                        q6: null,
                        q7: null,
                        q8: null
                    },
                    ra_s7_comment: {
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q5: null,
                        q6: null,
                        q7: null,
                        q8: null
                    },
                    ra_s6_comment: {
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null
                    },
                    ra_s5_comment: {
                        q1: null
                    },
                    ra_s4_comment: {
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q5: null,
                        q6: null,
                        q7: null,
                        q8: null,
                        q9: null,
                        q10: null,
                        q11: null,
                        q12: null,
                        q13: null,
                        q14: null,
                        q15: null,
                        q16: null,
                        q17: null,
                        q18: null,
                        q19: null,
                        q20: null,
                        q21: null,
                        q22: null,
                        q23: null,
                        q24: null,
                        q25: null,
                        q26: null,
                        q27: null
                    },
                    ra_s3_comment: {
                        q1: null,
                        q2: null
                    },
                    ra_s2_comment: {
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q5: null
                    },
                    ra_s1_comment: {
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null
                    },
                    ra_s19_answer: {
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q5: null,
                        q6: null,
                        q7: null,
                        q8: null,
                        q9: null,
                        q10: null,
                        q11: null,
                        q12: null
                    },
                    ra_s18_answer: {
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q5: null,
                        q6: null,
                        q7: null,
                        q8: null,
                        q9: null,
                        q10: null,
                        q11: null,
                        q12: null
                    },
                    ra_s17_answer: {
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q5: null,
                        q6: null,
                        q7: null,
                        q8: null,
                        q9: null,
                        q10: null,
                        q11: null,
                        q12: null
                    },
                    ra_s16_answer: {
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q5: null,
                        q6: null,
                        q7: null,
                        q8: null,
                        q9: null,
                        q10: null,
                        q11: null,
                        q12: null
                    },
                    ra_s15_answer: {
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q5: null
                    },
                    ra_s14_answer: {
                        report_text: 'The Fire Safety Order requires that suitable and adequate emergency routes and exits are provided, kept clear, maintained, indicated by signs and provided with adequate emergency lighting to ensure relevant persons can evacuate the premises as quickly and safely as possible.',
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q5: null,
                        q6: null,
                        q7: null,
                        q8: null,
                        q9: null,
                        q10: null,
                        q11: null,
                        q12: null
                    },
                    ra_s13_answer: {
                        report_text: 'The Fire Safety Order requires that the premises are equipped with appropriate fire detectors and alarms in order to safeguard relevant persons in or on the premises.',
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q5: null,
                        q6: null,
                        q7: null,
                        q8: null,
                        q9: null,
                        q10: null
                    },
                    ra_s12_answer: {
                        report_text: 'The Fire Safety Order requires that appropriate fire fighting equipment is provided, easily accessible, simple to use and indicated by appropriate signs.',
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q5: null,
                        q6: null,
                        q7: null,
                        q8: null,
                        q9: null,
                        q10: null,
                        q11: null
                    },
                    ra_s11_answer: {
                        report_text: 'The Fire Safety Order requires the Responsible Person to safeguard relevant persons from hazards or incidents involving dangerous substances in or on the premises.\n\n A Dangerous Substance is any substance or preparation that is explosive, oxidising, extremely flammable, highly flammable or flammable (including combustible dusts) which meet the criteria in the HSE Approved Classification and Labelling Guide for Chemicals (CHIP).  The safe handling and storage of dangerous substances must be in accordance with the Dangerous Substances and Explosive Atmospheres Regulations 2002 (DSEAR).',
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q5: null,
                        q6: null,
                        q7: null,
                        q8: null,
                        q9: null,
                        q10: null,
                        q11: null,
                        q12: null,
                        q13: null
                    },
                    ra_s10_answer: {
                        report_text: 'The Fire Safety Order requires the Responsible Person to make general fire precautions to reduce the risk of fire and fire spread on the premises. There are three elements required for a fire to occur: a source of ignition, oxygen, and fuel. This section highlights probable ignition sources and available fuels discovered during the assessment that must be eliminated or reduced.',
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q5: null,
                        q6: null,
                        q7: null,
                        s10_second_report_text: 'All cooking equipment should be viewed as a potential source of ignition. This includes but is not limited to gas-fired equipment with a naked flame, deep fat fryers and electrical equipment such as toasters, griddles and microwaves.  Potential fuel sources include gas supply, oils and fats, food products and deposits of grease or grime on, in or around equipment.',
                        q8: null,
                        q9: null,
                        q10: null,
                        q11: null,
                        q12: null,
                        q13: null,
                        q14: null,
                        q15: null,
                        q16: null,
                        q17: null,
                        q18: null,
                        q19: null,
                        q20: null,
                        q21: null,
                        q22: null,
                        q23: null,
                        q24: null
                    },
                    ra_s9_answer: {
                        report_text: 'The Fire Safety Order requires the Responsible Person to ensure that the premises, facilities, equipment and devices provided to safeguard relevant persons are subject to a suitable system of routine maintenance and are maintained in working order, good repair and an efficient state.',
                        q1: null,
                        q2: null,
                        q3: null
                    },
                    ra_s8_answer: {
                        report_text: 'The Fire Safety Order requires the Responsible Person to provide adequate fire safety training and information to employees and to provide adequate fire safety information to the employers and employees of outside undertakings.',
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q5: null,
                        q6: null,
                        q7: null,
                        q8: null
                    },
                    ra_s7_answer: {
                        report_text: 'The Fire Safety Order requires the Responsible Person put in place appropriate safety drills in the event of serious and imminent danger to relevant persons. They must ensure that sufficient numbers of competent persons are nominated and trained to implement these drills.',
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q5: null,
                        q6: null,
                        q7: null,
                        q8: null,
                        q9: null,
                    },
                    ra_s6_answer: {
                        report_text: 'This section details deficiencies in the effective planning, organisation, control, and monitoring of the preventative and protective measures that are required to ensure the premises and relevant persons are safe from fire.',
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null
                    },
                    ra_s5_answer: {
                        report_text: 'External or Sub-buildings (if any) that form part of this assessment are briefly described below: The control measures required to rectify any deficiencies discovered within these areas will be highlighted in the main body of the report.',
                        q1: null
                    },
                    ra_s4_answer: {
                        report_text: '', //Removed content on John's request from 13 Nov, 2019 
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q5: null,
                        q6: null,
                        q6_report_text: 'In multi-occupied buildings the Regulatory Reform (Fire Safety) Order 2005, and the Fire (Scotland) Act 2006 require the \'Responsible Person/ Duty Holder\' to co-operate and liaise with other \'Responsible Persons/Duty Holder\' within the building whether on a permanent or temporary basis to ensure the safety of all relevant persons.',
                        q7: null,
                        q8: null,
                        q9: null,
                        q10: null,
                        q11: null,
                        q12: null,
                        q13: null,
                        q14: null,
                        q15: null,
                        q16: null,
                        q17: null,
                        q18: null,
                        q19: null,
                        q20: null,
                        q21: null,
                        q22: null,
                        q23: null,
                        q24: null,
                        q25: null,
                        q26: null,
                        q27: null
                    },
                    ra_s3_answer: {
                        report_text: null,
                        q1: null,
                        q2: null
                    },
                    ra_s2_answer: {
                        report_text:  'The persons at risk are the \'Relevant Persons\' as described within the Fire Safety Order. The term relevant person refers to any person, who is or may be on the premises and any person in the immediate vicinity of the premises who is at risk from a fire on the premises.',
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null,
                        q5: null
                    },
                    ra_s1_answer: {
                        report_text: 'The management of fire safety rests with the \'Responsible Person\' as defined by the Regulatory Reform (Fire Safety) Order 2005 and the Fire (Scotland) Act 2005, otherwise referred to as The Fire Safety Order. The \'Responsible Person\' could be the employer, the owner, the landlord, an occupier or anyone else with control of the premises, e.g. a facilities manager, building manager, managing agent or risk assessor.  They are responsible for fire safety in business or other non-domestic premises.  If there\'s more than one Responsible Person, you have to work together to meet your responsibilities.\n\nAs the Responsible Person you must:\n- carry out a fire risk assessment of the premises and review it regularly\n- tell staff or their representatives about the risks you\'ve identified\n- put in place, and maintain, appropriate fire safety measures\n- plan for an emergency\n- provide staff information, fire safety instruction and training',
                        q1: null,
                        q2: null,
                        q3: null,
                        q4: null
                    },
                    ra_cover: {
                        report_type: null,
                        prepared_for: null,
                        reference_number: null,
                        location: null,
                        date_of_assessment: null,
                        assessor_name: null,
                        signed_off_by: null,
                        sign_off_date: null,
                        recommended_review_date: null,
                        cover_image: null,
                        cover_images: [],
                        cover_offline_images: [],
                    },
                    site_risk_audit_id: Math.floor(new Date().getTime() / 1000),
                    engineer_signature_image: null,
                    client_signature_image: null,
                    offline_engineer_signature_image: null,
                    offline_client_signature_image: null,
                    client_signed_by: null,
                    client_signed_date: null,
                    report_version: null,
                },

                isImageUploading: false,
                modifyingPhoto: false,
                dropdownList: [],
                reportTypes: null,
                isDone: false,
                submitting: false,
                errors: [],
                defaultQuestions: {
                    s1q1: 'Name of the \'Responsible Person\' or Duty Holder',
                    s1q2: 'Responsible Person or Duty Holders Position',
                    s1q3: 'Name and Position of the Building Fire Safety Manager or person who deals with fire safety',
                    s1q4: null,
                    s2q1: 'Number of persons on site',
                    s2q2: 'Total number of people within the building',
                    s2q3: 'Number of persons under the age of 18 on this site',
                    s2q4: 'Categories of people identified as potentially being \'at risk\'',
                    s2q5: 'Occupied hours and risk profiles',
                    s3q1: 'Is there a history of fire related incidents or enforcements?',
                    s3q2: null,
                    s4q1: 'How much of the inspected building does the client occupy?',
                    s4q2: 'The main use of the premises is:',
                    s4q3: 'What is the property type?',
                    s4q4: 'Approximate property size',
                    s4q5: 'Occupancy and permitted numbers',
                    s4q6: 'Is the building and it\'s emergency exit routes shared with other occupants and if so, does the Responsible Person co-operate and liaise with other Responsible Persons to ensure the safety of all relevant people?',
                    s4q7: 'The number of floors',
                    s4q8: 'Building condition',
                    s4q9: 'External wall construction',
                    s4q10: 'External fire spread',
                    s4q11: 'Internal wall construction',
                    s4q12: 'Floor construction',
                    s4q13: 'Roof construction',
                    s4q14: 'Staircases in the property',
                    s4q15: 'External fire escape staircases',
                    s4q16: 'Emergency exits on site which includes the main entrance to the property',
                    s4q17: 'Does the property have any lifts installed?',
                    s4q18: 'Number of fireman / evacuation lifts',
                    s4q19: 'Is a smoke and heat exhaust ventilation system provided?',
                    s4q20: 'Is there any air handling equipment on site?',
                    s4q21: 'Property utilities',
                    s4q22: 'The property has the following boiler system',
                    s4q23: 'Heating provisions',
                    s4q24: 'Sources of ignition that are potential fire hazards',
                    s4q25: 'Oxygen sources that are potential fire hazards',
                    s4q26: 'Combustible fuels that are potential fire hazards',
                    s4q27: 'Are any Dangerous Substances stored or used?',
                    s5q1: 'Are there any sub buildings included in this report?',
                    s6q1: 'Is there a suitable fire safety policy document held on site?',
                    s6q2: 'What is the evacuation strategy?',
                    s6q3: 'Does the building have an emergency plan in place?',
                    s6q4: 'Does the Responsible Person have assistance to deal with matters fire related?',
                    s7q1: 'Are fire evacuation and safety drills conducted on a regular basis?',
                    s7q2: 'Are enough people trained and responsible for ensuring safe evacuation?',
                    s7q3: 'Are there procedures in place for the safe evacuation of persons with a physical or sensory disability?',
                    s7q4: 'Are safe assembly points established?',
                    s7q5: 'Are there procedures in place for the safe isolation of machinery during evacuation?',
                    s7q6: 'Are suitable arrangements in place for summoning the emergency services?',
                    s7q7: 'Are third party visitors / contractors provided with clear fire safety information?',
                    s7q8: 'Are regular fire safety checks being carried out and recorded?',
                    s7q9: 'Additional comments',
                    s8q1: 'Is fire safety instruction/training being given to employees on a regular basis by a competent person and are records of training kept?',
                    s8q2: 'Have sufficient people been trained to a competent standard (where Fire Wardens are not required) to conduct the fire evacuation procedures?',
                    s8q3: 'Are employees given fire safety training at commencement of employment?',
                    s8q4: 'If required, are there sufficient fire wardens for the size and type of building?',
                    s8q5: 'Does specific training include hazardous working practises?',
                    s8q6: 'Are arrangements for visitors/contractors adequate? Specifically related to fire safety provision.',
                    s8q7: 'Are Fire Marshals established and trained on a regular basis?',
                    s9q1: 'Is all fire related equipment subject to a system of routine maintenance/ testing and recorded in the Fire Safety Log Book?',
                    s9q2: 'Are relevant checks being carried out and recorded?',
                    s9q3: 'Any other relevant information for this section',
                    s10q1: 'Fixed wiring installations. Are the systems inspected, tested and checked by competent persons?',
                    s10q2: 'Is the responsible person ensuring the prevention of electrical fires within the property?',
                    s10q3: 'Are all electrical fittings in a good state of repair and free from any obvious signs of damage including light fittings?',
                    s10q4: 'Are any portable electrical appliances subject to a system of routine inspection?',
                    s10q5: 'Are electrical cables and sockets in good condition without signs of visible defects?',
                    s10q6: 'Is the building protected from electrostatic discharge by installations such as lightning conductors and is the system adequately maintained?',
                    s10q7: 'Are suitable arrangements in place to prevent the ignition of flammable liquids, gases or dusts from electrostatic discharge?',
                    s10q8: 'Does the building contain commercial cooking equipment and facilities?',
                    s10q9: 'Is kitchen equipment, extraction systems and ductwork subject to a system of routine cleaning and maintenance?',
                    s10q10: 'Are any emergency cut-off switches/valves/cocks free from obstruction, suitably located and clearly indicated?',
                    s10q11: 'Are there any hot work processes being carried out on site?',
                    s10q12: 'Are satisfactory arrangements in place for hot work?',
                    s10q13: 'Are there any naked flame processes on site?',
                    s10q14: 'Are satisfactory arrangements in place for any naked flame processes?',
                    s10q15: 'Mechanical equipment and machinery',
                    s10q16: 'Is mechanical machinery maintained on a regular basis?',
                    s10q17: 'Is housekeeping well managed including high-risk areas?',
                    s10q18: 'Is there an acceptable system in place to remove rubbish and is general waste management of the premises sufficient?',
                    s10q19: 'Are suitable arrangements in place to minimise the risk of arson?',
                    s10q20: 'Is a Smoking Policy in force?',
                    s10q21: 'Is there evidence of illicit smoking on site?',
                    s10q22: 'Are furniture coverings in a good state of repair?',
                    s10q23: 'Furniture provision and fire loading',
                    s10q24: 'Additional comments referring to fire hazards for this section of the report?',
                    s11q1: 'Are highly flammable liquids used on site?',
                    s11q2: 'If yes, are appropriate arrangements in place for the safe storage of flammable liquids and solvents?',
                    s11q3: 'Are flammable liquids (with a flashpoint below 21ºC) kept to a minimum in the workplace?',
                    s11q4: 'Has an assessment been carried out under the current DSEAR regulations? (Dangerous Substances Explosive Atmosphere Regulations)',
                    s11q5: 'Are gas systems and appliances installed to site and regularly maintained by a competent person?',
                    s11q6: 'Is the mains gas intake housed in a suitable compartment with adequate ventilation and free from all ignition sources?',
                    s11q7: 'Are gas emergency shut off controls readily accessible?',
                    s11q8: 'Are highly flammable gases used or stored on site?',
                    s11q9: 'Is LPG stored in accordance with Code of Practice 7?',
                    s11q10: 'Are on site LPG appliances subject to a system of routine maintenance?',
                    s11q11: 'Is there a combustible dust hazard evident on this site?',
                    s11q12: 'Are appropriate controls and collection in place for combustible dusts?',
                    s11q13: 'Dangerous Substances additional comments section',
                    s12q1: 'Are the correct types and numbers of extinguisher/fire blankets in place to deal with the most likely sources of ignition?',
                    s12q2: 'Are there any non-compliant fire extinguishers on site?',
                    s12q3: 'Are all extinguishers correctly sited, fixed to the wall or on appropriate extinguisher stands?',
                    s12q4: 'Are extinguishers accessible and free from obstruction?',
                    s12q5: 'Are all extinguishers provided with the appropriate safety signage?',
                    s12q6: 'Is a fire suppression system installation required to protect high risk or other areas?',
                    s12q7: 'Is a sprinkler system installed?',
                    s12q8: 'Is a sprinkler or water misting system required for the property or facility?',
                    s12q9: 'Is the sprinkler or misting system serviced, inspected and tested as required and the results of the examination recorded on the correct manner?',
                    s12q10: 'Additional comments section regarding sprinklers, misting systems and suppression',
                    s13q1: 'Is there a fire alarm system in the building?',
                    s13q2: 'What is the category of the fire alarm system installed in this property?',
                    s13q3: 'Is automatic fire detection installed in the building and is it sufficient for the building design and use?',
                    s13q4: 'Has the level of audibility of the fire warning system been checked by a competent person throughout the premises? Is the system adequate?',
                    s13q5: 'Are automatic hold open devices required but not currently installed?',
                    s13q6: 'Are automatic hold open devices (where fitted) functioning correctly?',
                    s13q7: 'Are the fire alarm call points correctly positioned and accessible?',
                    s13q8: 'Are additional call points required to ensure all persons within the premises are within 30 metres?',
                    s13q9: 'Are strobe lights required but not installed?',
                    s13q10: 'Fire alarm system comments',
                    s14q1: 'Do all emergency routes and exits lead to a place of safety?',
                    s14q2: 'Travel distances',
                    s14q3: 'Is the building free of any inner room situation that requires recommendations?',
                    s14q4: 'Is the building free of any Dead End situation that may compromise the escape route?',
                    s14q5: 'Are there adequate emergency exits from the premises?',
                    s14q6: 'Are all emergency fire exit doors available for use at all times?',
                    s14q7: 'Do all emergency exit doors open in the direction of escape?',
                    s14q8: 'Does the building have any revolving or sliding emergency exit doors?',
                    s14q9: 'Are all fire exit doors in a good state of repair?',
                    s14q10: 'Are all steps/platforms, gantries and the areas around emergency exit doors in a good condition?',
                    s14q11: 'Do all emergency doors have approved emergency fastenings?',
                    s14q12: 'Are there any other deficiencies with regard to emergency routes and exits?',
                    s14q13: 'Are all EXTERNAL emergency routes and exits free from obstruction?',
                    s14q14: 'Are all INTERNAL emergency routes and exits free from obstruction?',
                    s15q1: 'Are emergency routes adequately indicated by directional exit signs?',
                    s15q2: 'Are emergency exits adequately indicated by appropriate signs?',
                    s15q3: 'Are Lift Fire Action notices clearly displayed adjacent to lifts on all floors?',
                    s15q4: 'Fire Action notices and other appropriate signage requirements. The following locations require specific signs to inform the end user of the correct function or instruction:',
                    s15q5: 'Are all emergency exit operating mechanisms clearly indicated by appropriate signs such as \'Push Bar to Open\'?',
                    s16q1: 'Is there a reasonable standard of internal emergency lighting provided and is it suitable for the occupancy of the building?',
                    s16q2: 'Is additional emergency lighting required?',
                    s16q3: 'Is there a reasonable standard of external emergency lighting or is borrowed lighting available and suitable?',
                    s16q4: 'Do all installed emergency lighting units appear functional and free from damage and defects?',
                    s17q1: 'Are fire resisting doors installed on site to a reasonable standard?',
                    s17q2: 'From a visual inspection of the fire doors, does the equipment appear compliant?',
                    s17q3: 'Are additional fire resisting doors required to be installed / updated?',
                    s17q4: 'Do all doors that form part of emergency routes and high-risk areas conform to the required standard of resistance?',
                    s17q5: 'Do fire doors require remedial works, adjustment, additional equipment or parts?',
                    s17q6: 'Are intumescent strips or cold smoke seals installed to all fire resisting doors?',
                    s17q7: 'Additional self-closing mechanism requirements?',
                    s17q8: 'Were any fire resisting doors held in the open position by items or devices that would not allow the door to close in a fire situation?',
                    s17q9: 'Are fire resisting doors free from air transfer grills, letter boxes or ventilation holes?',
                    s17q10: 'Is fire resistant door glazing of the required fire resistance?',
                    s17q11: 'Further fire resisting door commentary?',
                    s18q1: 'Do partition walls, wall panels, glazing and ceilings that form part of the escape route provide adequate fire resistance?',
                    s18q2: 'Is adequate fire rated separation provided for higher risk locations?',
                    s18q3: 'Does the property have lift shaft service hatches or other openings which can promote fire spread?',
                    s18q4: 'Are there any issues observed with fire walls or ceilings such as service penetrations etc.? Examples include passing of pipes between rooms, cable holes or other systems penetrating the original design.',
                    s18q5: 'Movement impaired facilities, refuges and areas for persons with limited mobility',
                    s18q6: 'Other information relevant to this report',
                    s19q1: 'Fire and Rescue Services provisions and access',
                    s19q2: 'Solar panels and DC controllers',
                    s19q3: 'Does the building have any fire dampers installed and are there adequate maintenance procedures in place?'
                },
                customQuestions: {
                    jpfire: {
                        s1q1: 'The organisation with ultimate responsibility for fire safety on the premises',
                        s1q2: 'Name and position of Responsible Person (The person with delegated responsibility for fire safety on the premises)',
                        s1q3: 'Name and position of Competent Person (The person appointed by the Responsible Person to assist with the undertaking of preventative and protective measures on the premises)',
                        s1q4: 'The identity and roles of key individuals from whom information was obtained as part of the assessment',
                        s2q1: 'Occupancy details',
                        s2q2: 'Total occupancy',
                        s2q3: 'Disabled occupants and persons under the age of 18',
                        s2q4: 'Occupants identified as being especially at risk from fire',
                        s2q5: 'Occupied hours and purpose group or risk profile',
                        s3q1: 'Is there a history of fire related incidents, inspections or enforcements',
                        s3q2: 'Relevant Legislation',
                        s4q1: 'Does the client have full control of the premises?',
                        s4q2: 'Main use of the premises',
                        s4q3: 'Property type',
                        s4q4: null,
                        s4q5: 'Occupancy calculation',
                        s4q6: 'Cooperation and coordination with other premises occupiers, neighbouring premises, emergency services and other authorities',
                        s4q7: 'Number of floors',
                        s4q8: 'Building height',
                        s4q9: null,
                        s4q10: null,
                        s4q11: 'Internal wall and ceiling construction',
                        s4q12: null,
                        s4q13: null,
                        s4q14: 'Number of staircases in the property',
                        s4q15: 'External fire escape provision',
                        s4q16: 'Number of exits',
                        s4q17: 'Are there any passenger or goods lifts provided?',
                        s4q18: 'Are there any fire-fighting lifts provided?',
                        s4q19: 'Are any smoke and heat exhaust ventilation systems provided?',
                        s4q20: 'Air handling',
                        s4q21: null,
                        s4q22: 'Boiler systems',
                        s4q23: 'Heating and cooling provisions, including portable heating',
                        s4q24: 'Sources of ignition',
                        s4q25: 'Oxygen sources',
                        s4q26: 'Combustible fuels',
                        s4q27: 'Dangerous Substances',
                        s5q1: 'External areas or sub buildings',
                        s6q1: 'Is there a suitable fire safety policy document in place?',
                        s6q2: null,
                        s6q3: null,
                        s6q4: 'Fire Safety Management additional commentary',
                        s7q1: 'Fire evacuation and safety drill requirements',
                        s7q2: null,
                        s7q3: 'Procedures for the evacuation of persons who may need assistance',
                        s7q4: null,
                        s7q5: null,
                        s7q6: null,
                        s7q7: null,
                        s7q8: null,
                        s7q9: 'Multi-occupied residential buildings: information provided to residents',
                        s8q1: null,
                        s8q2: 'Have sufficient people been trained to a competent standard (where Fire Marshals are not required) to conduct the fire evacuation procedures?',
                        s8q3: null,
                        s8q4: 'If required, are there sufficient Fire Marshals for the size and type of building?',
                        s8q5: null,
                        s8q6: 'Are fire safety training arrangements for visitors/contractors adequate?',
                        s8q7: 'Is fire safety information provided to occupants?',
                        s9q1: null,
                        s9q2: 'Routine building maintenance',
                        s9q3: 'Are all facilities provided for use by firefighters subject to a recorded system of routine maintenance/ testing?',
                        s10q1: null,
                        s10q2: null,
                        s10q3: 'Cable management, sockets and overloading',
                        s10q4: null,
                        s10q5: 'Device and equipment condition',
                        s10q6: null,
                        s10q7: 'Renewable energy sources, DC storage, EV charging facilities',
                        s10q8: null,
                        s10q9: null,
                        s10q10: null,
                        s10q11: 'Are there any hot work processes being carried out either internally or externally?',
                        s10q12: 'What are the control measures for hot works and are they satisfactory?',
                        s10q13: 'Are there any naked flame processes being carried out either internally or externally?',
                        s10q14: 'What are the control measures for naked flames and are they satisfactory?',
                        s10q15: null,
                        s10q16: null,
                        s10q17: 'Is housekeeping well managed?',
                        s10q18: 'Control measures for waste management',
                        s10q19: null,
                        s10q20: 'What are the smoking control measures?',
                        s10q21: 'Is there evidence of illicit smoking?',
                        s10q22: 'List areas of significant fire loading',
                        s10q23: 'Control measures for fire loading',
                        s10q24: 'Fire loading additional commentary',
                        s11q1: 'Are highly flammable liquids used or stored?',
                        s11q2: 'Are appropriate arrangements in place for the safe storage of flammable liquids and solvents?',
                        s11q3: 'Are appropriate arrangements in place for the use and storage of flammable liquids with a flashpoint below 21ºC?',
                        s11q4: 'Is a DSEAR (Dangerous Substances Explosive Atmosphere Regulations 2002) risk assessment required?',
                        s11q5: 'Are gas systems and appliances installed and are they regularly maintained?',
                        s11q6: 'Location of gas mains intake and control measures',
                        s11q7: 'Are gas emergency shut off controls provided?',
                        s11q8: 'Are highly flammable gases used or stored?',
                        s11q9: null,
                        s11q10: 'Is LPG equipment routinely maintained?',
                        s11q11: null,
                        s11q12: null,
                        s11q13: 'Dangerous Materials, Substances, Dusts and Gases additional commentary',
                        s12q1: 'Does the premises require portable firefighting equipment?',
                        s12q2: 'Is the type of portable firefighting equipment suitable and sufficient?',
                        s12q3: 'Is all portable firefighting equipment correctly sited, fixed to the wall or on appropriate extinguisher stands?',
                        s12q4: 'Is all portable firefighting equipment accessible and free from obstruction?',
                        s12q5: 'Is all portable firefighting equipment provided with the appropriate safety signage?',
                        s12q6: 'Description of fire suppression systems installed or required, suitability and arrangements for service, testing and maintenance',
                        s12q7: 'Description of sprinkler or water mist systems installed or required, suitability and arrangements for service, testing and maintenance',
                        s12q8: 'Description of wet or dry risers installed or required and arrangements for service, testing and maintenance',
                        s12q9: 'Fire engineered solutions',
                        s12q10: 'Portable and fixed firefighting equipment additional commentary',
                        s13q1: null,
                        s13q2: null,
                        s13q3: null,
                        s13q4: 'Has the level of audibility of the fire warning system been checked by a competent person throughout the premises?',
                        s13q5: 'Are automatic hold open devices provided and functional?',
                        s13q6: 'Is there any interfaced equipment linked to the fire alarm?',
                        s13q7: null,
                        s13q8: 'Are call points provided on every storey?',
                        s13q9: 'Are visual or sensory alarms provided?',
                        s13q10: 'Fire alarm system additional commentary',
                        s14q1: null,
                        s14q2: null,
                        s14q3: 'Are there any inner room situations?',
                        s14q4: 'Are there any dead-end situations?',
                        s14q5: 'Is the emergency exit provision adequate?',
                        s14q6: null,
                        s14q7: 'Do all designated emergency exit doors open in the direction of escape?',
                        s14q8: null,
                        s14q9: null,
                        s14q10: 'Are all steps, ramps, platforms, gantries and the areas around emergency exit doors in a good condition?',
                        s14q11: null,
                        s14q12: 'Means of escape additional commentary',
                        s14q13: null,
                        s14q14: null,
                        s15q1: null,
                        s15q2: 'Are final emergency exits adequately indicated by appropriate signs?',
                        s15q3: 'Are Fire Action Notices clearly displayed?',
                        s15q4: 'Other relevant signage requirements',
                        s15q5: 'Are Lift Fire Action Notices clearly displayed adjacent to lifts on all floors?',
                        s16q1: null,
                        s16q2: 'Locations where emergency lighting is installed',
                        s16q3: 'Is there a reasonable standard of external emergency lighting?',
                        s16q4: null,
                        s17q1: 'Are fire resisting doors installed?',
                        s17q2: null,
                        s17q3: 'Is there a satisfactory maintenance and inspection regime in place for fire resisting doors?',
                        s17q4: null,
                        s17q5: 'Were any fire resisting doors held in the open position by items or devices that would not allow the door to close in a fire situation?',
                        s17q6: 'Intumescent strips and cold smoke seal requirements',
                        s17q7: 'Self-closing mechanism requirements, door furniture, iron mongery and air transfer grills',
                        s17q8: 'Is fire resistant door glazing of the required fire resistance?',
                        s17q9: 'Fire resisting door and glazing requirements for external escapes',
                        s17q10: 'Fire shutters, fire curtains, room separators.',
                        s17q11: 'Fire resisting doors additional commentary',
                        s18q1: null,
                        s18q2: 'Is adequate fire resisting separation provided for higher risk locations?',
                        s18q3: 'Does the building have fire or smoke dampers?',
                        s18q4: null,
                        s18q5: null,
                        s18q6: 'Does the property have lift shaft, service hatches or other openings which can promote fire spread?',
                        s19q1: null,
                        s19q2: 'Hydrants and water supplies',
                        s19q3: 'Requirements for liaising with the Fire and Rescue Service'
                    }
                }
            }
        },
        validations: {
        },
        mounted() {
            const modulesData = this.$session.get('enabled_modules');
            if(!modulesData || modulesData.indexOf('FRA') === -1) {
                this.$router.push('/');
                return;
            }

            if (this.$route.name === 'risk-audit-edit') {
                this.isEdit = true;
            }

            this.getReportTypes();

            if (this.isEdit) {
                this.getRiskAudit();
            } else if(this.dbName === 'jpfire') {
                this.raAnswer.ra_s1_answer.report_text = 'The management of fire safety rests with the \'Responsible Person\' as defined by the Regulatory Reform (Fire Safety) Order 2005, otherwise referred to as The Fire Safety Order. The \'Responsible Person\' could be the employer, the owner, the landlord, an occupier or anyone else with control of the premises, e.g. a facilities manager, building manager, managing agent or risk assessor.  They are responsible for fire safety in business or other non-domestic premises.  If there\'s more than one Responsible Person, you have to work together to meet your responsibilities.\n\nAs the Responsible Person you must:\n- carry out a fire risk assessment of the premises and review it regularly\n- tell staff or their representatives about the risks you\'ve identified\n- put in place, and maintain, appropriate fire safety measures\n- plan for an emergency\n- provide staff information, fire safety instruction and training';
                this.raAnswer.ra_s5_answer.report_text = 'External areas or Sub-buildings (if any) that form part of this assessment are briefly described below: The control measures required to rectify any deficiencies discovered within these areas will be highlighted in the main body of the report.';
                this.raAnswer.ra_s4_answer.q6_report_text = 'In multi-occupied buildings the Regulatory Reform (Fire Safety) Order 2005 requires the \'Responsible Person/ Duty Holder\' to co-operate and liaise with other \'Responsible Persons/Duty Holder\' within the building whether on a permanent or temporary basis to ensure the safety of all relevant persons.';
            }
        },
        methods: {
            clearClientSignature() {
                this.$refs.clientSignaturePad.clearSignature();
            },
            saveClientSignature() {
                const { isEmpty, data } = this.$refs.clientSignaturePad.saveSignature();

                if(!isEmpty) {
                    this.raAnswer.offline_client_signature_image = {
                        data: data
                    };
                }
                
                this.addingClientSignature = false;
                this.clearClientSignature();
            },
            addEditClientSignature() {
                this.addingClientSignature = true;
            },
            clearEngineerSignature() {
                this.$refs.engineerSignaturePad.clearSignature();
            },
            saveEngineerSignature() {
                const { isEmpty, data } = this.$refs.engineerSignaturePad.saveSignature();

                if(!isEmpty) {
                    this.raAnswer.offline_engineer_signature_image = {
                        data: data
                    };
                }
                
                this.addingEngineerSignature = false;
                this.clearEngineerSignature();
            },
            addEditEngineerSignature() {
                this.addingEngineerSignature = true;
            },
            forceRerender() {
                this.componentKey += 1;  
            },
            onFileChange(e) {
                this.isImageUploading = true;
                var files = e.target.files || e.dataTransfer.files
                if (!files.length) {
                    this.isImageUploading = false;
                    return;
                }

                var vm = this;
                EXIF.getData(files[0], function() {
                    var orientation = EXIF.getTag(this, "Orientation");
                    vm.createCoverPhoto(files[0], orientation);
                });
            },
            createCoverPhoto(file, orientation) {
                var compress = new Compress()
                var files = [file];
                console.log(files);
                var vm = this;
                compress.compress(files, {
                    size: 4, // the max size in MB, defaults to 2MB
                    quality: .6, // the quality of the image, max is 1,
                    maxWidth: 700, // the max width of the output image, defaults to 1920px
                    maxHeight: 700, // the max height of the output image, defaults to 1920px
                    resize: true, // defaults to true, set false if you do not want to resize the image width and height
                }).then((data) => {
                    var imgSrc = data[0].prefix + data[0].data;

                    if(this.raAnswer.ra_cover.cover_offline_images == undefined) {
                        this.raAnswer.ra_cover.cover_offline_images = [];        
                    }

                    this.raAnswer.ra_cover.cover_offline_images.push({'data': imgSrc, 'orientation': orientation});
                    this.isImageUploading = false;
                });
            },
            onPhotoChange(e) {
                this.isImageUploading = true;
                var files = e.target.files || e.dataTransfer.files
                if (!files.length) {
                    this.isImageUploading = false;
                    return;
                }

                var vm = this;
                for(var i = 0; i < files.length; i++) {
                    var file = files[i];
                    EXIF.getData(file, function() {
                        var orientation = EXIF.getTag(this, "Orientation");
                        vm.createPhoto(this, orientation);
                    });
                }
            },
            createPhoto(file, orientation) {
                var compress = new Compress()
                var files = [file];
                var vm = this;
                //console.log(files);
                compress.compress(files, {
                    size: 4, // the max size in MB, defaults to 2MB
                    quality: .6, // the quality of the image, max is 1,
                    maxWidth: 700, // the max width of the output image, defaults to 1920px
                    maxHeight: 700, // the max height of the output image, defaults to 1920px
                    resize: true, // defaults to true, set false if you do not want to resize the image width and height
                }).then((data) => {
                    // returns an array of compressed images
                    var imgSrc = data[0].prefix + data[0].data;
     
                    this.raAnswer.offline_images.push({'data': imgSrc, 'orientation': orientation});
                    this.isImageUploading = false;
                });
            },
            removePhoto(index) {
                this.modifyingPhoto = true;
                this.raAnswer.offline_images.splice(index, 1);
                this.modifyingPhoto = false;
            },
            rotatePhoto(index, degrees) {
                this.modifyingPhoto = true;
                this.rotateImage(this.raAnswer.offline_images[index].data, degrees).then(newDataUri => {
                    this.raAnswer.offline_images[index].data = newDataUri;
                    this.modifyingPhoto = false;
                }).catch(e => {
                    console.log(e);
                    alert('Error occurred while trying to rotate photo');
                    this.modifyingPhoto = false;
                });
            },
            rotateCoverPhoto(degrees) {
                this.modifyingPhoto = true;
                this.rotateImage(this.raAnswer.ra_cover.cover_offline_images[0].data, degrees).then(newDataUri => {
                    this.raAnswer.ra_cover.cover_offline_images[0].data = newDataUri;
                    this.modifyingPhoto = false;
                }).catch(e => {
                    console.log(e);
                    alert('Error occurred while trying to rotate cover photo');
                    this.modifyingPhoto = false;
                });
            },
            sendImageToServer(file, xhr, formData) {
                formData.append('user_id', 1);
            },
            saveImageToForm(response) {
                var imageData = JSON.parse(response.xhr.response);
                if (imageData.success) {
                    this.raAnswer.ra_cover.cover_images.push({image: imageData.image_data, image_id: imageData.image_data.image_id});
                }
            },
            scrollToTop() {
                var element = document.getElementById('audit-app-container');
                var top = element.offsetTop;
                window.scrollTo(0, top);
            },
            submit() {
                this.$v.$touch();
                if (!this.$v.$error) {
                    this.ignoreLeaveEvent = true;
                    this.sendFormData();
                } else {
                    this.validationError();
                }
            },
            getDropdowns(questionId) {
                var vm = this;
                this.getDb(function onConnectedGetDropdowns(db) {
                    var dropdownsStore = db.transaction('dropdowns').objectStore('dropdowns');
                    if (dropdownsStore) {
                        var questionResults = dropdownsStore.index('question_id').getAll(questionId);
                        questionResults.onsuccess = function(e) {
                            console.log(e.target.result);
                            return e.target.result;
                        }
                        questionResults.onerror = function(e) {
                            console.log('Problem', e);
                        }
                    }
                })
            },
            enableSubmitLoader() {
                this.submitting = true;
            },
            disableSubmitLoader() {
                this.submitting = false;
            },
            sendFormData() {
                this.enableSubmitLoader();

                var vmt = this;
                this.getDb(function onConnectedGetDoorSets(db) {

                    console.log('Saving this please', vmt.raAnswer);
                    var vm = vmt;
                    var putRequest = db.transaction('risk_assessments', 'readwrite')
                        .objectStore('risk_assessments').put(vm.raAnswer);
                    putRequest.onsuccess = function(event) {
                        vm.submitSuccess({
                            success: true,
                            site_risk_audit_id: putRequest.result,
                        })
                    }
                    putRequest.onerror = function(event) {
                        alert("Unable to add data ");
                    };
                })
            },
            submitSuccess(response) {
                if (response.success) {
                    this.isSubmitted = true;
                    this.isError = false;
                    this.$router.push({ name: 'risk-audit-view' })
                } else {
                    this.errorHeader = 'error.invalidFields';
                    this.errors = response.data.errors;
                    this.isError = true;
                }
            },
            submitError(error) {
                this.errorHeader = 'error.general';
                this.errors = [{'field': null, 'message': 'error.generalMessage'}];
                this.isError = true;
            },
            validationError() {
                this.errorHeader = 'error.invalidFields';
                this.errors = this.getErrors();
                this.isError = true;
            },
            isErrorField(field) {
                try {
                    if (this.getValidationField(field).$error) {
                        return true;
                    }
                } catch (error) {}

                return this.errors.some(el => el.field === field);
            },
            getErrors() {
                let errors = [];
                for (var field of Object.keys(this.riskAudit)) {
                    try {
                        if (this.getValidationField(field).$error) {
                            errors.push({'field': field, 'message': null});
                        }
                    } catch (error) {}
                }
                return errors;
            },
            getFieldClasses(field) {
                return { 'is-invalid': this.isErrorField(field) }
            },
            getContainerClasses(field) {
                return { 'text-danger': this.isErrorField(field) }
            },
            getValidationField(field) {
                if (this.$v.riskAudit[field]) {
                    return this.$v.riskAudit[field];
                }
                throw Error('No validation for field ' + field);
            },
            onFieldBlur(field) {
                try {
                    this.getValidationField(field).$touch();
                    if (this.getValidationField(field).$error) {
                        if (!this.errors.some(el => el.field === field)) {
                            this.errors.push({'field': field, 'message': null});
                        }
                    } else {
                        this.errors = this.errors.filter(el => el.field !== field);
                    }
                } catch (error) {}
            },
            getRiskAudit() {
                var vmt = this;
                this.getDb(function onConnectedGetRiskAudit(db) {

                    var vm = vmt;
                    try {
                        var riskAuditId = parseInt(vm.$route.params.id);
                        var objectStore = db.transaction('risk_assessments').objectStore('risk_assessments');
                        var storeRequest = objectStore.get(riskAuditId);
                        storeRequest.onsuccess = function(event) {
                            vm.raAnswer = storeRequest.result;

                            for(var i = 1; i <= 19; i++) {
                                if(typeof vm.raAnswer['ra_s'+i+'_images_to_delete'] == 'undefined' || vm.raAnswer['ra_s'+i+'_images_to_delete'] == null) {
                                    vm.raAnswer['ra_s'+i+'_images_to_delete'] = [];
                                }
                            }

                            if(typeof vm.raAnswer.ra_hidden_question == 'undefined' || vm.raAnswer.ra_hidden_question == null) {
                                vm.raAnswer.ra_hidden_question = {
                                        s1q1: false,
                                        s1q2: false,
                                        s1q3: false,
                                        s1q4: false,
                                        s2q1: false,
                                        s2q2: false,
                                        s2q3: false,
                                        s2q4: false,
                                        s2q5: false,
                                        s3q1: false,
                                        s4q1: false,
                                        s4q2: false,
                                        s4q3: false,
                                        s4q4: false,
                                        s4q5: false,
                                        s4q6: false,
                                        s4q7: false,
                                        s4q8: false,
                                        s4q9: false,
                                        s4q10: false,
                                        s4q11: false,
                                        s4q12: false,
                                        s4q13: false,
                                        s4q14: false,
                                        s4q15: false,
                                        s4q16: false,
                                        s4q17: false,
                                        s4q18: false,
                                        s4q19: false,
                                        s4q20: false,
                                        s4q21: false,
                                        s4q22: false,
                                        s4q23: false,
                                        s4q24: false,
                                        s4q25: false,
                                        s4q26: false,
                                        s4q27: false,
                                        s5q1: false,
                                        s6q1: false,
                                        s6q2: false,
                                        s6q3: false,
                                        s6q4: false,
                                        s7q1: false,
                                        s7q2: false,
                                        s7q3: false,
                                        s7q4: false,
                                        s7q5: false,
                                        s7q6: false,
                                        s7q7: false,
                                        s7q8: false,
                                        s7q9: false,
                                        s8q1: false,
                                        s8q2: false,
                                        s8q3: false,
                                        s8q4: false,
                                        s8q5: false,
                                        s8q6: false,
                                        s8q7: false,
                                        s9q1: false,
                                        s9q2: false,
                                        s9q3: false,
                                        s10q1: false,
                                        s10q2: false,
                                        s10q3: false,
                                        s10q4: false,
                                        s10q5: false,
                                        s10q6: false,
                                        s10q7: false,
                                        s10q8: false,
                                        s10q9: false,
                                        s10q10: false,
                                        s10q11: false,
                                        s10q12: false,
                                        s10q13: false,
                                        s10q14: false,
                                        s10q15: false,
                                        s10q16: false,
                                        s10q17: false,
                                        s10q18: false,
                                        s10q19: false,
                                        s10q20: false,
                                        s10q21: false,
                                        s10q22: false,
                                        s10q23: false,
                                        s10q24: false,
                                        s11q1: false,
                                        s11q2: false,
                                        s11q3: false,
                                        s11q4: false,
                                        s11q5: false,
                                        s11q6: false,
                                        s11q7: false,
                                        s11q8: false,
                                        s11q9: false,
                                        s11q10: false,
                                        s11q11: false,
                                        s11q12: false,
                                        s11q13: false,
                                        s12q1: false,
                                        s12q2: false,
                                        s12q3: false,
                                        s12q4: false,
                                        s12q5: false,
                                        s12q6: false,
                                        s12q7: false,
                                        s12q8: false,
                                        s12q9: false,
                                        s12q10: false,
                                        s13q1: false,
                                        s13q2: false,
                                        s13q3: false,
                                        s13q4: false,
                                        s13q5: false,
                                        s13q6: false,
                                        s13q7: false,
                                        s13q8: false,
                                        s13q9: false,
                                        s13q10: false,
                                        s14q1: false,
                                        s14q2: false,
                                        s14q3: false,
                                        s14q4: false,
                                        s14q5: false,
                                        s14q6: false,
                                        s14q7: false,
                                        s14q8: false,
                                        s14q9: false,
                                        s14q10: false,
                                        s14q11: false,
                                        s14q12: false,
                                        s14q13: false,
                                        s14q14: false,
                                        s15q1: false,
                                        s15q2: false,
                                        s15q3: false,
                                        s15q4: false,
                                        s15q5: false,
                                        s16q1: false,
                                        s16q2: false,
                                        s16q3: false,
                                        s16q4: false,
                                        s17q1: false,
                                        s17q2: false,
                                        s17q3: false,
                                        s17q4: false,
                                        s17q5: false,
                                        s17q6: false,
                                        s17q7: false,
                                        s17q8: false,
                                        s17q9: false,
                                        s17q10: false,
                                        s17q11: false,
                                        s18q1: false,
                                        s18q2: false,
                                        s18q3: false,
                                        s18q4: false,
                                        s18q5: false,
                                        s18q6: false,
                                        s19q1: false,
                                        s19q2: false,
                                        s19q3: false
                                };
                            }

                            //console.log('Force re-render..');
                            vm.forceRerender();
                            //     if (storeRequest.result !== undefined) {
                            //         vm.doorCheckDoor.site_door_check_id = vm.doorCheck.site_door_check_id;
                            //         vm.doorCheckFound = true;
                            //     }
                            //     vm.doorCheckLoading = false;
                        };
                        storeRequest.onerror = function(e) {
                            // vm.doorCheckFound = false;
                            // vm.doorCheckLoading = false;
                        }
                    } catch (e) {
                        console.log(e);
                    }
                })
            },
            getReportTypes() {
                if(this.dbName !== 'jpfire') {
                    return;
                }

                var vm = this;
                this.getDb(function onConnected(db) {
                    vm.reportTypes = [];
                    try {
                        var objectStore = db.transaction('fra_report_types').objectStore('fra_report_types');
                        if (objectStore) {
                            objectStore.openCursor().onsuccess = function (event) {
                                var cursor = event.target.result;

                                if (cursor) {
                                    if (vm.reportTypes) {
                                        vm.reportTypes.push({
                                            fra_report_type_id: cursor.value.fra_report_type_id,
                                            fra_report_type_name: cursor.value.fra_report_type_name,
                                        })
                                    }
                                    cursor.continue();
                                }
                            };
                        }
                    } catch (e) {
                        console.log(e);
                    }
                });
            },
            getQuestion(questionIdentifier) {
                const questionText = this.customQuestions[this.dbName] && this.customQuestions[this.dbName][questionIdentifier] ? this.customQuestions[this.dbName][questionIdentifier] : this.defaultQuestions[questionIdentifier];
                return questionIdentifier.toUpperCase().replace('Q', '.') + '. ' + questionText;
            },
            getPartTitle(partId) {
                var output = 'Part ' + partId + ': ';
                switch(partId) {
                    case 1:
                        output += this.dbName === 'jpfire' ? 'Overview of Premises and Business Enterprise' : 'Assessment';
                        break;
                    case 2:
                        output += 'Management of Fire Safety';
                        break;
                    case 3:
                        output += this.dbName === 'jpfire' ? 'Fire Hazards and Hazardous Substances' : 'Fire Hazards & Dangerous Substances';
                        break;
                    case 4:
                        output += 'General Fire Precautions';
                        break;
                }
                
                return output;
            },
            getSectionTitle(sectionId) {
                var output = 'Section ' + sectionId + '. ';
                switch(sectionId) {
                    case 1:
                        output += 'The Responsible Person / Duty Holder';
                        break;
                    case 2:
                        output += 'Persons at Risk';
                        break;
                    case 3:
                        output += this.dbName === 'jpfire' ? 'History of Fire Incidents and Authority Inspections' : 'History of Fire Occurrences';
                        break;
                    case 4:
                        output += this.dbName === 'jpfire' ? 'Description and Extent of Premises' : 'Description of Premises';
                        break;
                    case 5:
                        output += this.dbName === 'jpfire' ? 'External areas or other buildings which form part of the report' : 'External or other buildings which form part of the report (Sub Buildings)';
                        break;
                    case 6:
                        output += 'Fire Safety Policy and Emergency Plan';
                        break;
                    case 7:
                        output += 'Procedures and Practises for Serious and Imminent Danger';
                        break;
                    case 8:
                        output += this.dbName === 'jpfire' ? 'Fire Safety Information, Instruction and Training' : 'Information and Training of Employees';
                        break;
                    case 9:
                        output += 'Maintenance of Equipment and Record Keeping';
                        break;
                    case 10:
                        output += 'Fire Hazards';
                        break;
                    case 11:
                        output += 'Dangerous Materials, Substances, Dusts and Gases';
                        break;
                    case 12:
                        output += 'Firefighting equipment, which includes portable and fixed solutions';
                        break;
                    case 13:
                        output += 'Fire Detection and Warning Systems';
                        break;
                    case 14:
                        output += 'Emergency Routes and Exits';
                        break;
                    case 15:
                        output += 'Fire Signs and Notices';
                        break;
                    case 16:
                        output += this.dbName === 'jpfire' ? 'Emergency Lighting' : 'Emergency Lighting Provision and Requirements';
                        break;
                    case 17:
                        output += this.dbName === 'jpfire' ? 'Fire-resisting Doors' : 'Fire-resisting Doors and Door Sets';
                        break;
                    case 18:
                        output += 'Fire Separation, Fire Resistance, Containment and Fire Stopping';
                        break;
                    case 19:
                        output += 'Additional Fire Safety Provisions';
                        break;
                }
                
                return output;
            }
        }
    }

</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
